/* TypeTopia — Wrap studio (v3.64)
   v3.64 (2026-10-28, Ally of Christmas Jumper Club's name step: "maybe on this one it doesnt need a whos it for?"): a design
   that takes a name for each face (the idea engine v1.19) has no "who's it for?" box: the step is "their name" / "their
   names" and a box for every face (one face too), its head beside it. The first face's box starts as their name (what they
   typed on the gift wrap page's bar, or any wrap) and typing there is their name everywhere; a blank box is a plain jumper.
   Till one box has a name the button asks for one ("type their name"), as the name step does; a box whose name won't knit
   gets the name step's way out ("swap to plain letters", "make it shorter", "change the letters").
   v3.63 (2026-10-28, Ally of Christmas Jumper Club: "would need name for each face in options"): a design that takes a name
   for each face (the idea engine v1.18, takes.names) has, on its name step under their name, a box for each of its faces
   (two or more) with that face's head beside it (.js-fnames, made here: section unchanged, css v3.51); blank knits their
   name, which shows faint in the box. What they type is the design's pattern.names by the face's key (so it follows the
   face, kept a week with the rest); the engine's rules (the knitted letters' own: design.letters.rule shows under the
   boxes, and a box whose name can't be knitted says why, as the name's does). The line's new field: "Names" (IDEA_FIELDS).
   ?ttdev: ttWrapStudioDev.faceName(i, text) types face i's name (from 0).
   v3.62 (2026-10-28, Ally of Under the Mistletoe: "we need to choose couples so couple 1, couple 2, can add more couples,
   only 1 as default then you pick whos in it like the naughty & nice and you can position them from there"): a couples
   design (the section's couple_ideas) has a "couples" step after its photos: a card a couple, their faces as chips to put
   in or take out (two a couple), "add a couple" (up to three) and "remove"; kept in its pattern (couples). The faces it
   draws and orders are its couples' in turn (couplesFaces: two a couple, so the wrap takes the couples in turn), and the
   face fitter on step 1 positions each of them (fitFaces). The line's new field: "Couples" (and faces up to 6).
   v3.61 (2026-10-28):
     · (Ally: "the words and name can be the same step", "merry & bright & i think all") a design's own words sit under
       its name on the name step (a box titled "the words"); only a design with words and no name (Pudding Heads, Cracker
       Crowns' jokes) keeps the "words" step. Any engine's texts (the hat engine's v8 for Santa Rows and Santa on White,
       "Words" on their line too);
     · (Ally: "rudolph rows, move name to step 2", "name to step 2 on elf yourself") the figure designs keep their name
       step: step 1 is the photo and the fitter only (the name box never moves into the fitter now);
     · (Ally of Cracker Crowns' jokes: "when clicking the next joke here, could the close up shift to show that joke?") a
       list's box in use glides the close-up to the nearest slip carrying its words (textCloseUp: the idea engine's
       stickers say what each group of words is, v1.15), at the close-up's size; on the whole sheet it zooms in while
       typing and goes back when the boxes are left; a joke's box is as tall as its words, the rows spaced 12px.
   v3.60 (2026-10-28, Ally of Rudolph Rows' nose: "on the red nose, maybe no tilt option but positioning sliders?"): a
   design's fit piece may say tilt: false (no tilt slider, no turning knob, its turn kept at 0, pinches only size it) and
   slide: true ("left / right" and "up / down" sliders side by side, section v3.51: its move in hundredths of a head height, 30 either
   way, live as dragged, as the size slider; dragging it on the face still works). Other pieces are as they were.
   v3.59 (2026-10-28, Ally: "can all colour options be like this (not the colours the styling) - this is what we have on
   bunting so should be consistent ... black outline with a tick when selected"): every colour swatch carries its tick's
   colour (--tick, tickOn(): the bunting's rule, #333 or white, whichever reads more on it); the look is the CSS's (v3.48).
   v3.58 (2026-10-28):
     · their own words (Ally of Pinkmas: "not just editable name but the 'merry christmas' too"; of Pudding Heads, Red Nosed
       Reindeer, Elf Yourself and Merry & Bright: "change the words"; of Cracker Crowns: "read all the jokes, make your
       own"): the section's text_ideas get a "words" step (data-step "texts", after their name): a box for each of the
       design's texts (idea engine v1.13), filled with its words as they are, so every joke reads there; what they type is
       the design's pattern[text id] (kept a week with the rest), blank puts the design's own back, and the engine's rules
       show under the box as the name's do. The line's new fields: "Words", "Joke 1" to "Joke 4" (IDEA_FIELDS);
     · the fitter moves what the face wears (Ally: "position the pud", "position antlers, nose", "move hat", "position the
       crown (one pos for all colours)", "sleigh ride, you should be able to move the hat too"): a design's fit.pieces
       (idea engine v1.14), each moved on its own (the face's fit's p), the handles on it; with more than one (or the face
       as well) a row of pills over the faces picks which (.js-fparts); size, tilt and "reset" are the one being moved.
   v3.57 (2026-10-27, Ally: "christmas wraps on christmas page, red background product page (if possible)"): opened in place by a page
   that gives it its own colour (data-ws-colour, the Christmas page's red), every design shows on that colour (look()).
   v3.56 (2026-10-27, Ally: "when choosing a wrap on the christmas page, it takes you to the gift wrap page. Can we keep
   them on christmas?"): the Christmas page opens the studio in place as the gift wrap page does (its back and add come
   back there through tt:ws-home / tt:ws-added, as ever). On a wrap's own page loaded where a page had opened the studio
   in place (a reload of it, or back to it from elsewhere: its entry says ttwc "studio" and carries ttGrid / ttFrom,
   assets/tt-wrap-collection.js v3.25, copied onto the designs' own entries), "‹ back" from the first step and the add
   go back to that page where they were (backToOpener: the Navigation API's entry, else its address), not to the gift
   wrap page; a plain visit to a wrap's page goes to the gift wrap page as before (homeUrl). There, the browser treats
   the opener's entries as this page's own (Chrome: back to them is only a popstate here), so a popstate onto the
   opener's wraps entry (ttwc "grid") loads that page (location.reload at its address), which opens where they were.
   v3.55 (2026-10-27, Ally: "I think the problem on the text ones is text appears blurry", "Should all be sharp ideally"):
   the sheet, the face fitter and the hat editor draw at the screen's own density, up to 3 (density(); it was held at
   2, so a phone at 3 stretched every canvas half again), the sheet no bigger than 12 million pixels. With the idea
   engine's sharp redraw once a glide stops (v1.2) and the faces drawn from pictures as big as they're shown (The
   Classic v1.2, The All-Over v1.3), the close-up and the whole sheet are drawn at the size they're shown. The close-up's
   size and place are TTWrapView v1.2's (assets/tt-wrap-view.js: the head 28% of the sheet, words that read, the
   edges in the gaps); nothing else here changes for it.
   v3.54 (2026-10-26, Ally of v3.52's grid, option C of three: "Build C, the two lists. Make "both" mean half nice, half
   naughty for every face"): the choice per face is Santa's two lists under the faces (.js-pfrow, section v3.48, css
   v3.46): a "nice list" and a "naughty list" side by side on the wrap's own lined paper with its handwritten heading
   (the design's perFace.lists and look: Naughty or Nice v1.4), each face a chip in each. A tap ticks a face onto a list
   (the wrap's pen tick) or takes it off; on both lists is "both"; a face taken off its only list goes on the other.
   Faces off a list are faded. Five faces fit a phone (the chips shrink, two rows). No icons, halos or horns any more.
   The line is unchanged ("Face 1": "Nice" / "Naughty" / "Both").
   v3.53 (2026-10-26, Ally: "cut the Cloudinary uploads down: upload at add to basket (or the size step), skip pictures
   already uploaded, and use smaller formats where there's no see-through part"): a design is no longer saved a second
   after every change (each face, nudge, colour or letter uploaded a whole set: Cracker Crowns about 4MB a time). It's
   saved once the size step is reached (atSize: also when it opens on it, or becomes complete there), and on add if it's
   changed since: the button stays "add to basket", and a tap on an unsaved design says "saving…" (p.pending) till the
   pictures are up, then adds; a failed save offers "try saving again" as before. The kit (v1.6) never sends a picture
   it has sent this week, and sends the previews and the swatch as WebP (JPEG on Safari) and the idea wraps' under tile
   (and any figure) as JPEG when nothing in them is see-through (the kit's lossyFor); faces in hats and the over tile
   stay PNG.
   v3.52 (2026-10-26, Ally of v3.47's naughty or nice row: "ui / ux not the best. I want the most clear, easy to use, fun
   ui ux"): every choice on show, none hidden behind a tap: Santa's list as a little grid under the faces (.js-pfrow,
   section v3.47, css v3.45), their faces along the top wearing their verdict (a halo, horns, or both, popping on), nice /
   naughty / both down the side with drawn icons, a pill where each face meets each choice. The line is v3.47's.
   v3.51 (2026-10-26, Ally: "think we need to remove the quick left to right switcher for wraps, make the back button
   clearer & in better place (maybe steps instead? maximise ease of use so do whatever is most intuitive), after adding
   to basket take them back to the wraps page"):
     · no switching design in the studio: the ‹ › arrows, the dots, the sideways swipe on the paper and the papers drawn
       ahead either side for it are gone (another wrap is picked on the gift wrap page). api.open and the address
       following the design stay, for the page that opens it;
     · "‹ back" top left (section v3.45: a white pill in the name row): a step back; from the first step back to the
       wraps (home(): the gift wrap page's own way back to its grid when it opened the studio, tt:ws-home, else its
       address, homeUrl). The small "back" beside each step's heading is gone;
     · the step bar under the name (.js-trail, syncTrail): a numbered dot and a word for each step (C.trail), the one
       on show marked; a tap on one before it goes back to it, and one after it goes there once everything before it
       is answered (the dot of an answered step before it is a tick);
     · after an add, back to the wraps: once their roll is packed and has flown to the basket, the gift wrap page that
       opened the studio takes them back to its grid, where they were, and shows the basket popup there (tt:ws-added);
       on a wrap's own page they go to the gift wrap page, which shows the popup as it arrives (sessionStorage
       ttWsAdded). "another one?" (the moment's cards, their size row and their adds) is gone. In the theme editor
       the popup shows in place.
   v3.50 (2026-10-26, Ally: "the close ups should be the same as how theyre displayed on the gift wrap page. If text is on
   it should be legible while still being able to see the pattern"): the close-up shows exactly the piece of the roll the
   design's card on the gift wrap page shows on this screen, the same cm across the sheet as the card's across its paper
   and from the same place (assets/tt-wrap-view.js, the rule both read: TTWrapView.frame on TTWrapView.cardPaper(), the
   card's paper here, on product pages too): 24cm, The Party Hat 19, The Santa Hat 21, The Cheerful 11 on a name, Our
   Favourite 14 to 22 on a phrase; a design with words as close as its card comes for them (its smallest letters 9px tall
   on a phone's card, 11px on a computer's, never closer than one and a half of its repeats). The bigger sheet just makes
   the words bigger. It used to be a face a fifth of the sheet's height, a name block CLOSE_FILL of it, a phrase
   PHRASE_FILL of it, three shirts across.
   v3.49 (2026-10-26, Ally: "wraps like snowman & gingerbread, they need to position their face in the first panel & name
   should be there too"): the idea wraps whose face goes in a figure or a body (the section's fit_ideas: Snowman Me,
   Gingerbread Gang, Christmas Jumper Club, Sleigh Ride, Up the Chimney, Stocking Stuffers, Snow Globes, Bauble Faces;
   kind.fit) have a face fitter under the upload on "who's it for?" (.js-fsoon): their face in its figure, drawn by the
   design (idea engine v1.7's fitInfo, then its sharp drawing of that part), with "fit the hat"'s handling (drag, two
   fingers, a corner, the knob, "reset"; on a phone a tap opens it full screen, .js-ffit, with size and tilt). Every face
   keeps its own fit (P().fits by face key; the engine bakes it into the face's figures, so the paper, the line's pictures
   and the print have it), kept a week with the design's other choices (TTKeep). With two or more faces on the wrap their
   heads say which is being fitted (.js-fwho). The ones that take a name have the name box there too (the name step's
   own, moved in: placeName), so no name step; the button asks for the name once the faces are in.
   v3.48 (2026-10-26, Ally: "the classic & all over face size they have a tool while party hat has advanced, can they have
   advanced too and anything else that has this"): The Classic and The All-Over take their face size from the size step's
   "face size", as the hats do (their slider and range under the photos are gone): smaller, normal (the engine's default),
   bigger, each saying how big (FSIZE_PAT). The choice is the pattern's own sizes, so the line still says "Head size" /
   "Size range" and it's kept with the pattern; a size kept from before that isn't one of the three becomes the nearest.
   The other designs have no face size of their own (Santa Rows', Santa on White's and the idea wraps' are the design's).
   v3.47 (2026-10-26, Ally of Naughty or Nice: "they need to be able to pick naughty, nice or both (mixed) for each face"):
   an idea wrap whose design has a choice per face (its perFace: idea engine v1.5) shows it in "who's it for?" under the
   faces (.js-pfrow, section v3.42): each face in the mix with its choice under it, a tap moving it on (both, nice,
   naughty); kept in the design's pattern by the face's key, on the line as "Face 1" ... (in IDEA_FIELDS, so the basket
   takes it).
   v3.46 (2026-10-26, Ally: "the colour background picker, have it on the first panel", "and enable custom colour"): the
   pattern wraps' colour row is in "who's it for?" under their faces (.js-icol, section v3.41), with a "+" that opens the
   custom colour card (colourCard(), as the football shirt's) for their own ("#rrggbb", the idea engine's custom option:
   on the line as "Custom #rrggbb"); the colour step is gone.
   v3.45 (2026-10-26, Ally: "when swapping faces, they animate on really slowly, can we make them come in faster &
   animate in about 0.5s and not from top down left to right so it feels sharp. Animate each head in on its own"): a
   ripple hands the engines each face's own start (anim.delay(n): scattered by the golden ratio over POP_SPREAD, so
   neighbours never go together), its pop (anim.pop, POP_IN) and the whole (anim.span): about half a second however
   many faces are on show, where each used to wait its turn in reading order (45ms apiece: over two seconds on a whole
   sheet). Our Favourite's smileys keep their stagger.
   v3.44 (2026-10-26, Ally: "when changing photo & going into a wrap, it goes back to the first image uploaded"): a new
   photo (or a saved face) is the one face again on every design, the mixes too (the idea wraps, The Classic, The
   All-Over), as on the hats since v3.12; it used to join the mix behind the first photo, which stayed first. A face
   chosen on the gift wrap page since the studio last showed does the same (seenFaceKey). A tap on a face in the row
   still adds it to a mix.
   v3.43 (2026-10-26, Ally of the close-up: "blurry text"): the engines are told when the view is gliding (gliding), so the
   idea wraps draw their close-up sharp once it's still (idea engine v1.2).
   v3.42 (2026-10-26, Ally, of The Santa Hat: "close up should show more of the pattern"): the hat wraps' close-up (The
   Party Hat, The Santa Hat, Santa Rows, Santa on White) makes a face about a fifth of the paper's height, as the other
   face designs do (closeZ; it was two fifths: one and a half faces across).
   v3.41 (2026-10-26, Ally: "give the customer sizing options (maybe in an advanced options) Normal face size including
   accessories should be 87mm"): The Party Hat and The Santa Hat take a face size (the size step's "face size": smaller 74mm,
   normal, bigger 104mm; FSIZE_ON), kept as the design's own (p.fsize, 0 for normal) and handed to the hat engine (v7.4) as
   state.size, which writes it on the line as "Face size" (normal writes nothing: the worker's 87mm).
   v3.40 (2026-10-26, Ally: "build them all" (the Christmas wrap ideas and the four pattern wraps); and of Santa Rows: "when
   typing name, switch to close up view"):
     · the idea wraps: engine "idea" (assets/tt-wrap-engine-idea.js), one design a block (its Idea: the design's id) and
       its kind from what the block says it takes (idea_uses: photo, colour, name): their faces (up to five, a mix as
       The Classic's), "pick a colour" (the design's colours, a swatch each: the four pattern wraps) and their name (the
       name step every named design shares), in that order; the line's fields are the idea engine's;
     · typing their name switches the paper to close up (every design with the switch: Santa Rows, Santa on White, The
       Cheerful, the named idea wraps), as tapping "close up" does: their choice from then on.
   v3.39 (2026-10-26, Ally):
     · no date box ("as we're removing the date picker"): delivery is picked at checkout (Royal Mail Tracked 24, or
       Guaranteed by 1pm, ordering by 3pm). The steps end on the size (ORDER_STEPS), where the button adds; a line no
       longer carries "When do you need it for?", nor does an add from "another one?"; nothing about a date is kept.
     · the football shirt's kit is in "who's it for?" with the name and number ("colour options should be with name and
       number"): one step, KINDS.shirt.steps ["shirt"] (the section holds the kit's controls in it).
     · on a phone the kit opens full screen from a "their kit" button under the name and number (Ally: "better layout
       on mobile, easier. If it needs a pop up instead, do that with no wrap preview just one shirt"): one shirt, big,
       the kit's controls under it (moved in while it's open), "done" to go back; the button wears their shirt.
     · which faces are on a hat wrap is their heads ("would be better if it had the heads here & you can select which
       ones you want"): each face's own cut-out, faded till it's on, the ink tick when it is, as the tray's faces;
       several at once, never none, five at most, as before. The label says "faces".
   v3.38 (2026-10-26, Ally: "santa rows & santa on white, brilliant"; "build them all"): Santa on White (engine
   "santawhite", the hat engine v7.2's fourth kind, its words in TTPlaceCards as Santa Rows'): everything Santa Rows has
   (their faces in the slouchy hat, then their name; the same line, with layout santa-white-1), on white.
   v3.37 (2026-10-26, Ally: "yea emojis on shirt"): the football shirt's name box loads the emoji typed in it too, and
   its line waits for them before it calls one a letter we haven't got (the shirt engine, assets/tt-shirt-data.js v1.4,
   draws them).
   v3.36 (2026-10-25, Ally: "if emojis are typed, we need them to show"; "go with fluent"): an emoji typed in the
   words (Our Favourite's phrase; the names) is loaded as it's typed (TTEmoji.need, assets/tt-emoji.js, which the section
   loads), then the paper's drawn again and the design saved again; till it's in, the box's line doesn't call it a letter
   we haven't got. Words with emoji kept from before, or handed over, are loaded as the studio opens.
   v3.35 (2026-10-25, Ally: "on santa rows, no need to zoom in when typing name & date picker, i think we should remove for everything"; "the hat editor, you can already edit that in the first step then it makes you edit again. Also, this ui is glitched"):
   typing never zooms the paper (no close-up on the box's focus or on each keystroke; on a phone the box is still kept
   above the keyboard, the page put back after); The Santa Hat and Santa Rows have no "your hat" step (the first step's
   editor already places the hat, and The Santa Hat's paper colours are there too); "another one?" with more than six
   other designs (Santa Rows made seven) scrolls its two rows sideways on a computer (.is-many) instead of squeezing the
   seventh under the button; a design whose name ends in s "is in your basket" (Santa Rows's read badly).
   v3.34 (2026-10-25, Ally: "if youve made wrap then go to somewhere else, when you come back to wrap, you're back to the start"; her picks: a week on that device, back where they left off): their work is
   kept (assets/tt-keep.js, "wrap", loaded before this): TTWrapShared starts with their name, age and size and gets their
   faces once the pictures load (a tile each, as a handed-over face); each design's own choices (its hats and where the
   hat sits, its words, its kit or pattern, its colour, its size) come back as they were; on a product page the design
   opens on the step they were on (a step past the faces falls back once it's clear their faces didn't come back), with
   the date they'd picked if it's still one that can be had. All of it is kept again as the page is left.
   v3.33 (2026-10-25, Ally, 2026-10-25: "santa rows & santa on white, brilliant", "carry on with santa rows"): Santa Rows (engine "santarows", the hat engine v7's third kind,
   data TTPlaceCards for its words): KINDS.santarows (faces, "your hat", their name; the line's fields), a hat-like design
   (the hat editor in "your hat", where its paper colour is hidden: data-engine santarows), and The Cheerful's name step
   (NAMED: the engines whose name is typed there; the engine's read() says what can't be printed).
   v3.32 (2026-10-24, Ally: "yes add the outline"): the football shirt's outline is automatic (assets/tt-shirt-data.js
   v1.3: one only where the lettering wouldn't read on the pattern); the outline's automatic place wears the outline it
   would draw ("auto · navy"), struck through while there's none ("auto · none").
   v3.31 (2026-10-24, Ally: "colour picker should always be consistent wherever it is - like the bunting one"): the
   football shirt's "+" opens the custom colour card (assets/tt-colour-card.js|css, loaded the first time: C.colourCard),
   the bunting's own card, with club colours that aren't among the 14 as its quick picks; never the browser's picker.
   v3.30 (2026-10-24, Ally: "remove it on the pages, should only be in account & they should have just outline, not white
   box"): saved faces in the tray are the face with a white outline and no x (the account page takes them off the list).
   v3.29 (2026-10-24, Ally: the football shirts "a bit smaller", "about 6-7 across", and tilted): the shirt engine's
   cells are read for its close-up (three shirts across); the tilt and size are the shirt engine's (tt-shirt-data.js).
   And (Ally: "outline text options") a sixth part, "outline": the name and number's outline, "none" in the palette's
   last place (the order line's "Outline"). And (Ally: "any way we can do custom colour instead of swatch?") a "+" in the
   palette, after the 14: the phone's own colour picker (.js-kitcolor, as the bunting page's), any colour for the part;
   once they've one, the "+" wears it.
   v3.28 (2026-10-24, Ally, of the football shirt's colour rows: "its a bit mental"): one palette. The kit step is the
   pattern (.js-kitpats), which part to colour (.js-kitparts: shirt, the pattern's own name for the second colour, sleeves,
   collar, name; P().kitPart) and the 14 colours in two rows (.js-kitpal), the last place the part's automatic colour
   ("as the shirt" for the sleeves, "auto" for the collar and the name; none for the shirt and second colour). The
   "sleeves & trim" side trip is gone.
   v3.27 (2026-10-24, Ally: "the our favourite, can the close up be a bit more zoomed out?"): Our Favourite's close-up
   shows a phrase at PHRASE_FILL of the sheet's width (0.4; it was CLOSE_FILL's 0.55), so more of the pattern is round it.
   v3.26 (2026-10-24, Ally: the football shirt wrap on the new system): a new design, engine "shirt"
   (assets/tt-wrap-engine-shirt.js, data assets/tt-shirt-data.js: the print worker's own shirt engine). Its steps:
   "who's it for?" (their name, the same name every design and the gift wrap page share, and their number: the age
   until they type one; .js-sname, .js-snum), then "their kit" (shirt colour, pattern, second colour and lettering,
   .js-kit buttons) with "sleeves & trim" a side trip (the "details" aside: sleeves, collar and cuffs). The kit is the
   design's own "pattern" (P().pattern: number, body, second, style, sleeves, trim, ink; the engine's defaults and
   clean), so it's drawn at once and saved a second later like The Classic's. Opens close up, a couple of shirts across.
   v3.25 (2026-10-20, Ally: "square (61cm x 61cm), then a metre"): the Square's pill says "square"; its length,
   61cm, is read by the kit (tt-wrap-kit.js v1.5), so the details say 61 x 61cm.
   v3.24 (2026-10-08, Ally): the earliest date is the working day after dispatch (Friday after
   1pm or the weekend: Tuesday); that date says to pick Guaranteed by 1pm.
   v3.23 (2026-10-08, Ally: next-day delivery "only if they order before 13:00", Mon–Fri):
   the date box's earliest day is tomorrow only on a weekday before 13:00 UK time, when
   tomorrow is Monday to Friday; otherwise the day after (ukEarliest, worked out again each
   time the box is judged, so a page left open past 1pm stops offering tomorrow). Picking
   tomorrow says under the box which delivery to choose at checkout (copy.nextDay); the
   checkout's rates (workers/typetopia-rates) follow the same rule.
   v3.22 (2026-10-08, Ally: "on hats, option to choose multiple?"; tap to tick, every face in
   every hat, one fit for all): The Party Hat's hat rows tick and untick (P().hats, in the order
   ticked; P().hat is the first, the one the hat editor shows; one always stays ticked). Every
   face goes in every hat ticked (hat engine v6's slots), at most five pictures on a wrap: a
   tick that would make more says so ("5 pictures is the most on one wrap") and shakes the
   hat. The one placement fits every hat. (v3.20 and v3.21 were CSS only: the view switch.)
   v3.19 (2026-10-08, Ally: "party hat wrap on mobile still very hard to reposition and
   size"; chose the full-screen fitter): on a phone (tabsMode) a touch on a small hat editor
   ("who's it for?", "how old?", "your hat") no longer edits there: it opens "fit the hat"
   (.js-hfit, moved to the end of <body>, over the header): the third editor in EDS, as big
   as the screen allows, with drag, pinch, corners and the knob as before, size and tilt
   under it (.js-hrange, kept in step like the others) and "done" (or Escape, or back).
   It fades and rises in (0.3s, house curve), out in 0.2s; the page under it doesn't
   scroll or move (overflow hidden on html while open, no scroll change). Focus goes to
   "done" and back to the editor that opened it. On a computer nothing changes.
   v3.18 (2026-10-08, Ally: "I dont like how the close ups go full width, should be same as
   whole sheet but bigger pattern"): close up no longer zooms the paper: the sheet stays where
   the whole sheet has it (its shape, edges and shadow, placeSheet at rest) and the design is
   drawn bigger inside it (clipped to the sheet at rest; restZoom centres on the sheet and
   keeps it covered; closeZ measures against the sheet, not the paper area). The typing
   close-up is clipped the same way. The header's logo reads the sheet at rest.
   v3.17 (2026-10-08, Ally: "mobile close up is like this, not great"): on a phone The
   Cheerful's and Our Favourite's close-up is wider (CLOSE_FILL_PHONE): the name with its
   pattern round it, not one name in white.
   v3.16 (2026-10-08, Ally: "On mobile the face wraps are too zoomed out, can they be more
   of a close up by default and option to see full wrap ... They have extra steps,
   duplicate - no need for that"):
     · on a phone (the one-step-at-a-time layout, tabsMode) every face design opens close
       up: The Party Hat and The Santa Hat on a face in its hat, The Classic and The
       All-Over on a few faces (one about a fifth of the paper's height). The paper's
       "close up · whole sheet" switch shows the full wrap, as before, and their choice
       holds for every design. On a computer the hats still open on the whole sheet, and
       The Classic and The All-Over now have the switch too (opening whole);
     · The Classic and The All-Over: no "your pattern" step. "who's it for?" already
       holds the same controls under the photos, so the next step is the size. (The
       step's markup stays, unused, so nothing else changes.)
   assets/tt-wrap-studio.js, the page for sections/tt-wrap-studio.liquid.

   v3.14 (2026-10-08, Ally: "accounts that save photos"): saved faces from
   the customer's account (window.TTMyPersonalisation, assets/
   tt-my-personalisation.js; signed in only, nothing kept in the browser):
     · the saved faces sit in the tray straight after the camera (.js-sv,
       drawn by the section for the first paint; renderSaved() keeps them in
       step with the account: a refresh, a remove, a face saved on the gift
       wrap page). A face already in this visit's faces isn't shown twice.
     · a tap loads its saved cut-out (CORS, so it can be baked) and adds it
       as a face { img, src, c, o } exactly as a new photo's, no upload and
       no cutout: c is the saved cut-out, o the saved photo, so the order
       carries them as it would a new photo's ("_Face cutout", "_Original
       photo", "_Hat cutout", ...). Its tile becomes that face's tile where it
       stands (addTile), so nothing moves; it joins a mix and a hat's faces
       as any new face does.
     · the x on a saved face takes it off their list (the image stays); the
       tile goes at once and comes back if the account couldn't be reached.
     · "save to my personalisation" (.js-keep, ticked by default): while it's
       ticked, each new face from a photo (every face of a group) is saved
       to the account, fire and forget (keepFaces). The tick is shared with
       the gift wrap page through TTWrapShared.keep (memory only).
     · signed out: "create an account to save your faces" (.js-signup) goes
       to sign-in and back to this page (TTMyPersonalisation.signInUrl()).

   v3.13 (2026-10-08, Ally):
     · a readable preview for the name designs ("option 1"): on a phone The
       Cheerful's and Our Favourite's whole 61cm sheet left their name about
       2mm tall. They now open CLOSE UP: the name nearest the paper's middle
       at about print size with the pattern round it, filling the paper
       (restZoom: Our Favourite's phrase, ISLA'S OUR FAVOURITE, about 55% of
       the paper's width; The Cheerful a 3cm name block at 55%, so a short
       name like ISLA is big and readable with the toys round it; the view
       never shows past the sheet's edge). The pill on the paper's foot,
       "close up · whole sheet" (.js-view; syncView, setView), glides
       between them on the house curve, cubic-bezier(.2, .8, .3, 1)
       (house()), 0.52s, drawn crisp at every scale by the engines: their
       bitmaps only near the whole sheet (z <= 2.5), closer just what's on
       screen as vectors, every frame; the bitmaps a glide starts from are
       made ahead when the page is idle (warmSoon). The view at rest is
       S.zoom.to = REST, resolved each frame (resolve), so it follows the
       paper's size and an engine arriving; the focus is found once per
       paper size (P().restF), so typing never nudges it. Their choice
       (S.view) holds for every design with the pill (VIEWS: the name
       designs open close up, the hats on the whole sheet, the patterns have
       no pill). Typing their name stays close up (or zooms in from the
       whole sheet, as before) and goes back to their view after. The
       papers drawn either side for a swipe are drawn in the view they'll
       open in. Adding to the basket rolls the whole sheet into the tube
       (drawn once for it to copy; the pill steps aside while it's packed).
       zoomedIn() now means only the typing close-up (a swipe still works
       close up). ?ttdev: ttWrapStudioDev.view(v), state().view;
     · the hat editor on phones (Ally's iPhone screenshot: a 90px editor
       under five handles): about 200px square (the CSS: a compact upload
       row for the hat designs), the hat-face filling it (edPad: 36px over
       it for the knob, 10px round it), one corner handle (bottom right)
       and the knob, apart; one finger anywhere moves the hat, two anywhere
       size and turn it, the page never scrolls under it; the sliders stay.
       "use: face 1 · face 2" sits under the sliders now (the section).
   The order fields, the bake into "_Hat face" and the engines are unchanged.

   v3.12 (2026-10-07, Ally: "a detection of multiple after the cutout & a
   choice to use all or drop"; The Party Hat and The Santa Hat: "give a
   choice to use multiple"):
     · a group photo: the photo still goes to the cutout worker once, as
       before. When the cut-out that comes back holds two or more people,
       K.split (wrap kit v1.3, assets/tt-face-find.js) makes each their own
       face (uploaded as its own PNG, never cut out again) and addGroup()
       puts them all in the tray, each ticked (aria-pressed) in every design
       that takes several: The Classic and The All-Over's mix (up to five,
       as before), and The Party Hat's and The Santa Hat's. The message says
       "found 3 faces · tap one to leave it out" (and when there were more
       than five, that five is the most). One person: exactly as before.
     · The Party Hat and The Santa Hat take up to five faces (KINDS.multi),
       each in the hat, alternating across the pattern (hat engine v5). One
       face stays the default: a new photo, or a tap on a face in the tray,
       is the one face again. With two or more faces this visit, "use: face
       1 · face 2 · ..." (.js-use, under the hat editor in "how old?" / "your
       hat") picks which are on the wrap (never none; five at most); the
       hat's placement stays on face 1's head (rebased when face 1 changes).
       Their line adds "_Hat face 2" ... "_Hat face 5" and "_Hat cutout 2"
       ... "_Hat cutout 5" (KINDS' fields; the print worker alternates them).
     · a group the gift wrap page found (TTWrapShared.group) is ticked the
       same way when the studio is shown (sync).
     · the hat box sets --bw / --bh with its size, and its handles follow by
       transform (the CSS), so moving or sizing the hat shifts no layout.

   v3.11 (2026-10-07, Ally on an iPhone):
     · the date: its box (.js-datebox) is .is-empty while there's no date, so
       the CSS shows the hint "pick a date" (iOS shows a blank box for an
       empty date input) and hides the browser's own dd/mm/yyyy; set on every
       change and on pageshow (a value the browser put back). On a computer a
       click anywhere in the box opens the calendar (showPicker; the native
       indicator is hidden); a phone's tap on the input opens its own. The
       min, the checks and "When do you need it for?" are unchanged;
     · "another one?" (Ally: "you can't choose length"): a size row under the
       line (buildMSizes: every size the other designs sell, shortest first,
       each with its lowest price from the variants' "cents"), on the size
       just added (S.mSize; it goes when the moment does). Every card's "add"
       uses it (pickFor): its own variant in that size, The Santa Hat's in its
       colour in use; a design without it takes its nearest length, its price
       line says so ("no 5m: 2m · £x") and so does the message after adding
       (its "A size it doesn't sell" words). Each card's price line is now
       its price in the chosen size ("5m · £x"). The date is the same as
       before. The row is one fixed height, so nothing outside the cards moves.

   v3.10 (2026-10-07): The Cheerful's line may also carry "_Preview"
   (KINDS.cheerful.fields; engine v1.2), a small picture of their design
   for the basket page and the basket popup, as the other studio wraps
   do. The print worker never reads it.

   v3.9 (2026-10-07, Ally, The Party Hat and The Santa Hat: "when you click to
   move hat, it takes you to the hat mover, can it just move it there?", and
   "sliders"):
     · the hat editor works wherever it's shown: there are two (EDS, one per
       .js-hated: "how old?" / "your hat"'s, and the one under the upload on
       "who's it for?", in place of the picture that went to the next step,
       .js-hpeek, gone). Each draws while its step is on show (edOn, edDraw)
       and keeps its own view; drag, pinch, the corners, the knob and "reset"
       work in both, and nothing in either changes step. Both show and change
       the one placement (P().place), so they stay in step. Under the upload
       it's live from the start: before a photo the hat moves on the sample
       face, and where it's put carries over to their face (the placement is
       relative to the face). Only the hats row or the paper colours beside it
       wait greyed (.js-hside inert) till a face is in. A short editor keeps
       less room round the hat-face for the handles (edPad);
     · size and tilt sliders beside the editor in "how old?" / "your hat"
       (.js-hrange, .js-hval; the row .js-hedrow is what placeEditor moves):
       size is the hat's width as a % of the face's (8% to 220%, the engine's
       limits), tilt in degrees (-45° to 45°, as your pattern's tilt: a turn
       either way on a phone-width slider was too coarse to set; turned
       further with the knob, the slider rests at its end and its value says
       the angle), each move through clampPlace as a drag is. They show the placement however it was last
       changed (syncHatSliders, with every draw), "reset" included.
   The bake into "_Hat face", the order fields and the engines are unchanged.

   v3.8: no change here (the shipping tube, assets/tt-wrap-tube.js v3).


   v3.7 (2026-10-07, Ally: "make santa hat live using this hat"): The Santa Hat
   (KINDS.santa, engine "santa": the hat engine's second kind, assets/
   tt-wrap-engine-hat.js v3). Its steps: "who's it for?" (their photo; under
   it, greyed till a face is in, their face in the Santa hat and the paper
   colours) → "your hat" (data-step "hat": the same hat editor as "how old?",
   moved into whichever step the open design uses (placeEditor), and the
   paper colour) → size → date and add. No age. The paper colour is the
   product's Colour option (colourOption, colourValues): the colour in use is
   P().colour (the first, or the one a ?variant= link names), its swatch and
   print colour the block's "Paper colours" (d.papers, paperHex), drawn under
   the pattern by the engine (state.bg) and sent as "_Background"; the size
   buttons are that colour's variants (one per size), so the variant follows
   the size and the colour (setColour keeps the size). Its line is the
   engine's santa-hat-1 (KINDS.santa.fields). It joins the swipe, the dots and
   the all-wraps moment (its card drawn as The Party Hat's, in the colour in
   use; it needs only a photo). On a computer, five or six other designs in
   the moment go three across (.is-3).

   v3.6 (2026-10-07, Ally: "Tube is 2d can we do 3D?" and, after an add, "All
   wraps, already made"):
     · the shipping tube is 3D (assets/tt-wrap-tube.js v2: CSS 3D, no
       library), its sticker the "Type Topia Prints" lettering (assets/
       tt-wrap-tube-sticker.webp, C.tubeSticker, decoded ahead by
       TTWrapTube.prepare once the tube's script is in); startTube takes a
       card as well as the paper;
     · after an add, "another one?" shows every other design as a small live
       card (showMoment, buildOthers, drawOther, syncOthers), in place of
       v3.2's single next design sliding in: their face, name and age drawn
       by each design's engine in the gift wrap page's regions (cardRegion;
       the sample face till theirs is in), its name, "from £x" and a quiet
       button: "add" (that design's own save, variant in their size, fields
       and the date: addOther, cartPost; the tube rolls up from the card), or
       what it still needs ("add their age": opens it on that step,
       cardNeed/openOther), or "✓ in your basket". Tapping a card opens it
       with the swipe's slide on its first step (S.landOn). The cards are
       built once, in the hidden step, and drawn only near the screen while
       the moment is on. The ink button says "no thanks, checkout" (the
       basket); "back" goes to the design's own steps. The basket popup stays
       away during the moment, as before. save(d), orderable(d) and
       designReady(d) work for any design now. Gone: offerAfter, offer,
       offerNext, saveOffer, hasAll, wordsReady, S.offering;
     · ?ttdev: ttWrapStudioDev.moment() (the moment, nothing added) and
       others() (each card's button, drawn, near, need, variant).

   v3.5 (2026-10-07, from Ally's screenshots, and Ally's add-to-basket design):
     · The Cheerful's line carries "_Wrap layout" = "cheerful-1" too
       (KINDS.cheerful.fields; the engine's bake, engine v1.1), for the print
       worker's routing. Name is unchanged;
     · "who's it for?": the upload area (.js-drop: the camera, "add their
       photo", the quiet line) is a drop zone of its own, lit while a photo is
       dragged over it (is-over); faces join it after the camera. Under it
       (.js-soon) the open design's next tools, greyed out and inert until it
       has a face (syncSoon, from syncTiles), then live: the pattern controls
       are a second copy of "your pattern"'s (every .js-range / .js-lay /
       .js-bg / .js-val / .js-shuffle is kept in step, as before), The Party
       Hat's are the hat row (hatRows(): built, ticked and drawn on their face
       in both rows) and their face in the hat (.js-hpeek, the engine's ghost
       face till theirs is in; a tap goes to "how old?");
     · add to basket: the shipping tube (assets/tt-wrap-tube.js, loaded when
       the page is idle): their wrap rolls up, into a kraft tube with the TP
       sticker, white caps, tan tape, and it flies to the basket; then the
       basket popup (TTCartToast.show, after the flight; every add is ttQuiet
       now, so the popup also shows with "another one?", whose next design
       slides in as the tube leaves). The paper hides only by opacity while
       its copy rolls (startTube / unpack / slideClear), so nothing moves.
       Reduced motion, a swipe or close-up under way, or a hidden tab: no
       tube, just the popup. A failed add puts the paper back at once.

   v3.4 (2026-10-07, Ally: "the hat's too small ... and hat options";
   "resize and reposition the hat, like on face confetti"; "above the tweak
   options, one face with a hat & they can reposition without the extra
   click"):
     · The Party Hat's "how old?" step: their face in the hat at the top, a
       live editor always there (.js-hated): drag to move, two fingers to
       size (and turn after a 5° twist), a corner handle to size, the knob
       to turn, "reset" back to the default; the limits are the engine's
       clampPlace (the face confetti's: 8% to 220% of the face's width,
       and the hat-face still fits its cell). It shows the whole hat-face,
       zooming out while it's held only when it must, gliding to fit once
       let go. Touch on it never scrolls the page. Under it, the age box
       and the five hats (the Orange Stripy Hat is new), each drawn on
       their face with their age and placement (hatThumbs). The "pick a
       hat" side trip and "change the hat" are gone (KINDS.hat.aside);
     · the placement is the design's own (P().place, kept when switching
       designs; one for every hat), goes into st() as state.place, and is
       baked into "_Hat face" by the engine; the paper follows it live;
     · ?ttdev: ttWrapStudioDev.state() says place and hatBox.

   v3.3 (2026-10-07):
     · The Cheerful (engine "cheerful", assets/tt-wrap-engine-cheerful.js with
       the data assets/tt-cheerful-data.js and the tile pictures
       tt-cheerful-tile-400/-1200.webp, all loaded only when it's shown: the
       print worker's "cheerful" recipe, proven by workers/tpprintfiles/test/
       cheerful-parity.test.mjs). Its steps: "who's it for?" (their name,
       data-step "name", .js-cname) → size → date + add. The name is
       TTWrapShared.name, the one Our Favourite and the gift wrap page use
       (Our Favourite's phrase follows it while it's still the one made from
       it). What can't be printed says the worker's rules under the box
       (.js-cmsg), calmly, and the button offers the way out ("swap to plain
       letters", "make it shorter", "change the letters"). Its line carries
       only "Name" (KINDS.cheerful.fields) and the date. It joins the swipe
       order and "another one?" like any design. The close-up while typing
       goes to the name nearest the middle, as the words' does;
     · Ally: "there's a shift in the UI when you change wraps": nothing moves
       on a switch but the paper's content. Every design has the same step
       area (the CSS's one --q-h, your pattern's), so the paper, the name row,
       the heading and the button never move; the steps' height glide and the
       hold during "another one?" (holdSteps) are gone, and the slide no
       longer sets the design's engine early. Focus rings only from the
       keyboard (the CSS).
   ?ttdev: ttWrapStudioDev.name(text) and tab(step); state() says name and nameOk.

   v3.2 (2026-10-07, Ally: the paper shape, and "selling more than one
   roll", Claude's ideas 1 + 2):
     · the paper is a plain sheet, no photo (the kit's sheet() is gone): the
       canvas draws its white face and the print in the same rectangle as
       before (BOX: the old photo's sheet, so what's on show and the header
       logo's answer, cv.ttColourAt, are unchanged), and one .tt-paper
       (assets/tt-paper.css: a crisp edge, a soft pink drop shadow, a faint
       sheen) sits over it, placed on that rectangle every frame so it
       follows the close-up (placeSheet). Its white face stands in until
       the first drawing (.is-blank);
     · swipe between designs: on the paper, a clearly sideways swipe
       (touch or pen; the page still scrolls over it: touch-action pan-y)
       slides it away and the design beside it in; ‹ › beside the name do
       the same (buttons; ← and → on them too), and a dot per design under
       the name says which one this is. The papers either side are drawn
       ahead when the page is idle (sides, drawSide), with their faces,
       name, age, pattern, so the next paper slides in already made; then
       that design opens (switchTo: the address follows, no cross-fade, no
       pop-in), keeping their size where it's sold and the date, on the
       step they were on or the first still to answer. 0.3s on the house
       curve (snapping back 0.2s); reduced motion: at once. "more wraps"
       and its cards are gone (drawCard, rowFor, cardSample);
     · "another one?": a roll added (with another design not yet added
       this visit), the next one slides in already made (one with all it
       needs first), on a step of its own: "another one?", a tick and
       "<design>’s in your basket · same size and date", "no thanks,
       checkout" (the basket), and the ink button "add this one too · £x"
       (saved at once; anything it still needs comes first, taking them to
       that step). It's that design's own add (its variant and fields, as
       ever). A swipe or the arrows offer another; "back" goes to its own
       steps. After each add the next is offered, until all are in. For
       those adds the basket popup stays away (fetch's ttQuiet, read by
       sections/tt-cart-toast v1.5, which still updates the count), so
       only one confirmation shows;
     · ?ttdev: ttWrapStudioDev.sides() and step(dir) replace thumbs() and
       cards(); state() says offerFrom, sliding and inBasket.
   Unchanged: the engines, what's saved and ordered (KINDS' fields), the
   cart flow, prices from the variants, and the API the gift wrap page
   uses (open, sync, leave, ready (no sheet photo to wait for now), draw,
   current, data-ws-open, data-ws-sample, .js-title).

   v3.1 (2026-10-07, Ally): "change design" and its picker are gone; the
   other designs are "more wraps" under the studio (.js-designs, cards
   .tt-ws__design as before, so the gift wrap page's hooks hold):
     · each card is drawn LIVE at its own size (drawCard), as the gift wrap
       page draws its wraps: the sheet photo, white paper, and a piece of
       the design (the gift wrap page's regions: two faces or so across;
       Our Favourite a phrase about a quarter of the paper wide, centred on
       a whole one) with their faces, name and age, else the sample face
       (C.cardSample, or the page's data-ws-sample) and age 5 and Marlowe.
       Only cards near the screen are drawn (an IntersectionObserver; a
       design's engine is loaded when its card first comes near), and again
       0.3s after anything they show changes;
     · tapping one switches in place (everything kept, landing on the step
       they were on, as the picker did; the address follows) and, if the
       paper isn't all on screen, the page glides back up to it (smooth;
       at once with reduced motion), with the paper simply swapped (a
       cross-fade can't follow a scroll). Its card and the open design's
       swap places in the row, so no other card moves. Focus goes to the
       design's name;
     · The Classic and The All-Over: "your pattern" is a step (faces →
       pattern → size → date), never required; its controls are sliders
       (face size and gap; The All-Over's face size is one slider with two
       thumbs, tilt and how busy), the layout's words, the paper colours
       and shuffle. The values, steps and ranges are the engines' own
       (clean(): half centimetres, whole degrees), so the order fields are
       unchanged. The steppers are gone;
     · the hat engine prefetches the other hats only once its design is
       open (a card in the row loads only what it draws).
   Unchanged: the engines, order fields, the cart flow, prices from the
   variants, ?ttdev hooks (thumbs() now draws the cards), cv.ttColourAt and
   the API the gift wrap page uses.

   The shell. It owns the page: the paper (a plain sheet, .tt-paper, with the
   open design's engine drawing underneath it), the design picker, the
   steps (one at a time), this visit's faces, the words, the sizes and date, the one
   form, the big button and add to basket. Each design is drawn by an
   engine (assets/tt-wrap-engine-NAME.js, plus any data it needs, e.g. Our
   Favourite's assets/tt-fav-data.js), loaded only when that design is
   first shown; engines draw and bake and never touch the page. Shared
   intake (cutout, uploads) is assets/tt-wrap-kit.js
   (window.TTWrapKit), loaded before this file.

   State, all in memory (nothing is stored in the browser, nothing personal
   goes in the address):
     · shared by every design: window.TTWrapShared = { faces, face, name,
       age, size } (this visit's faces, the one in use, their name and
       age, and the size they last picked, by name), so a page that opens
       the studio in place (the gift wrap page, to come) can hand them over;
     · per design: its hat, its phrase, its size, its saved design, its
       engine and its add to basket. A one-face design uses the face in
       use; a design with no faces leaves them be.

   Switching design (the "design" cards, shown with two or more designs):
   in place, no page load. Only the paper cross-fades (a same-document view
   transition with view-transition-name on the paper alone; with reduced
   motion or no support it simply swaps), the page colour glides to the
   design's own over 0.3s, the steps become that design's (The Party Hat:
   design · faces · hat · order; Our Favourite: design · words · order),
   the address becomes that design's product page (history.pushState; with
   ?ttdev it keeps this address and sets &design=, because draft and
   archived products' pages 404) and back switches back. The size carries
   over when the new design sells it. On a computer the steps column keeps
   its top where it was, so the card under the pointer doesn't move.

   How a design reaches the order:
     · (v3.53) once the design is complete and the size step is reached,
       the engine bakes it and the kit uploads the pictures (any it has
       sent before are not sent again). A failed save tries again by itself
       (twice, 3s then 6s later), and from the first failure the button
       offers "try saving again";
     · add to basket saves first if what's on screen isn't saved yet (the
       button says "saving…" meanwhile), and needs a size;
     · just before adding, every properties[...] field the form owns is
       removed except "When do you need it for?" (the date box itself), and
       the open design's own set is written, checked against that design's
       list of fields, so a line never carries another design's fields.
       Then the form goes to /cart/add.js, which raises the tt-cart-toast
       popup like every other add.
   Announces document "tt:wrapstudio" { design, ready } whenever the design
   or ready changes (ready = the design is saved and can be ordered).

   The page never jumps: nothing here scrolls the page or moves focus by
   itself. The one exception is typing on a phone (the age, or the words):
   like Our Favourite's old page, it keeps the box clear of the keyboard and
   the paper glides in close above it. On a short phone with a tall keypad,
   where the header would leave only a sliver of paper, the header fades
   while they type (it doesn't move). When the box is left, or the keyboard
   goes away, the paper zooms out, the header comes back and the page
   glides back to where it was. The words close-up also happens on a
   computer (a phrase is a few millimetres at true size), and eases back
   out to the whole sheet 1.6s after the typing stops. On a computer the
   steps column scrolls itself (never the page) to show a date that won't
   do and why. A date isn't judged while its year is still being typed.

   If an engine doesn't load, the message stays up and the button offers
   to load it again (faces and words are kept).

   ?ttdev=1 (testing only): a design whose product can't be shown borrows
   this page's product; &design=<handle> opens that design;
   window.ttWrapStudioDev offers face(url, real) (a sample face without the
   cutout worker), skip(ms) (jump the animation clock), draw(),
   keyboard(px) (pretend a keyboard is up), zoom(on), sizes(list),
   design(key), phrase(text) and state().

   v3.0 (2026-10-07, Ally: "so busy, make it intuitive"): one step at a
   time, on phones and computers alike. The tabs are gone; the open
   design's steps (ORDER) are its own questions (The Party Hat: faces,
   age; Our Favourite: words; The Classic and The All-Over: faces) and
   then size and date. One step is on show (S.tab), in one place of one
   fixed height, so a step change never moves the paper or the button: it
   slides 14px and fades (0.2s out, 0.3s in; reduced motion: no slide).
   The ink button is the step's next move: what it still needs ("add
   their photo", "add their age", "type their name", "swap to plain
   letters", "pick a date"), else "next", and on the last step add to
   basket (anything earlier still to answer comes first). Side trips,
   never required, from a step: "change design" (the four designs as
   pictures; picking one switches in place as before and lands on the
   step they were on, or the first before it still to answer), "change
   the hat" (age step) and "tweak the pattern" (photo step); "back", the
   ink "done" or Escape return to the step (S.ret). "back" on every step
   but the first. Focus that was in a step that goes moves to the new
   step's heading, which is announced. Our Favourite takes their name
   (made into "Name’s our favourite", as the gift wrap page makes it,
   and the name is shared with it through TTWrapShared.name) or, with
   "write your own words", the whole phrase (P().own); the rules show
   only when what's typed can't be printed. Removed with the tabs: the
   steps column's scroll and its held height (anchorColumn, measureColumn,
   reveal), the "+ ’s our favourite" chip, the count, the hint, the wide
   "add their photo" row's shrink. Unchanged: what's drawn, saved and
   sent (KINDS' fields), the cart flow, saved faces in memory, the API the
   gift wrap page uses (open, sync, leave, ready, draw, current, shared,
   data-ws-open, data-ws-sample), ?ttdev hooks (state() also says ret),
   cv.ttColourAt.
   v2.7: The Classic and The All-Over (engines "classic" and "allover",
   assets/tt-wrap-engine-classic.js and tt-wrap-engine-allover.js: the
   print worker's "wrap" and "allover" recipes, proven by workers/
   tpprintfiles/test/classic-allover-parity.test.mjs). Their steps are
   design · faces · pattern · order:
     · faces: up to five (each design's own mix, P().picked, by face key):
       tapping a face adds it to the mix or takes it out (never the last
       one; a sixth says "five at most"); a new photo joins the mix (the
       oldest goes if there are five). With no mix of its own a design uses
       the face in use (SHARED.face), so a photo added on the gift wrap
       page is the one they see; a new face there (sync) starts these
       designs' mixes afresh with it. The Party Hat still takes one face;
     · pattern (P().pattern, the engine's defaults() until they change
       it): The Classic's layout, face size, gap and paper; The All-Over's
       smallest and largest face, tilt, how many (its extras pop in and
       out as it slides; nothing else moves) and shuffle (a new seed, the
       faces pop in again). Steppers go in half centimetres, as the old
       pages did; a stepper at its end is shut. On a phone the button
       offers "next: pattern" once the faces are in, until they've seen it.
     · a line in the basket carries exactly the old Classic or All-Over
       page's fields (the engine's bake(); KINDS lists them, faces 1 to 5).
   ?ttdev: window.ttWrapStudioDev.pattern({ ... }) sets the pattern, and
   state() says the mix and the pattern too. The Party Hat and Our
   Favourite are unchanged: what they draw, save and send is the same.
   v2.6 (from the review of the gift wrap page; the studio's own page is
   unchanged, and so is what's saved and sent): data-ws-sample='{"face":
   url, "age": "5"}' on the studio's element, set by a page that puts the
   studio on itself (the gift wrap page, which draws its wraps with that
   sample face and age till theirs are in), draws the paper and the design
   cards with that face (and that age, while they haven't typed one) until
   they add their own photo. Display only: the face and age a design is
   saved, judged complete and ordered with are still only theirs (st()),
   so the sample is never baked, and the button still says "add their
   photo" until they do; the paper still opens the picker.
   v2.5 (from the review of the gift wrap page; the studio's own page is
   unchanged, and so is what's drawn, saved and sent):
     · data-ws-open="<key>" on the studio's element, set by a page that
       puts the studio on itself before booting it, says which design to
       open on (it wins over the page's own product, so the gift wrap page
       never boots on the wrap that was fetched and then switches, loading
       that wrap's artwork for nothing);
     · a design chosen on that page (data-ws-open, or open(key, { fresh }))
       doesn't pop in: it was drawn there already, so the first picture is
       the finished sheet (the pop-in left the paper blank, then the faces
       came back one by one);
     · ready(): the design on show can be drawn in full (its engine and
       artwork, and the sheet photo), and draw(): the paper drawn at once
       (not next frame), so that page can wait for it, and have it drawn,
       before the studio is pictured;
     · the phrase made from their name (Our Favourite, the name from that
       page): one that can't be printed as typed (Lily-Mae) starts as the
       version the engine offers (LILY MAE, engine v1.4), as that page drew
       it. One they type themselves is read as before ("swap to plain
       letters" offers the same).
   v2.4: opened in place by the gift wrap page (sections/tt-wrap-collection,
   assets/tt-wrap-collection.js), which fetches this studio's markup from a
   wrap's product page, puts it on its own page and boots it with
   window.TTWrapStudioBoot() (this file was loaded before the markup was
   there). open(key, { fresh: true }) opens a design on its own first step
   (faces, words), not the "design" tab, as the wrap was chosen on that
   page. Two more calls on the studio's API for that page, neither used
   on the product page itself:
     · sync(): each time the page shows the studio again. Their faces,
       name and age may have changed on the page meanwhile: new faces get
       their tiles, the face in use is ticked, the age box shows their age,
       and Our Favourite's phrase follows their name while it's still the
       one made from it (one they've typed over is theirs, and stays). The
       page colour and title come back, and the studio measures itself
       again and carries on saving if the design changed;
     · leave(): before the page takes the studio off to show the wraps
       again: typing ends (the box is left, the close-up and the faded
       header put back, nothing glides afterwards) and "details" closes.
   Nothing else changes: what's drawn, saved and sent is the same.
   v2.3: the section holds the studio back (data-ws-arriving) until the
   little script straight after it shows it whole; booting here shows it
   too, in case that script never ran.
   v2.2: nothing moves as the page loads or as faces arrive:
     · the design cards and the "design" tab come from the section's
       Liquid, on the first paint (with ?ttdev=1 its little script shows a
       borrowed design's card before the first paint); this script gives
       each card its address, its click and its live picture, and builds a
       card only if the section didn't;
     · the faces tray: the camera tile comes first and faces follow it, so
       a new face never moves what's there (a face used to push the tile
       along); the first face turns the wide "add their photo" row into the
       camera tile over 0.3s: the tile's own box changes at once where it
       stands, and only its look (the dashed edge, the camera, the words
       fading) eases there, so nothing else moves;
     · the basket popup's picture of an Our Favourite line is the start of
       their phrase (the engine says where on the _Preview: bake().thumbs),
       told to sections/tt-cart-toast v1.4 by window.TTWrapThumbs.
   v2.1: piece 2's fixes:
     · sizes: the size they last picked (SHARED.size, by name, set only by
       tapping a size or by a ?variant= link) is used wherever it's sold;
       where it isn't, this design's own last pick (else the first), and
       a note says so ("... doesn't come in 5m, so it's set to A2"); on a
       phone the button then offers "next: order" until they've seen it.
       ?variant= opens on that size;
     · "adding…" / "added" belong to the design that was added; a cutout's
       result or error only reaches a design with faces (an error waits
       until one is shown); a face that changes while another design is
       open resets every faces design's save, and a save that's overtaken
       never leaves "saving…" stuck;
     · the engine and its data each retry by themselves (the data is never
       fetched twice); open(key, { replace }) replaces the address;
     · the paper's ground is see-through (the kit's "clear" sheet), so the
       page colour shows through it and the switch never shows the paper's
       box; the old paper fades in 0.2s;
     · the header's logo asks the paper what it shows (cv.ttColourAt,
       sections/tt-header v1.13), so it isn't white on the white close-up;
     · phones: typing the words keeps the line under the box (the note,
       the ending and swap buttons) above the keyboard too; those buttons
       only bring the keyboard back if it was up; hidden steps are put
       back once they've slid out (they made the page 4px wider); the
       tab pill lands with the new design's tabs;
     · the big button says "swap to plain letters" / "make it shorter" /
       "change the letters" for words that can't be printed;
     · computers: the steps column keeps the tallest design's height (as
       far as the screen allows), so the button stays put on a switch;
       Space on a design card switches, like a button;
     · the cards: Our Favourite's shows its card picture until a phrase is
       typed, then the start of their phrase, big enough to read.
   v2: piece 2 of the studio: Our Favourite and the design switcher; the
   date waits for a whole year.
   v1: piece 1, with The Party Hat.
*/
(function () {
  "use strict";
  var K = window.TTWrapKit;
  if (!K) return;                                   /* the section's own check says so on the page */
  var WIDE_Q = "(min-width: 900px) and (min-aspect-ratio: 1/1)";
  var REDUCED = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  var DEV = /[?&]ttdev\b/.test(location.search);
  var ROLL = 61;                                    /* every wrap is 61cm wide */
  /* (v3.55, Ally: "Should all be sharp ideally"): the canvases at the screen's own density (it was held at 2, so a
     phone at 3 stretched them half again), up to 3, and no bigger than 12 million pixels for a canvas W x H CSS px */
  function density(W, H) {
    var d = Math.min(3, window.devicePixelRatio || 1);
    if (W > 0 && H > 0) d = Math.max(1, Math.min(d, Math.sqrt(12e6 / (W * H))));
    return d;
  }
  var NO_ZOOM = { z: 1, ox: 0, oy: 0 };
  /* (v3.13) the view at rest: resolved each frame to the open design's (restZoom) */
  var REST = { rest: true };
  /* (v3.13) the view a design opens on: The Cheerful and Our Favourite close up (their name about
     print size), the hats on the whole sheet; their choice (S.view) then holds for every design
     that has the switch. Designs not listed show the whole sheet, with no switch */
  var VIEWS = { cheerful: "close", phrase: "close", hat: "whole", santa: "whole", santarows: "whole", santawhite: "whole", idea: "whole", classic: "whole", allover: "whole", shirt: "close" };
  /* (v3.16) on a phone, the face designs open close up too */
  var PHONE_VIEWS = { hat: "close", santa: "close", santarows: "close", santawhite: "close", idea: "close", classic: "close", allover: "close" };
  /* (v3.50) how much of the roll a close-up shows, and where: the gift wrap page's cards' rule (assets/tt-wrap-view.js) */
  var WV = window.TTWrapView || null;
  var ZOOM_MS = 520;
  var AGE_PX = 26;                                  /* the close-up shows the age at least this tall */
  var LINGER_MS = 1600;                             /* the words close-up eases out this long after typing stops */
  /* what each kind of design needs from the page, and the only order
     fields it may ever send (the print worker routes a line by its fields) */
  var FACE_FIELDS = [1, 2, 3, 4, 5].reduce(function (a, i) {
    var sfx = i === 1 ? "" : " " + i;
    return a.concat(["_Original photo" + sfx, "_Face cutout" + sfx]);
  }, []);
  /* (v3.12) a hat wrap's faces 2 to 5 (hat engine v5) */
  var HAT_MORE = [2, 3, 4, 5].reduce(function (a, i) { return a.concat(["_Hat face " + i, "_Hat cutout " + i]); }, []);
  /* steps: the design's own questions, before "which size?"; aside: its
     side trips (one tap away, never required) */
  var KINDS = {
    hat: { faces: 1, multi: 5, steps: ["faces", "age"], aside: [], fields: ["Hat", "Age", "Face size", "_Hat face", "_Hat cutout"].concat(HAT_MORE, ["_Original photo", "_Wrap layout", "_Preview"]) },
    phrase: { faces: 0, steps: ["words"], aside: [], fields: ["Phrase", "_Wrap layout", "_Preview"] },
    /* the old Classic and All-Over pages' fields (snippets/tt-wrap-pattern, tt-wrap-scatter) */
    classic: { faces: 5, steps: ["faces"], aside: [], fields: FACE_FIELDS.concat(["Head size", "Spacing", "Layout", "_Background", "_Pattern swatch"]) },
    allover: { faces: 5, steps: ["faces"], aside: [], fields: FACE_FIELDS.concat(["Size range", "Rotation", "_Background", "_Seed", "_Extras", "_Pattern swatch"]) },
    /* The Cheerful: only what the worker's cheerful recipe reads (assets/tt-wrap-engine-cheerful.js) */
    cheerful: { faces: 0, steps: ["name"], aside: [], fields: ["Name", "_Wrap layout", "_Preview"] },
    /* (v3.7) The Santa Hat: their face in the Santa hat (no age), on the paper colour they pick
       ("your hat": the hat editor and the colour); the hat engine's santa-hat-1 line */
    santa: { faces: 1, multi: 5, steps: ["faces"], aside: [],         /* (v3.35) no "your hat": the first step places it */ fields: ["Hat", "Face size", "_Hat face", "_Hat cutout"].concat(HAT_MORE, ["_Original photo", "_Background", "_Wrap layout", "_Preview"]) },
    /* (v3.33) Santa Rows: their faces in the Santa hat and their name (the hat engine's santa-rows-1 line; no colour) */
    santarows: { faces: 1, multi: 5, steps: ["faces", "name"], aside: [],     /* (v3.35) no "your hat" either; (v3.61) their words beside their name */ fields: ["Hat", "Name", "Words", "_Hat face", "_Hat cutout"].concat(HAT_MORE, ["_Original photo", "_Wrap layout", "_Preview"]) },
    /* (v3.38) Santa on White: Santa Rows' line, on white (santa-white-1) */
    santawhite: { faces: 1, multi: 5, steps: ["faces", "name"], aside: [], fields: ["Hat", "Name", "Words", "_Hat face", "_Hat cutout"].concat(HAT_MORE, ["_Original photo", "_Wrap layout", "_Preview"]) },
    /* (v3.26) the football shirt: only what the worker's shirtwrap recipe reads (assets/tt-wrap-engine-shirt.js) */
    shirt: { faces: 0, steps: ["shirt"], aside: [],               /* (v3.39) the kit in with the name and number */ fields: ["Name", "Number", "Shirt colour", "Second colour", "Pattern", "Sleeves", "Trim", "Lettering", "Outline", "_Wrap layout", "_Preview"] }
  };
  function isHatLike(engine) { return engine === "hat" || engine === "santa" || engine === "santarows" || engine === "santawhite"; }
  /* (v3.40) the idea wraps: a kind each, from what its block says it takes (idea_uses: photo, colour, name); the line's
     fields are the idea engine's (assets/tt-wrap-engine-idea.js: a face's figures up to twelve specs each) */
  var IDEA_FIELDS = ["Design", "Name", "Age", "Colour", "Face 1", "Face 2", "Face 3", "Face 4", "Face 5", "_Wrap layout", "_Layout", "_Figures", "_Tile under", "_Tile over", "_Preview"]   /* (v3.47) the faces' choices */
    .concat(["Words", "Joke 1", "Joke 2", "Joke 3", "Joke 4"])                     /* (v3.58) their own words (the design's texts) */
    .concat(["Couples"])                                                            /* (v3.62) how many couples */
    .concat(["Names"])                                                              /* (v3.63) a name for each face */
    /* (v3.62) a couples design's faces are its couples' (three couples: six) */
    .concat([1, 2, 3, 4, 5, 6].reduce(function (a, f) { for (var s = 1; s <= 12; s++) a.push("_Figure " + f + "." + s); return a.concat(["_Cutout " + f, "_Original photo " + f]); }, []));
  function ideaKind(uses, idea, texty, pairs) {
    var u = String(uses || "photo").split(/[\s,]+/), steps = [], two = (pairs || []).indexOf(idea) > -1;
    if (u.indexOf("photo") > -1) steps.push("faces");
    /* (v3.62) a couples design: who's in each couple, after their photos */
    if (two) steps.push("couples");
    /* (v3.46) the colour is in the first step, under their faces (Ally: "the colour background picker, have it on the
       first panel"): no step of its own */
    if (u.indexOf("name") > -1) steps.push("name");
    /* (v3.58) the section's text_ideas: their own words, a step of their own */
    /* (v3.61, Ally: "the words and name can be the same step") with their name, on its step; else a step of their own */
    if ((texty || []).indexOf(idea) > -1 && u.indexOf("name") < 0) steps.push("texts");
    return { faces: u.indexOf("photo") > -1 ? 5 : 0, steps: steps, aside: [], fields: IDEA_FIELDS, couples: two };
  }
  /* (v3.41) the designs that take a face size, and the sizes (mm; 0 is normal, the worker's 87mm) */
  var FSIZE_ON = { hat: 1, santa: 1 }, FSIZES = [0, 74, 104];
  /* (v3.48) and The Classic and The All-Over: the same three as their pattern's own sizes (cm; the middle is the engine's
     default), smaller and bigger about a fifth either way, as the hats' */
  var FSIZE_FS = ["smaller", "normal", "bigger"];
  var FSIZE_PAT = {
    classic: [{ head: 6 }, { head: 7.5 }, { head: 9 }],
    allover: [{ sMin: 3.5, sMax: 6.5 }, { sMin: 4.5, sMax: 8 }, { sMin: 5.5, sMax: 9.5 }]
  };
  /* which of the three a pattern's faces are nearest (The All-Over's by the middle of its range; a tie stays normal) */
  function fsizeOf(engine, pat) {
    var L = FSIZE_PAT[engine], best = 1, mid = function (x) { return x.head != null ? +x.head : (+x.sMin + +x.sMax) / 2; };
    if (!L || !pat || !isFinite(mid(pat))) return best;
    L.forEach(function (x, i) { if (Math.abs(mid(x) - mid(pat)) < Math.abs(mid(L[best]) - mid(pat))) best = i; });
    return best;
  }
  var NAMED = { cheerful: 1, santarows: 1, santawhite: 1 };                        /* (v3.33) the designs whose name is typed in "name" */
  /* (v3.40) and the idea wraps that take a name */
  function isNamed(d) { return !!(d && (NAMED[d.engine] || (d.engine === "idea" && /\bname\b/.test(d.ideaUses || "")))); }
  var ORDER_STEPS = ["size"];                                    /* (v3.39: no date box; the size step adds) */
  var DATA_GLOBAL = { phrase: "TTFav", cheerful: "TTCheerful", shirt: "TTShirt", santarows: "TTPlaceCards", santawhite: "TTPlaceCards" };            /* the design data an engine needs, by the global it sets */
  /* the basket popup's picture of a studio line (sections/tt-cart-toast
     asks Cloudinary for exactly this); asked for once a design is saved,
     so it's ready when they add. An engine that says where on a picture
     to look (Our Favourite: the start of their phrase) gets that square,
     told to the popup through window.TTWrapThumbs (by the picture's
     address); else the middle of it */
  var TOAST_THUMB = "c_crop,w_0.5,h_0.5,g_center/c_fill,w_240,h_240,f_auto,q_auto";
  function toastThumb(box) {
    if (!box || !(box.w > 0) || !(box.h > 0)) return TOAST_THUMB;
    return "c_crop,x_" + Math.round(box.x) + ",y_" + Math.round(box.y) + ",w_" + Math.round(box.w) + ",h_" + Math.round(box.h) + "/c_fill,w_240,h_240,f_auto,q_auto";
  }

  function ease(t) { t = Math.min(1, Math.max(0, t)); return 1 - Math.pow(1 - t, 3); }
  function ymd(d) { return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"); }
  function slice(x) { return Array.prototype.slice.call(x || []); }
  /* (v3.58) a colour swatch's tick, as the photo bunting's (its tickFor): #333 or white, whichever reads more on the colour
     (WCAG contrast; a gradient goes by its first colour) */
  function tickOn(c) {
    var m = /#([0-9a-f]{6}|[0-9a-f]{3})\b/i.exec(String(c || "")), h = m ? m[1] : "ffffff";
    if (h.length === 3) h = h.replace(/./g, "$&$&");
    var lum = function (x) { x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4); };
    var v = parseInt(h, 16), l = 0.2126 * lum(v >> 16 & 255) + 0.7152 * lum(v >> 8 & 255) + 0.0722 * lum(v & 255), d = 0.0331;   /* (#333's) */
    return (Math.max(l, d) + 0.05) / (Math.min(l, d) + 0.05) >= 1.05 / (l + 0.05) ? "#333333" : "#ffffff";
  }

  function bootAll() { slice(document.querySelectorAll("[data-tt-ws]")).forEach(boot); }
  bootAll();
  document.addEventListener("shopify:section:load", bootAll);     /* the theme editor redrew it */
  window.TTWrapStudioBoot = bootAll;                                /* a page that adds a studio after this file ran (the gift wrap page) */

  function boot(root) {
    if (root.dataset.wsReady) return;
    root.dataset.wsReady = "1";
    root.removeAttribute("data-ws-arriving");
    var C;
    try { C = JSON.parse(document.getElementById(root.getAttribute("data-tt-ws")).textContent); } catch (e) { return; }
    var copy = C.copy || {};
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return slice(root.querySelectorAll(s)); };
    var wideMq = window.matchMedia ? matchMedia(WIDE_Q) : null;
    /* a phone (or any portrait or narrow screen): typing there brings up a keyboard */
    function tabsMode() { return !(wideMq && wideMq.matches); }
    var html = document.documentElement;

    var paper = q(".js-paper"), cv = q(".js-cv"), busyEl = q(".js-busy"), busyTxt = q(".js-busytxt");
    var slideEl = q(".js-slide") || cv.parentNode, sheetEl = q(".js-sheet");
    var steps = qa(".tt-ws__step"), stepsBox = q(".js-steps"), backBtn = q(".js-navback"), trailEl = q(".js-trail"), titleEl = q(".js-title");
    var nameEl = q(".js-name"), artImg = q(".js-artimg");
    var tray = q(".js-tray"), addBtn = q(".js-add"), fileIn = q(".js-file"), dropEl = q(".js-drop");
    var hatsEl = q(".js-hats"), ageIn = q(".js-age");
    /* (v3.5) under the upload: the next tools, greyed out till a face is in */
    var soonEl = q(".js-soon"), hsoon = q(".js-hsoon"), hside = q(".js-hside"), hats2 = q(".js-hats2");
    var nameIn = q(".js-cname"), nmsg = q(".js-cmsg");
    var snameIn = q(".js-sname"), snumIn = q(".js-snum"), smsg = q(".js-smsg");      /* (v3.26) the football shirt's */
    var phraseIn = q(".js-phrase"), pmsg = q(".js-pmsg"), plabel = q(".js-plabel"), ownBtn = q(".js-own"), ownTxt = q(".js-owntxt");
    var sizesEl = q(".js-sizes"), sizeLine = q(".js-sizeline"), det = q(".js-details"), dsizes = q(".js-dsizes");
    var form = q(".js-form"), idIn = q(".js-id");
    var go = q(".js-go"), goLabel = q(".js-golabel"), msg = q(".js-msg"), sr = q(".js-sr");

    /* ── the designs: each its own product, sizes and prices ── */
    var designs = (C.designs || []).map(function (d) {
      var p = d.product;
      if (!p && DEV) {
        p = { id: C.productId, handle: "", title: d.name, url: C.page.url, options: C.page.options,
              fromPrice: C.page.fromPrice, variants: C.page.variants, borrowed: true };
      }
      return { id: d.id, key: d.key || d.id, engine: d.engine, kind: d.engine === "idea" ? ideaKind(d.ideaUses, d.idea, C.textIdeas, C.coupleIdeas) : KINDS[d.engine], idea: d.idea || "", ideaUses: d.ideaUses || "", name: (d.product && d.product.title) || d.name,
               colour: d.colour, ink: d.ink, titleSrc: d.titleSrc, cardSrc: d.card, product: p, hats: d.hats || [], copy: d.copy || {},
               papers: readPapers(d.papers) };
    }).filter(function (d) { return d.kind && d.product && d.product.variants && d.product.variants.length && C.engines[d.engine]; });
    if (!designs.length) {
      root.classList.add("is-empty");
      q(".js-empty").hidden = false;
      return;
    }
    /* (v3.49) the figure designs (the section's fit_ideas): their face is fitted, and their name typed, in "who's it for?" */
    designs.forEach(function (d) {
      if (d.engine !== "idea" || (C.fitIdeas || []).indexOf(d.idea) < 0) return;
      var k = {}, n;
      for (n in d.kind) k[n] = d.kind[n];
      /* (v3.61, Ally: "rudolph rows, move name to step 2") their name keeps its own step (with their words): step 1 is the photo and the fitter */
      k.fit = true;
      d.kind = k;
    });
    /* (v3.7) the paper colours a design is printed on: "Green: #17633A, Red: #C0202B, ..." (its block) */
    function readPapers(t) {
      return String(t || "").split(",").map(function (s) {
        var m = /^\s*([^:]+?)\s*:\s*(#[0-9a-f]{6})\s*$/i.exec(s);
        return m ? { name: m[1], hex: m[2].toUpperCase() } : null;
      }).filter(Boolean);
    }
    function byKey(k) {
      return k ? designs.filter(function (d) { return d.key === k || d.id === k || (d.product && d.product.handle === k); })[0] || null : null;
    }
    /* the design a page that put the studio on itself asked for (data-ws-open);
       else the page's own product's design; else (testing) ?design=; else the first */
    var liquidOpen = (C.designs[C.open] || {}).id;
    var asked = byKey(root.getAttribute("data-ws-open"));
    var D = asked || (C.openMatched ? designs.filter(function (d) { return d.id === liquidOpen; })[0] : null);
    if (!D && DEV) D = byKey(new URLSearchParams(location.search).get("design"));
    if (!D) D = designs.filter(function (d) { return d.id === liquidOpen; })[0] || designs[0];

    /* ── state ── */
    /* (v3.34) their work from before (a week, this browser), unless in the theme editor */
    var KEEP = !(window.Shopify && Shopify.designMode) && window.TTKeep, kept = KEEP ? KEEP.get("wrap") : null;
    var SHARED = window.TTWrapShared || (window.TTWrapShared = (KEEP && KEEP.wrapShared()) || { faces: [], face: null, name: "", age: "", size: null });
    var PER = {};
    designs.forEach(function (d) {
      /* saving: the save under way (a token, so an overtaken save never
         clears a newer one's); adding / added: this design's add to basket;
         sizeNote: its size isn't the one they picked, and (phones) they
         haven't seen its order tab since */
      /* own: Our Favourite's words are their own (else made from their name) */
      PER[d.id] = { hat: 0, hats: [0], place: null, phrase: "", auto: "", own: false, pattern: null, picked: null, seen: {},
                    variant: null, tab: null, saved: { sig: "", props: null }, saving: null, fails: 0, offerRetry: false,
                    engine: null, engState: "idle", tries: 0, intro: false, openedAt: performance.now(),
                    adding: false, added: false, addedT: 0, addMsg: "", sizeNote: false, inBasket: false, colour: null, fsize: 0 };
    });
    function P(d) { return PER[(d || D).id]; }
    /* (v3.34) each design's own choices, as they left them */
    (function () {
      var all = kept && kept.per && typeof kept.per === "object" ? kept.per : {};
      var isN = function (n, max) { return typeof n === "number" && n >= 0 && n < max && n === Math.floor(n); };
      designs.forEach(function (d) {
        var k = all[d.key], p = PER[d.id], nh = Math.max(1, d.hats.length);
        if (!k || typeof k !== "object") return;
        if (isN(k.hat, nh)) p.hat = k.hat;
        if (Array.isArray(k.hats)) { var hs = k.hats.filter(function (n) { return isN(n, nh); }).slice(0, 5); if (hs.length) { p.hats = hs; p.hat = hs[0]; } }
        if (k.place && typeof k.place === "object" && isFinite(k.place.x) && isFinite(k.place.y)) p.place = k.place;
        if (typeof k.phrase === "string") { p.phrase = k.phrase.slice(0, 120); p.auto = typeof k.auto === "string" ? k.auto : ""; p.own = !!k.own; }
        if (k.pattern && typeof k.pattern === "object") p.pattern = k.pattern;
        if (Array.isArray(k.picked)) p.picked = k.picked.filter(function (x) { return typeof x === "string"; }).slice(0, 5);
        if (typeof k.colour === "string") p.colour = k.colour;
        if (typeof k.variant === "number" || typeof k.variant === "string") p.variant = k.variant;
        if (FSIZE_ON[d.engine] && FSIZES.indexOf(k.fsize) > 0) p.fsize = k.fsize;      /* (v3.41) */
      });
    })();
    /* (v3.49) each face's fit in the figure designs, as they left it */
    (function () {
      var all = kept && kept.per && typeof kept.per === "object" ? kept.per : {};
      var num = function (v) { return typeof v === "number" && isFinite(v); };
      designs.forEach(function (d) {
        var k = all[d.key], fits = k && k.fits, out = {}, n = 0;
        if (!d.kind.fit || !fits || typeof fits !== "object") return;
        Object.keys(fits).slice(0, 10).forEach(function (key) {
          var f = fits[key];
          if (f && num(f.x) && num(f.y) && num(f.s) && num(f.r)) { out[key] = { x: f.x, y: f.y, s: f.s, r: f.r }; n++; }
        });
        if (n) P(d).fits = out;
      });
    })();
    if (asked) P(asked).intro = true;                 /* chosen on the page that opened it, where it was drawn already */
    /* tab: the step on show; ret: the step a side trip returns to */
    var S = {
      tab: null, ret: null, busy: false, anim: null, clock: 0, kb: 0, cutMsg: "",
      zoom: { from: NO_ZOOM, to: REST, t0: 0 }, variant: null, view: null
    };
    /* the faces a design uses: a one-face design the face in use; one that
       takes several, its own mix (else the face in use) */
    function faceByKey(k) { return SHARED.faces.filter(function (f) { return f.key === k; })[0] || null; }
    function facesFor(d) {
      d = d || D;
      if (!d.kind.faces) return [];
      var p = P(d), got = (d.kind.faces > 1 || d.kind.multi) && p.picked ? p.picked.map(faceByKey).filter(Boolean) : [];
      return got.length ? got : SHARED.face ? [SHARED.face] : [];
    }
    /* (v3.12) how many faces a design may use: a mix's, or a hat's (one by default) */
    function faceCap(d) { d = d || D; return d.kind.faces > 1 ? d.kind.faces : d.kind.multi || d.kind.faces; }
    function isMix(d) { return (d || D).kind.faces > 1; }
    /* what an engine is drawing: the face in use (designs with faces) and
       the faces in its mix, the age, and the design's own hat, phrase and
       pattern */
    function st(d) {
      d = d || D;
      var p = P(d), fs = isCouples(d) ? couplesFaces(d) : facesFor(d);       /* (v3.62) a couples design: its couples in turn */
      return { face: d.kind.faces ? (fs[0] || null) : null, faces: fs, hat: p.hat, hats: p.hats && p.hats.length ? p.hats.slice() : [p.hat], age: SHARED.age, phrase: p.phrase, pattern: p.pattern, name: SHARED.name, place: p.place,
               bg: d.engine === "santa" ? paperHex(d) : "", size: FSIZE_ON[d.engine] ? p.fsize || 0 : 0,
               fits: d.kind.fit ? p.fits || null : null,                 /* (v3.49) */
               couples: isCouples(d) };                                   /* (v3.62) its faces are its couples' */
    }
    /* what's drawn (never what's saved or ordered): st(), with the sample face and age
       of the page that opened the studio (data-ws-sample, v2.6) until their own photo's in */
    var SAMPLE = null;
    try {
      var smp = JSON.parse(root.getAttribute("data-ws-sample") || "null");
      if (smp && smp.face) SAMPLE = { src: String(smp.face), age: String(smp.age || ""), face: null, job: null };
    } catch (e) { SAMPLE = null; }
    function shown(d) {
      d = d || D;
      var s = st(d);
      if (!SAMPLE || !d.kind.faces || SHARED.face) return s;
      if (!SAMPLE.face && !SAMPLE.job) {
        SAMPLE.job = K.loadImage(SAMPLE.src, true).then(function (img) {
          SAMPLE.face = { img: img, src: SAMPLE.src, c: "", o: "", key: "sample" };
          if (root.isConnected) render();
        }, function () {});
      }
      if (SAMPLE.face) { s.face = SAMPLE.face; s.faces = [SAMPLE.face]; if (!s.age) s.age = SAMPLE.age; }
      return s;
    }

    /* ── the engines: one per design, loaded when it's first shown ── */
    function have(name) { return window.TTWrapEngines && window.TTWrapEngines[name]; }
    function again(src, n) { return n ? src + (src.indexOf("?") > -1 ? "&" : "?") + "retry=" + n : src; }
    function loadEngine(name, n) {
      return (have(name) ? Promise.resolve() : K.loadScript(again(C.engines[name], n)))
        .then(function () { if (!have(name)) throw new Error("engine"); return have(name); });
    }
    function loadData(name, n) {
      var src = (C.data || {})[name], g = DATA_GLOBAL[name];
      if (!src || !g) return Promise.resolve(null);
      return (window[g] ? Promise.resolve() : K.loadScript(again(src, n)))
        .then(function () { if (!window[g]) throw new Error("data"); return window[g]; });
    }
    function makeCanvas(w, h) { var c = document.createElement("canvas"); c.width = w; c.height = h; return c; }
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    function eng(d) { var p = P(d); return p.engState === "ok" ? p.engine : null; }
    function ensureEngine(d) {
      var p = P(d);
      if (p.engState === "ok" || p.engState === "loading") return;
      p.engState = "loading";
      /* the engine and its data each try once more by themselves, on their
         own: one that's still on its way is never asked for again */
      var n = p.tries; p.tries += 2;
      var twice = function (f) { return f(n).catch(function () { return f(n + 1); }); };
      Promise.all([twice(function (k) { return loadEngine(d.engine, k); }), twice(function (k) { return loadData(d.engine, k); })])
        .then(function (got) {
          p.engine = got[0]({
            hats: d.hats, data: d.engine === "idea" ? { id: d.idea, urls: window.TTIdeaUrls } : got[1], art: (C.art || {})[d.engine], fontUrl: C.font, fonts: document.fonts, makeCanvas: makeCanvas, Path2D: window.Path2D,
            loadImage: function (src) { return K.loadImage(src, true); },
            changed: function () { if (d === D) { render(); maybeIntro(); hatEdit(); hatThumbsSoon(); } }
          });
          p.engState = "ok";
          /* a pattern design starts on its engine's own pattern */
          if (!p.pattern && p.engine.defaults) p.pattern = p.engine.defaults();
          /* (v3.48) its face size one of the three (one kept from the old slider: the nearest) */
          if (FSIZE_PAT[d.engine] && p.engine.clean) { var fp = p.engine.clean(p.pattern); p.pattern = p.engine.clean(Object.assign(fp, FSIZE_PAT[d.engine][fsizeOf(d.engine, fp)])); }
          if (d === D) syncPattern();
          /* a phrase made from their name before the engine could read it: the printable version, now it can */
          if (p.auto && p.phrase === p.auto) {
            var made = autoPhrase(d);
            if (made && made !== p.phrase) { p.phrase = p.auto = made; if (d === D && phraseIn) phraseIn.value = made; }
          }
          /* the hat on show first; the other three when the page is idle */
          p.engine.load(p.hat).then(function () {
            if (d === D) { maybeIntro(); prefetchHats(d); hatEdit(); hatThumbsSoon(); syncFsize(); }
            if (d === D && d.engine === "idea") { syncIdeaCols(d); syncPerFace(d); syncTexts(d); syncCouples(d); syncNames(d); figParts(); readName(); render(); changed(); }    /* (v3.40) its design's in (v3.58: its words, its fitter's pieces; v3.63: its faces' names) */
          });
          if (d === D) {
            if (msg.dataset.kind === "engine") hideMsg();
            readPhrase(); readName(); syncTexts(d);             /* (v3.61) its words (any engine that has them) */
            render(); maybeIntro(); changed();
          }
        }).catch(function () {
          p.engState = "failed";
          if (d === D) { showMsg(copy.engineFail, 0, "engine"); paint(); }
        });
    }
    /* the other hats, when the page is idle: only once that design is open
       (a design drawn beside it loads only the hat it draws) */
    function prefetchHats(d) {
      var p = P(d);
      if (p.prefetched || p.engState !== "ok" || !d.hats.length) return;
      p.prefetched = true;
      idle(function () { d.hats.forEach(function (h, i) { p.engine.prefetch(i); }); }, { timeout: 5000 });
    }
    function retryEngine() {
      P().engState = "idle"; hideMsg();
      ensureEngine(D); paint();
    }

    /* ── the paper (v3.2): a plain sheet, no photo. Its white face and the
       print are drawn here, in a rectangle the shape of the old photo's
       sheet (61 x 85.2cm on show), centred with a little room round it for
       the shadow; its edge, shadow and sheen are one .tt-paper over the
       canvas (assets/tt-paper.css), placed on that rectangle each frame, so
       it follows the close-up. The page colour round it is the ground ── */
    var BOX = { x: 0.175, y: 0.05, w: 0.6425, h: 0.8975 };          /* the sheet's proportions (as tt-wrap-sheet.webp's, read 2026-10-05) */
    function placeSheet(el, r, z) {
      if (!el) return;
      var at = [z.ox + r.bx * z.z, z.oy + r.by * z.z, r.bw * z.z, r.bh * z.z].map(function (v) { return Math.round(v * 100) / 100; });
      var key = at.join(",");
      if (el.ttAt === key) return;
      el.ttAt = key;
      el.style.left = at[0] + "px"; el.style.top = at[1] + "px"; el.style.width = at[2] + "px"; el.style.height = at[3] + "px";
      el.classList.add("is-placed");
    }

    /* ── drawing: only while something moves ── */
    var raf = 0, drawn = false;
    function render() { if (!raf) raf = requestAnimationFrame(frame); figEdit(); }     /* (v3.48: the face fitter too) */
    function clock(t) { return (t == null ? performance.now() : t) + S.clock; }
    /* the sheet (plus a little room round it) fills the paper area, centred */
    function sheetRect(W, H) {
      var b = BOX, m = 0.035;
      var s = Math.min(W / (b.w + 2 * m), H / (b.h + 2 * m));
      var ox = W / 2 - (b.x + b.w / 2) * s, oy = H / 2 - (b.y + b.h / 2) * s;
      return { s: s, ox: ox, oy: oy, bx: ox + b.x * s, by: oy + b.y * s, bw: b.w * s, bh: b.h * s };
    }
    function frame(t) {
      raf = 0;
      var now = clock(t);
      var W = cv.clientWidth, H = cv.clientHeight;
      if (!W || !H) return;
      var dpr = density(W, H);
      var pw = Math.round(W * dpr), ph = Math.round(H * dpr);
      if (cv.width !== pw || cv.height !== ph) { cv.width = pw; cv.height = ph; }
      var ctx = cv.getContext("2d");
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, W, H);
      var z = zoomAt(now);
      var r = sheetRect(W, H), k = r.bw / ROLL, moving = false, e = eng(D);
      ctx.save();
      /* (v3.18) the sheet stays put: the close-up is drawn inside it */
      ctx.beginPath(); ctx.rect(r.bx, r.by, r.bw, r.bh); ctx.fillStyle = "#fff"; ctx.fill(); ctx.clip();
      if (z.z !== 1 || z.ox || z.oy) { ctx.translate(z.ox, z.oy); ctx.scale(z.z, z.z); }
      ctx.save();
      ctx.beginPath(); ctx.rect(r.bx, r.by, r.bw, r.bh); ctx.fillStyle = "#fff"; ctx.fill(); ctx.clip();
      ctx.translate(r.bx, r.by);
      if (e) {
        /* how big it's shown, and the part that's on screen (cm on the sheet) */
        /* (v3.13) crisp at every scale: a glide is drawn from the engine's bitmaps only while it's
           near the whole sheet (they're made at up to 2.5x); closer, the engine draws just what's
           on screen, sharp, every frame */
        var view = { dpr: dpr, z: z.z, zMax: Math.max(S.zoom.from.z, resolve(S.zoom.to).z), moving: z.moving && z.z <= 2.5, gliding: z.moving,
                     x0: (-z.ox / z.z - r.bx) / k, y0: (-z.oy / z.z - r.by) / k,
                     x1: ((W - z.ox) / z.z - r.bx) / k, y1: ((H - z.oy) / z.z - r.by) / k };
        moving = e.draw(ctx, ROLL, r.bh / k, k, now, shown(), S.anim, view);
      }
      ctx.restore();
      ctx.restore();
      placeSheet(sheetEl, r, NO_ZOOM);
      closeClass();                                   /* (v3.13: the view can change as an engine arrives) */
      if (!drawn) { drawn = true; paper.classList.add("is-drawn"); if (sheetEl) sheetEl.classList.remove("is-blank"); }     /* the paper's stand-in face fades to the print */
      if (!moving) S.anim = null;
      if (moving || z.moving) render();
      else if (e && VIEWS[D.engine]) warmSoon();
    }
    /* (v3.13) the bitmaps a glide between the views starts from (the engine's whole sheet at
       2.5x), made ahead when the page is idle, so a tap on the switch glides from its first frame */
    var warmT = 0, warmCv = null;
    function warmSoon() {
      clearTimeout(warmT);
      warmT = setTimeout(function () {
        idle(function () {
          var e = eng(D), W = cv.clientWidth, H = cv.clientHeight;
          if (!e || !W || !H || S.zoom.t0 && zoomAt(clock()).moving) return;
          var r = sheetRect(W, H), k = r.bw / ROLL, dpr = density();
          warmCv = warmCv || makeCanvas(1, 1);
          var x = warmCv.getContext("2d");
          x.save(); x.scale(0.001, 0.001);
          try { e.draw(x, ROLL, r.bh / k, k, clock(), shown(), null, { dpr: dpr, z: 1.01, zMax: 40, moving: true }); } catch (er) {}
          x.restore();
        }, { timeout: 1500 });
      }, 400);
    }
    function drawNow() { cancelAnimationFrame(raf); raf = 0; frame(performance.now()); }
    /* (v3.45) every head its own moment in the first POP_SPREAD ms, each popping in over POP_IN ms (the house arrival) */
    var POP_SPREAD = 200, POP_IN = 300;
    function popDelay(n) { return (n * 0.6180339887 % 1) * POP_SPREAD; }
    function ripple(stagger) {
      if (REDUCED) { S.anim = null; render(); return; }
      S.anim = D.engine === "phrase" ? { t0: clock(), stagger: stagger }
             : { t0: clock(), stagger: stagger, delay: popDelay, pop: POP_IN, span: POP_SPREAD + POP_IN };
      render();
    }
    /* each design pops in once, the first time it's on show (if that's soon
       after it was opened) */
    function maybeIntro() {
      var p = P(), e = eng(D);
      if (p.intro || !e || !e.ready()) return;
      p.intro = true;
      if (performance.now() - p.openedAt > 6000) { render(); return; }
      ripple(D.engine === "phrase" ? 16 : SHARED.face ? 45 : 22);
    }
    if ("ResizeObserver" in window) new ResizeObserver(function () { render(); }).observe(cv);

    /* ── the close-up while typing (the age on a phone; the words anywhere) ── */
    function zoomAt(now) {
      var Z = S.zoom, T = resolve(Z.to);
      if (!Z.t0) return { z: T.z, ox: T.ox, oy: T.oy, moving: false };
      var p = REDUCED ? 1 : Math.min(1, (now - Z.t0) / ZOOM_MS), e = house(p);
      return { z: Z.from.z + (T.z - Z.from.z) * e, ox: Z.from.ox + (T.ox - Z.from.ox) * e,
               oy: Z.from.oy + (T.oy - Z.from.oy) * e, moving: p < 1 };
    }
    /* (v3.13) the house curve, cubic-bezier(.2, .8, .3, 1), for the zoom's glide */
    function house(t) {
      if (t <= 0) return 0; if (t >= 1) return 1;
      var lo = 0, hi = 1, u = t;
      for (var i = 0; i < 18; i++) {
        u = (lo + hi) / 2;
        var x = 3 * u * (1 - u) * (1 - u) * 0.2 + 3 * u * u * (1 - u) * 0.3 + u * u * u;
        if (x < t) lo = u; else hi = u;
      }
      return 3 * u * (1 - u) * (1 - u) * 0.8 + 3 * u * u * (1 - u) + u * u * u;
    }
    /* (v3.13) the view at rest, close up or the whole sheet: the open design's (or d's, for a
       paper drawn beside it), worked out for the paper's size now */
    function resolve(T) { return T && T.rest ? restZoom() : T; }
    function viewOf(d) { d = d || D; var v = VIEWS[d.engine]; if (v && tabsMode() && PHONE_VIEWS[d.engine]) v = PHONE_VIEWS[d.engine]; return v ? S.view || v : "whole"; }
    /* how close: (v3.50) the card's view, cm of the roll across the sheet as across its card's paper, the card as it is
       on this screen */
    function closeZ(d) { return WV ? ROLL / WV.cm(d.engine, eng(d), shown(d), WV.cardPaper()) : 2.5; }
    function restZoom(d, W, H) {
      d = d || D;
      if (viewOf(d) !== "close") return NO_ZOOM;
      var e = eng(d);
      W = W || cv.clientWidth; H = H || cv.clientHeight;
      if (!e || !WV || !W || !H) return NO_ZOOM;
      var r = sheetRect(W, H), k = r.bw / ROLL;
      /* (v3.50) the piece of the roll its card shows on this screen (TTWrapView.frame), found once for this paper size:
         typing a longer name never nudges the close-up */
      var cp = WV.cardPaper(), fk = W + "x" + H + "|" + Math.round(cp), pd = P(d), R = pd.restF && pd.restF.key === fk ? pd.restF.R : null;
      if (!R) {
        R = WV.frame(d.engine, e, shown(d), cp, r.bw / r.bh);
        if (R.wait) return NO_ZOOM;
        pd.restF = { key: fk, R: R };
      }
      var z = ROLL / R.w;
      var ox = r.bx - (r.bx + R.x * k) * z, oy = r.by - (r.by + R.y * k) * z;
      /* (v3.18) the sheet at rest stays covered (no edge of the design shows inside it) */
      ox = Math.min(r.bx - r.bx * z, Math.max(r.bx + r.bw - (r.bx + r.bw) * z, ox));
      oy = Math.min(r.by - r.by * z, Math.max(r.by + r.bh - (r.by + r.bh) * z, oy));
      return { z: z, ox: ox, oy: oy };
    }
    function atClose() { return resolve(S.zoom.to).z > 1.001; }
    function zoomTo(T) {
      var now = clock(), cur = zoomAt(now);
      S.zoom = { from: { z: cur.z, ox: cur.ox, oy: cur.oy }, to: T, t0: now };
      closeClass();
      render();
    }
    /* the close-up while typing (not the view at rest) */
    function zoomedIn() { return !S.zoom.to.rest && S.zoom.to.z > 1.001; }
    /* the header's logo (sections/tt-header v1.13) asks the paper what it
       shows under it: the sheet is white, the ground round it see-through
       (the page colour). Answered for where the close-up is going, and
       html's tt-ws-close class changing makes the header look again, so
       the logo turns with the zoom (not white on the white close-up) */
    function closeClass() { html.classList.toggle("tt-ws-close", atClose()); syncView(); }
    cv.ttColourAt = function (x, y) {
      var b = cv.getBoundingClientRect(), W = cv.clientWidth, H = cv.clientHeight, z = resolve(S.zoom.to);
      var cx = x - b.left, cy = y - b.top;
      if (!W || !H || cx < 0 || cy < 0 || cx > W || cy > H) return null;
      var r = sheetRect(W, H), px = cx, py = cy;     /* (v3.18) the sheet never moves */
      return px >= r.bx && px <= r.bx + r.bw && py >= r.by && py <= r.by + r.bh ? [255, 255, 255, 1] : null;
    };
    function vvH() { var vv = window.visualViewport; return (vv ? vv.height : window.innerHeight) - S.kb; }
    function vvTop() { var vv = window.visualViewport; return vv ? vv.offsetTop : 0; }
    /* how far down the paper the page's own sticky bits (the header) reach:
       the first row, from the top of what's on screen, where the paper
       itself is what's showing across it */
    function clearTop(rect, top, bot) {
      var xs = [0.15, 0.5, 0.85].map(function (f) { return rect.left + rect.width * f; });
      for (var y = top; y < bot; y += 4) {
        var vy = rect.top + y + 1, clear = true;
        for (var i = 0; i < xs.length && clear; i++) {
          var e = document.elementFromPoint(xs[i], vy);
          clear = !!e && (e === cv || paper.contains(e));
        }
        if (clear) return y;
      }
      return bot;
    }
    /* the face (or phrase) nearest the middle of the part of the paper
       that's on screen (under the header, above any keyboard): a face made
       about four fifths of that height (on a short screen, closer still, on
       its hat, so the age can be read); a phrase about half the paper wide */
    function closeUp() {
      var e = eng(D);
      if (!e || !e.focus) return NO_ZOOM;
      var W = cv.clientWidth, H = cv.clientHeight, rect = cv.getBoundingClientRect();
      var vTop = vvTop(), vH = vvH();
      var top = Math.max(0, vTop - rect.top), bot = Math.min(H, vTop + vH - rect.top);
      top = clearTop(rect, top, bot);
      if (bot - top < 36) return NO_ZOOM;
      var r = sheetRect(W, H), k = r.bw / ROLL, cx = W / 2, cy = (top + bot) / 2;
      var f = e.focus((cx - r.bx) / k, (cy - r.by) / k, r.bh / k);
      if (!f) return NO_ZOOM;
      var fx = f.x, fy = f.y, z = (0.8 * (bot - top)) / (f.h * k);
      if (f.w) z = Math.min(z, (0.5 * W) / (f.w * k));
      if (VIEWS[D.engine] === "close" || D.engine === "idea") z = closeZ(D);     /* (v3.13) the name designs: as their close-up shows them; (v3.40) the idea wraps a few repeats; (v3.50) the card's view */
      if (f.age && f.age.h > 0) {
        var za = AGE_PX / (f.age.h * k);
        if (za > z) { z = za; fx = f.age.x; fy = f.age.y; }
      }
      z = Math.max(1.4, Math.min(VIEWS[D.engine] === "close" ? 40 : 9, z));
      var px = r.bx + fx * k, py = r.by + fy * k;
      return { z: z, ox: cx - px * z, oy: cy - py * z };
    }
    /* (v3.13) the switch on the paper's foot: close up · whole sheet. It shows the view on screen
       (close up while they type, too); a tap glides there and becomes their choice for every
       design with the switch. The paper and the page never change size */
    var viewEl = q(".js-view"), viewBtns = qa(".js-vbtn");
    function syncView() {
      if (!viewEl) return;
      var has = !!VIEWS[D.engine];
      if (viewEl.hidden === has) viewEl.hidden = !has;
      var on = atClose() ? "close" : "whole";
      viewBtns.forEach(function (b) { var p = String(b.getAttribute("data-v") === on); if (b.getAttribute("aria-pressed") !== p) b.setAttribute("aria-pressed", p); });
    }
    function setView(v) {
      var now = clock(), cur = zoomAt(now);           /* (where it is now, before the view at rest changes) */
      S.view = v === "close" ? "close" : "whole";
      var a = typingEl();
      if (a && S.view === "whole") a.blur();         /* (the whole sheet: typing's over, as leaving the box) */
      clearTimeout(lingerT);
      if (!zoomedIn()) { S.zoom = { from: { z: cur.z, ox: cur.ox, oy: cur.oy }, to: REST, t0: now }; closeClass(); render(); }
    }
    viewBtns.forEach(function (b) {
      b.addEventListener("click", function () { setView(b.getAttribute("data-v")); });
    });
    function typingEl() { var a = document.activeElement; return a && (a === ageIn || a === phraseIn || a === nameIn || a === snameIn || a === snumIn || (a.classList && a.classList.contains("js-txin") && root.contains(a))) ? a : null; }   /* (v3.58: and the words) */
    function typing() { return tabsMode() && !!typingEl(); }
    /* how much of the paper is on screen while typing: under the header,
       above the keyboard (the controls sit below the paper) */
    function paperStrip() {
      var H = cv.clientHeight, rect = cv.getBoundingClientRect(), vTop = vvTop(), vH = vvH();
      var top = Math.max(0, vTop - rect.top), bot = Math.min(H, vTop + vH - rect.top);
      return bot > top ? Math.round(bot - clearTop(rect, top, bot)) : 0;
    }
    /* a short phone with a tall keypad (360 x 560 with 300px of keys) leaves
       only a sliver of paper between the header and the box: then, while
       typing, the header fades (opacity and visibility only, in the CSS, so
       nothing moves) and the close-up has the top of the screen too */
    var ROOM = 80, roomy = false;
    function setRoomy(on) {
      if (roomy === on) return;
      roomy = on;
      root.classList.toggle("is-roomy", on);
    }

    /* the page glides (house easing, 0.3s), and stops if they touch it */
    var glideRaf = 0;
    function glideTo(y) {
      cancelAnimationFrame(glideRaf);
      y = Math.max(0, Math.round(y));
      var from = window.scrollY || 0, dy = y - from;
      if (Math.abs(dy) < 2) return;
      if (REDUCED) { window.scrollTo(0, y); return; }
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / 300);
        window.scrollTo(0, from + dy * ease(p));
        if (p < 1) glideRaf = requestAnimationFrame(step);
      })(t0);
    }
    ["touchstart", "wheel"].forEach(function (ev) {
      window.addEventListener(ev, function () { cancelAnimationFrame(glideRaf); }, { passive: true });
    });

    /* keep the box being typed in above the keyboard (as Our Favourite's
       old page does), and put the page back where it was when typing ends.
       The words keep the line under their box clear too: what's wrong, the
       ending and the swap buttons are read and tapped while typing */
    var typedFrom = null, kbSeen = false, baseVV = vvH(), wordsFoot = q(".tt-ws__wordsfoot"), nameFoot = q(".tt-ws__namefoot");
    function kbUp() { return vvH() < baseVV - 120; }
    function clearOfKeyboard() {
      var el = typing() && typingEl();
      if (!el) return;
      var vTop = vvTop(), vH = vvH();
      var foot = el === phraseIn ? wordsFoot : el === nameIn ? nameFoot : (el === snameIn || el === snumIn) ? q(".tt-ws__shirtfoot") : el.classList.contains("js-txin") ? el.parentNode : null;
      var fr = (foot || el).getBoundingClientRect(), dy = 0;
      if (fr.bottom > vTop + vH - 12) dy = fr.bottom - (vTop + vH - 12);
      if (Math.abs(dy) > 2) glideTo((window.scrollY || 0) + dy);
    }
    var zoomT = 0, vvT = 0, lingerT = 0;
    /* (v3.35, Ally: "no need to zoom in when typing ... remove for everything") the box kept above the keyboard, no close-up */
    function zoomInSoon(wait) {
      clearTimeout(zoomT);
      zoomT = setTimeout(function () { zoomT = 0; clearOfKeyboard(); }, wait);
    }
    function endTyping() {
      clearTimeout(zoomT); clearTimeout(vvT); clearTimeout(lingerT); zoomT = 0;
      kbSeen = false;
      setRoomy(false);
      zoomTo(REST);
      if (typedFrom != null) { var y = typedFrom; typedFrom = null; glideTo(y); }
    }
    function onTypingFocus() {
      if (!tabsMode()) return;
      if (typedFrom == null) typedFrom = window.scrollY || 0;
      baseVV = Math.max(baseVV, vvH());
      kbSeen = kbUp();
      zoomInSoon(320);
    }
    function onTypingBlur() {
      clearTimeout(zoomT); zoomT = 0;
      if (!tabsMode()) {
        /* a computer: the words close-up eases out once they've left the box */
        clearTimeout(lingerT);
        lingerT = setTimeout(function () { if (!typingEl()) zoomTo(REST); }, 300);
        return;
      }
      zoomT = setTimeout(function () { zoomT = 0; if (!typingEl()) endTyping(); }, 250);
    }
    [ageIn, phraseIn, nameIn, snameIn, snumIn].forEach(function (el) {
      if (!el) return;
      el.addEventListener("focus", onTypingFocus);
      el.addEventListener("blur", onTypingBlur);
      /* Enter: on a phone it closes the keyboard; on a computer, once the
         answer's in, it's the ink button (focus goes to it, the page stays put) */
      el.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        e.preventDefault();
        if (tabsMode()) { el.blur(); return; }
        if (goAct && stepOk(S.tab)) { go.focus({ preventScroll: true }); goAct(); }
      });
    });
    function onViewport() {
      if (!typing()) {
        if (typedFrom == null && !kbUp()) baseVV = Math.max(baseVV, vvH());
        return;
      }
      if (kbUp()) {
        kbSeen = true;
        clearTimeout(vvT);
        vvT = setTimeout(function () { zoomInSoon(0); }, 80);
      } else if (kbSeen) {
        /* the keyboard went away (Android's back key, "hide keyboard") with
           the box still focused: typing's over, so the close-up ends too */
        var el = typingEl();
        if (el) el.blur();
      }
    }
    if (window.visualViewport) window.visualViewport.addEventListener("resize", onViewport);
    /* the words: in close on each keystroke, back out 1.6s after the last */
    /* (v3.35) no close-up on each keystroke any more: the paper stays as they set it (close up or whole sheet) */
    function wordsCloseUp() {}

    /* ── the steps: one question at a time ──
       ORDER is the open design's questions (its own, then "which size?");
       "‹ back" goes one back (from the first, to the wraps: home), and the
       step bar to any before it. A side trip (none now) returns to the step
       it left (S.ret) on "back", the ink "done" or Escape. Every step sits in
       one place of one fixed height, so a change never moves the paper */
    var ORDER = [];
    function stepsFor(d) { return d.kind.steps.concat(ORDER_STEPS); }
    function asidesFor(d) { return (d.kind.aside || []).slice(); }
    function isAside(name) { return !!name && ORDER.indexOf(name) < 0; }
    function stepEl(name) { return steps.filter(function (s) { return s.dataset.step === name; })[0] || null; }
    function headOf(name) { var s = stepEl(name); return s ? s.querySelector(".tt-ws__h2") : null; }
    /* a step's side offset (--from), set at once, with no slide to it */
    function setFrom(s, px) {
      s.style.transition = "none";
      if (px) s.style.setProperty("--from", px + "px"); else s.style.removeProperty("--from");
      void s.offsetWidth;
      s.style.transition = "";
    }
    /* is a step answered (for d; the open design unless said) */
    function stepOk(name, d) {
      d = d || D;
      if (name === "faces") return facesFor(d).length > 0;
      if (name === "age") return !!SHARED.age;
      if (name === "words") return phraseOk(d);
      if (name === "name") return nameOk(d);
      if (name === "texts") return textsOk(d);                  /* (v3.58) */
      if (name === "couples") return true;                      /* (v3.62) couple 1 is there from the start */
      if (name === "shirt") return shirtOk(d);
      if (name === "colour") return true;                        /* (v3.40) it has its design's own colour to start */
      if (name === "size") return d === D ? !!variant() : true;
      return true;
    }
    /* where a design opens: the step they were on (its first, if it hasn't
       that one), or the first before it that's still to answer */
    function landing(d, from) {
      var flow = stepsFor(d), at = from ? flow.indexOf(from) : 0;
      if (at < 0) at = 0;
      for (var i = 0; i < at; i++) if (!stepOk(flow[i], d)) return flow[i];
      return flow[at];
    }
    /* a step slides in from the way they're going (forward: from the right),
       the old one out the other way; both fade. Focus that was in the old
       step goes to the new one's heading (else it would be lost) */
    function showStep(name, dir) {
      var a = document.activeElement, had = a && stepsBox && stepsBox.contains(a) ? a : null;
      S.tab = name;
      P().seen[name] = true;
      steps.forEach(function (s) {
        var on = s.dataset.step === name, was = s.classList.contains("is-on");
        if (on && !was) { clearTimeout(s.ttFromT); setFrom(s, REDUCED ? 0 : dir * 14); }
        else if (!on && was) {
          if (!REDUCED) s.style.setProperty("--from", (-dir * 14) + "px");
          /* once it's slid out (0.2s) it goes back to its place: hidden off
             to the side, it could make the page wider than a phone */
          clearTimeout(s.ttFromT);
          s.ttFromT = setTimeout(function () { if (!s.classList.contains("is-on")) setFrom(s, 0); }, 240);
        }
        s.classList.toggle("is-on", on);
      });
      syncNav();
      var h = headOf(name);
      if (had && !stepEl(name).contains(had) && h) h.focus({ preventScroll: true });
      if (h) announce(h.textContent.trim());
      if (name === "age" || name === "hat" || name === "faces") hatEdit();
      if (name === "faces") figEdit();                            /* (v3.49) */
      paint();
    }
    function goStep(name) {
      if (!name || name === S.tab || !stepEl(name)) return;
      var dir;
      if (isAside(name)) { if (!isAside(S.tab)) S.ret = S.tab; dir = 1; }
      else if (isAside(S.tab)) dir = -1;
      else dir = ORDER.indexOf(name) > ORDER.indexOf(S.tab) ? 1 : -1;
      showStep(name, dir);
    }
    function forward() { var i = ORDER.indexOf(S.tab); if (i > -1 && i < ORDER.length - 1) goStep(ORDER[i + 1]); }
    function backward() {
      if (isAside(S.tab)) { goStep(ORDER.indexOf(S.ret) > -1 ? S.ret : ORDER[0]); return; }
      var i = ORDER.indexOf(S.tab);
      if (i > 0) goStep(ORDER[i - 1]);
    }
    /* (v3.51) "‹ back" (always there, so it never moves: what it goes back to is in its name for a screen reader),
       the step bar, and the open design's side-trip links */
    function trailWord(name) { return (C.trail || {})[name] || name; }
    function syncNav() {
      if (backBtn) {
        var to = isAside(S.tab) ? S.ret : ORDER[ORDER.indexOf(S.tab) - 1];
        backBtn.setAttribute("aria-label", to ? "back to step " + (ORDER.indexOf(to) + 1) + ": " + trailWord(to) : "back to all wraps");
      }
      syncTrail();
      var asides = asidesFor(D);
      qa(".js-tweak").forEach(function (b) { b.hidden = asides.indexOf(b.getAttribute("data-to")) < 0; });
    }
    /* (v3.51) the step bar: a numbered dot and a word a step (drawn by the section for the design it opens on; made
       again here only when the steps change). The one on show (a side trip's: the step it left) is marked; one
       before it is a tap back (an answered one's dot a tick); one after it a tap forward once every step before
       it is answered, else it waits (soft, and a tap does nothing) */
    function syncTrail() {
      if (!trailEl) return;
      var key = ORDER.join(",");
      if (slice(trailEl.children).map(function (li) { return li.getAttribute("data-step"); }).join(",") !== key) {
        trailEl.textContent = "";
        ORDER.forEach(function (name, i) {
          var li = document.createElement("li"), b = document.createElement("button"), n = document.createElement("i"), w = document.createElement("span");
          li.className = "tt-ws__crumb"; li.setAttribute("data-step", name);
          b.type = "button"; b.className = "tt-ws__cbtn";
          n.textContent = String(i + 1); w.textContent = trailWord(name);
          b.appendChild(n); b.appendChild(w); li.appendChild(b); trailEl.appendChild(li);
        });
      }
      var at = ORDER.indexOf(isAside(S.tab) ? S.ret : S.tab), open = true;
      slice(trailEl.children).forEach(function (li, i) {
        /* answered as the ink button sees it (a figure design's photo step wants its name too) */
        var b = li.firstElementChild, name = li.getAttribute("data-step"), ok = stepOk(name) && !need(name);
        var on = i === at, done = i < at && ok, can = on || i < at || open;
        li.classList.toggle("is-on", on);
        li.classList.toggle("is-done", done);
        li.classList.toggle("is-wait", !can);
        if (on) b.setAttribute("aria-current", "step"); else b.removeAttribute("aria-current");
        if (can) b.removeAttribute("aria-disabled"); else b.setAttribute("aria-disabled", "true");
        var lab = "step " + (i + 1) + " of " + ORDER.length + ": " + trailWord(name) + (done ? ", done" : "");
        if (b.getAttribute("aria-label") !== lab) b.setAttribute("aria-label", lab);
        if (!ok) open = false;
      });
    }
    if (trailEl) trailEl.addEventListener("click", function (e) {
      var b = e.target && e.target.closest ? e.target.closest(".tt-ws__cbtn") : null;
      if (!b || b.getAttribute("aria-disabled") === "true" || b.hasAttribute("aria-current")) return;
      goStep(b.parentNode.getAttribute("data-step"));
    });
    /* (v3.51) the wraps: the page that opened the studio takes them back to its own (tt:ws-home, cancelled), else
       the gift wrap page (on a wrap's own page; never from the theme editor). The address keeps a preview and ?ttdev */
    function homeUrl() {
      var sp = new URLSearchParams(location.search), keep = new URLSearchParams();
      ["preview_theme_id", "ttdev"].forEach(function (k) { if (sp.has(k)) keep.set(k, sp.get(k)); });
      var qs = keep.toString();
      return (C.homeUrl || "/collections/all") + (qs ? "?" + qs : "");
    }
    /* (v3.56) on the wrap's own page, loaded afresh where a page had opened the studio in place (a reload, or back to it
       from elsewhere: its entry says ttwc "studio", with where that page's wraps were): back to that page, where they
       were (the Navigation API's entry, else its address: the Christmas page or the gift wrap page). False: it wasn't */
    function backToOpener() {
      var hs = history.state || {}, N = window.navigation;
      if (hs.ttwc !== "studio") return false;
      if (N && hs.ttGrid && typeof N.traverseTo === "function") {
        try {
          if (N.entries().some(function (en) { return en.key === hs.ttGrid; })) {
            var r = N.traverseTo(hs.ttGrid);
            if (r && r.committed) r.committed.catch(function () {});
            if (r && r.finished) r.finished.catch(function () {});
            return true;
          }
        } catch (e) {}
      }
      if (typeof hs.ttFrom === "string" && /^\/(?!\/)/.test(hs.ttFrom)) { location.assign(hs.ttFrom); return true; }
      return false;
    }
    function home() {
      var ev = null;
      try { ev = new CustomEvent("tt:ws-home", { bubbles: true, cancelable: true }); } catch (e) {}
      if (ev && !root.dispatchEvent(ev)) return;
      if (C.designMode) return;
      if (backToOpener()) return;
      location.assign(homeUrl());
    }
    function stepBack() {
      if (isAside(S.tab) || ORDER.indexOf(S.tab) > 0) backward();
      else home();
    }
    /* the open design's steps, at once (no slide: a new design isn't a step) */
    function setSteps(d, name) {
      ORDER = stepsFor(d);
      var asides = asidesFor(d);
      if (ORDER.indexOf(name) < 0 && asides.indexOf(name) < 0) name = ORDER[0];
      S.tab = name;
      P(d).seen[name] = true;
      steps.forEach(function (s) {
        var k = s.dataset.step;
        clearTimeout(s.ttFromT);
        s.style.transition = "none";
        s.style.removeProperty("--from");
        s.classList.toggle("is-off", ORDER.indexOf(k) < 0 && asides.indexOf(k) < 0);
        s.classList.toggle("is-on", k === name);
      });
      void root.offsetWidth;
      steps.forEach(function (s) { s.style.transition = ""; });
      syncNav();
    }
    if (backBtn) backBtn.addEventListener("click", stepBack);
    qa(".js-tweak").forEach(function (b) { b.addEventListener("click", function () { goStep(b.getAttribute("data-to")); }); });
    /* Escape leaves a side trip (not while "details" has it) */
    root.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !isAside(S.tab) || (det && det.contains(e.target))) return;
      e.preventDefault();
      backward();
    });
    function focusIn(el) { if (el) el.focus({ preventScroll: true }); }

    /* ── the design's address (v3.50: designs are switched only by the page that opened the studio, api.open):
       the address follows the open design ── */
    function urlFor(d) {
      if (DEV) {
        var u = new URL(location.href);
        u.searchParams.set("design", d.key);
        return u.pathname + u.search + u.hash;
      }
      var pt = new URLSearchParams(location.search).get("preview_theme_id");
      return (d.product.url || location.pathname) + (pt ? "?preview_theme_id=" + encodeURIComponent(pt) : "");
    }

    /* ── switching design, in place ── */
    var baseTitle = document.title, baseName = C.page && C.page.title, shopName = C.shop || "";
    function titleFor(d) {
      if (baseName && baseTitle.indexOf(baseName) > -1) return baseTitle.replace(baseName, d.name);
      return d.name + (shopName ? " – " + shopName : "");
    }
    var colourNow = C.openColour || "", paintT = 0, booted = false;
    /* (v3.57, Ally: "christmas wraps on christmas page, red background product page (if possible)") a page that opens the studio in place may give it its own page colour (data-ws-colour: the
       Christmas page's red); every design then shows on that colour, and the design's own (the wraps' pink) is kept for
       its own page and the gift wrap page */
    var pageColour = root.getAttribute("data-ws-colour") || "";
    function look(d) {
      d = pageColour ? Object.assign({}, d, { colour: pageColour }) : d;
      root.style.setProperty("--bg", d.colour);
      root.style.setProperty("--ink", d.ink || "#333333");
      if (d.colour && d.colour !== colourNow) {
        colourNow = d.colour;
        /* the page colour glides (0.3s, with the paper's cross-fade); the
           header reads the new colour from html/body by itself */
        if (booted && !REDUCED) {
          html.classList.add("tt-ws-paint");
          clearTimeout(paintT);
          paintT = setTimeout(function () { html.classList.remove("tt-ws-paint"); }, 450);
        }
        html.style.backgroundColor = d.colour;
        document.body.style.backgroundColor = d.colour;
      }
      if (nameEl) nameEl.textContent = d.name;
      if (artImg) {
        var pic = artImg.parentNode;
        if (d.titleSrc) { if (artImg.getAttribute("src") !== d.titleSrc) artImg.src = d.titleSrc; pic.hidden = false; }
        else pic.hidden = true;
      }
      document.title = titleFor(d);
    }
    function showDesign(d, o) {
      var prev = booted ? D : null;
      if (prev && prev !== d) P(prev).variant = S.variant;
      /* the step it opens on: where they were (from a side trip, the step it
         left), or the first before it still to answer; the first on arrival */
      var from = booted ? (isAside(S.tab) ? S.ret : S.tab) : null;
      var a = document.activeElement, hadFocus = !!(a && stepsBox && stepsBox.contains(a));
      clearTimeout(saveT); clearTimeout(lingerT); clearTimeout(zoomT); zoomT = 0;
      S.zoom = { from: NO_ZOOM, to: REST, t0: 0 }; S.anim = null;
      closeClass();
      setRoomy(false);
      D = d;
      var p = P(d);
      p.openedAt = performance.now();
      root.dataset.engine = d.engine;
      look(d);
      prefetchHats(d);
      if (d.engine === "hat") buildHats(d);
      placeEditor(d);
      if (d.engine === "santa") buildPapers(d);
      syncIdeaCols(d);                                           /* (v3.40; v3.46: hides the colour row on the others) */
      syncPerFace(d);                                            /* (v3.47) */
      syncCouples(d);                                            /* (v3.62) */
      syncTexts(d);                                              /* (v3.58) */
      syncNames(d);                                              /* (v3.63) */
      figParts();                                                /* (v3.58) */
      syncPattern();
      syncFsize();                                               /* (v3.41) */
      syncTiles();
      if (phraseIn && d.engine === "phrase") {
        /* their name (from the page that opened the studio, or typed on The Cheerful) makes the
           phrase, while it's still the one made from their name */
        if (!p.own && (!p.phrase || p.phrase === p.auto)) { var made = autoPhrase(d); if (made || !SHARED.name) p.phrase = p.auto = made; }
        syncWords();
      }
      if (d.engine === "cheerful" || isNamed(d)) syncName();
      if (d.engine === "shirt") syncShirt();
      if (isHatLike(d.engine)) { EDS.forEach(function (ed) { ed.z = 0; }); hatEdit(); }
      var swap = buildSizes();
      /* (v3.34) a design reopened on its own page lands on the step they were on */
      var land = landing(d, from);
      if (o && o.tab && stepsFor(d).indexOf(o.tab) > -1) land = o.tab;
      setSteps(d, land);
      /* focus that was in the picker goes to the step it opens on */
      if (hadFocus && !stepEl(S.tab).contains(document.activeElement)) { var h = headOf(S.tab); if (h) h.focus({ preventScroll: true }); }
      ensureEngine(d);
      hideMsg();
      lastReady = null;
      drawNow();                                      /* this is the view transition's new picture */
      maybeIntro();
      resume();
      /* a size they picked that this design doesn't sell: said */
      p.sizeNote = !!(swap && booted);
      if (swap && booted) {
        showMsg(String(d.copy.sizeSwap || "").replace("{design}", d.name).replace("{size}", shortSize(swap.want)).replace("{to}", shortSize(swap.to)), 7000, "size");
      }
      /* what happened while it wasn't open: a cutout that failed, its own add that failed */
      if (d.kind.faces && S.cutMsg) { showMsg(S.cutMsg); S.cutMsg = ""; }
      if (p.addMsg) { showMsg(p.addMsg); p.addMsg = ""; }
      paint();
    }
    var vtNow = null, going = null;
    function switchTo(d, how) {
      how = how || {};
      if (!d || d === D || d === going) return;
      going = d;
      try {
        if (how.push) history.pushState(Object.assign({}, history.state, { ttws: d.key }), "", urlFor(d));
        else if (how.replace) history.replaceState(Object.assign({}, history.state, { ttws: d.key }), "", urlFor(d));
      } catch (e) {}
      var run = function () {
        if (going === d) going = null;
        if (D === d) return;
        showDesign(d, how);
      };
      if (REDUCED || how.animate === false || typeof document.startViewTransition !== "function" || document.visibilityState !== "visible") { run(); return; }
      /* only the paper cross-fades (the CSS names it, and only it, while
         html has tt-ws-vt); everything else changes at once */
      html.classList.add("tt-ws-vt");
      var t = null;
      try { t = document.startViewTransition(run); } catch (e) { t = null; }
      if (!t) { html.classList.remove("tt-ws-vt"); run(); return; }
      vtNow = t;
      var done = function () { if (vtNow === t) { vtNow = null; html.classList.remove("tt-ws-vt"); } };
      t.finished.then(done, done);
      if (t.ready) t.ready.catch(function () {});
      if (t.updateCallbackDone) t.updateCallbackDone.catch(function () {});
    }
    window.addEventListener("popstate", function (e) {
      if (!root.isConnected) return;
      /* (v3.56) on its own page, loaded afresh where a page had opened it in place: the browser counts the opener's
         entries as this page's own, so going back to the opener's wraps (its ttwc "grid" entry) only changes the
         address here. That page is loaded instead, and opens where they were */
      if (e.state && e.state.ttwc === "grid" && !root.closest("[data-tt-wc]")) { location.reload(); return; }
      var d = byKey(e.state && e.state.ttws);
      if (d && d !== D) switchTo(d, { push: false });
    });

    /* ── faces: this visit's, in memory only (shared by every design) ── */
    var busyLines = String(copy.busy || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean);
    var busyT = 0, tiles = {};
    function setBusy(on) {
      S.busy = on;
      clearInterval(busyT);
      if (on) {
        var i = 0;
        busyTxt.textContent = busyLines[0] || "";
        busyT = setInterval(function () { i = Math.min(i + 1, busyLines.length - 1); busyTxt.textContent = busyLines[i] || ""; }, 1800);
      }
      paint();
    }
    function pick() {
      if (S.busy || !fileIn || !D.kind.faces) return;
      fileIn.value = "";
      fileIn.click();
    }
    if (fileIn) fileIn.addEventListener("change", function () { var f = fileIn.files && fileIn.files[0]; if (f) handle(f); });
    function handle(file) {
      if (S.busy || !file || !D.kind.faces) return;
      hideMsg();
      S.cutMsg = "";
      setBusy(true);
      announce(busyLines[0] || "");
      K.cutout(file, { maxMB: C.maxMB || 12 }).then(function (r) {
        return K.loadImage(r.src, !r.test).then(function (img) {
          /* (v3.12) several people in the cut-out: each their own face; else as before */
          return (K.split ? K.split(r, img) : Promise.resolve(null)).then(function (g) {
            setBusy(false);
            if (g) { addGroup(g); keepFaces(g.faces); }
            else { var nf = { img: img, src: r.src, c: r.c, o: r.o, test: r.test }; addFace(nf); keepFaces([nf]); }
          });
        });
      }).catch(function (e) {
        setBusy(false);
        /* said on a design with faces; one without keeps it until one is shown */
        if (D.kind.faces) showMsg(K.friendly(e));
        else S.cutMsg = K.friendly(e);
      });
    }
    function addTile(f, animate) {
      if (!tray || tiles[f.key]) return;
      var b = document.createElement("button");
      b.type = "button"; b.className = "tt-ws__face";
      b.setAttribute("aria-label", copy.face || "use this face");
      b.setAttribute("aria-pressed", facesFor().indexOf(f) > -1 ? "true" : "false");
      var im = document.createElement("img");
      im.alt = ""; im.decoding = "async"; im.src = f.src;
      b.appendChild(im);
      b.addEventListener("click", function () {
        if (isMix()) toggleFace(f);
        else if (SHARED.face !== f) useFace(f);
      });
      tiles[f.key] = b;
      /* (v3.14) a saved face now in use: its tile becomes this face's, where it stands */
      var sv = savedTile(f.key);
      if (sv) {
        b.style.animation = "none";
        delete svEls[sv.dataset.sid];
        tray.replaceChild(b, sv);
        tray.classList.add("has-faces");
        return b;
      }
      /* after the camera and the faces already there: nothing moves (a new one pops in) */
      if (!animate) b.style.animation = "none";
      tray.appendChild(b);
      tray.classList.add("has-faces");
      return b;
    }

    /* ── (v3.14) my personalisation: their saved faces (signed in), and saving new ones ── */
    var keepEl = q(".js-keep"), signupEl = q(".js-signup"), svEls = {};
    function MP() { var m = window.TTMyPersonalisation; return m && m.signedIn ? m : null; }
    function keepOn() { return !!MP() && (keepEl ? keepEl.checked : SHARED.keep !== false); }
    if (keepEl) {
      if (SHARED.keep === false) keepEl.checked = false;
      keepEl.addEventListener("change", function () { SHARED.keep = keepEl.checked; });
    }
    /* sign-in, and back to this page as it is now (the address follows the design on show) */
    if (signupEl) signupEl.addEventListener("click", function () {
      var m = window.TTMyPersonalisation;
      if (m && m.signInUrl) signupEl.href = m.signInUrl();
    });
    /* new faces to the account while the tick is on (never a test face; each once) */
    function keepFaces(fs) {
      var m = MP();
      if (!m || !keepOn()) return;
      (fs || []).forEach(function (f) {
        f = (f && f.key && faceByKey(f.key)) || f;
        if (!f || f.test || !f.c || f.kept) return;
        f.kept = true;
        m.add({ type: "face", url: f.c, originalUrl: f.o || "" });
      });
    }
    /* a small picture of a saved cut-out (Cloudinary makes it; the tile falls back to the cut-out itself) */
    function thumbOf(u) {
      return /^https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(u) ? u.replace("/image/upload/", "/image/upload/c_limit,w_160/") : u;
    }
    function savedTile(key) {
      for (var id in svEls) if (svEls[id]._item && svEls[id]._item.url === key) return svEls[id];
      return null;
    }
    /* the saved faces to show: theirs, newest first, not already this visit's (twelve at most) */
    function savedFaces() {
      var m = MP();
      return m ? m.list("face").filter(function (it) { return it.url && !faceByKey(it.url); }).slice(0, 12) : [];
    }
    function bindSaved(el, it) {
      el._item = it;
      var pickB = el.querySelector(".tt-ws__face"), im = el.querySelector("img");
      /* only hidden: never take something off an account over a picture that didn't load */
      if (im) im.addEventListener("error", function () {
        var full = el._item && el._item.url;
        if (full && im.getAttribute("src") !== full) im.src = full;
        else el.hidden = true;
      });
      pickB.addEventListener("click", function () { useSaved(el); });
    }
    function makeSaved(it) {
      var el = document.createElement("span");
      el.className = "tt-ws__sv js-sv"; el.dataset.sid = it.id;
      var b = document.createElement("button");
      b.type = "button"; b.className = "tt-ws__face tt-ws__face--saved";
      var im = document.createElement("img");
      im.alt = ""; im.decoding = "async"; im.src = thumbOf(it.url);
      b.appendChild(im);
      el.appendChild(b);                             /* (v3.30) no x: the account page's */
      bindSaved(el, it);
      return el;
    }
    /* the section's saved tiles, each with its item (before faces handed over are added) */
    function indexSaved() {
      var m = MP(), all = {};
      if (!m) return;
      m.list("face").forEach(function (it) { all[it.id] = it; });
      qa(".js-sv").forEach(function (el) {
        var id = el.dataset.sid;
        if (all[id] && !svEls[id]) { svEls[id] = el; bindSaved(el, all[id]); }
      });
    }
    /* the tray's saved faces in step with the account: only what changed is touched */
    function renderSaved() {
      if (!tray || !addBtn || !root.isConnected) return;
      var list = savedFaces(), byId = {};
      list.forEach(function (it) { byId[it.id] = it; });
      /* the section's (first time) and ours: kept if still saved, else gone */
      qa(".js-sv").forEach(function (el) {
        var id = el.dataset.sid, it = byId[id];
        if (!it) { if (!el.classList.contains("is-loading")) { el.remove(); delete svEls[id]; } return; }
        if (!svEls[id]) { svEls[id] = el; bindSaved(el, it); }
        else el._item = it;
      });
      /* in the account's order, straight after the camera */
      var after = addBtn;
      list.forEach(function (it, i) {
        var el = svEls[it.id];
        if (!el) el = svEls[it.id] = makeSaved(it);
        if (after.nextSibling !== el) tray.insertBefore(el, after.nextSibling);
        el.querySelector(".tt-ws__face").setAttribute("aria-label", "use saved face " + (i + 1));
        after = el;
      });
      tray.classList.toggle("has-faces", SHARED.faces.length > 0 || list.length > 0);
    }
    /* a saved face, used: its cut-out (CORS, so it bakes) as a face like any other */
    function useSaved(el) {
      var it = el._item;
      if (!it || S.busy || !D.kind.faces || el.classList.contains("is-loading")) return;
      var had = faceByKey(it.url);
      if (had) { useFace(had); return; }
      hideMsg();
      el.classList.add("is-loading");
      el.setAttribute("aria-busy", "true");
      K.loadImage(it.url, true).then(function (img) {
        el.classList.remove("is-loading"); el.removeAttribute("aria-busy");
        if (!root.isConnected) return;
        addFace({ img: img, src: it.url, c: it.url, o: it.originalUrl || "", test: false, kept: true });
      }, function () {
        el.classList.remove("is-loading"); el.removeAttribute("aria-busy");
        showMsg(copy.savedFail || "", 6000, "faces");
      });
    }
    document.addEventListener("tt:mypersonalisation", renderSaved);
    function addFace(f) {
      f.key = f.c || f.src;
      var had = SHARED.faces.filter(function (x) { return x.key === f.key; })[0];
      if (had) f = had;
      else {
        SHARED.faces.push(f);
        var b = addTile(f, true);
        /* the new face (at the end) into view, the camera tile as near as it'll go */
        if (b) {
          var want = b.offsetLeft + b.offsetWidth + 6 - tray.clientWidth;
          if (want > tray.scrollLeft) tray.scrollTo({ left: want, behavior: REDUCED ? "auto" : "smooth" });
        }
      }
      useFace(f);
    }
    /* the tiles say which faces the open design uses */
    function syncTiles() {
      var on = facesFor();
      SHARED.faces.forEach(function (x) { var t = tiles[x.key]; if (t) t.setAttribute("aria-pressed", on.indexOf(x) > -1 ? "true" : "false"); });
      syncSoon();
      syncUse();
      syncPerFace();                                             /* (v3.47) the faces' choices follow the mix */
      syncCouples();                                             /* (v3.62) and the couples */
      syncNames();                                               /* (v3.63) and the faces' names */
    }
    /* (v3.5) the tools under the upload: the open design's, greyed out and inert until it has
       a face, then live (the same controls as their own step's). Only opacity changes. (v3.9)
       The hat designs' editor there is live from the start (on the sample face till theirs is
       in); only the hats row or the paper colours beside it wait for a face */
    function syncSoon() {
      if (!soonEl) return;
      var awake = !!D.kind.faces && facesFor().length > 0, hatLike = isHatLike(D.engine);
      soonEl.classList.toggle("is-awake", awake);
      soonEl.classList.toggle("is-hat", hatLike);
      if (awake || hatLike) soonEl.removeAttribute("inert"); else soonEl.setAttribute("inert", "");
      if (hside) { if (awake) hside.removeAttribute("inert"); else hside.setAttribute("inert", ""); }
      if (hsoon) hsoon.hidden = !hatLike;
      if (hatLike) { hatThumbsSoon(); hatEdit(); }
      figSync();                                                 /* (v3.49) */
    }
    /* a design that takes several faces: a tap adds the face to its mix or
       takes it out (never the last one; five at most) */
    function toggleFace(f) {
      var p = P(), cur = facesFor().map(function (x) { return x.key; }), i = cur.indexOf(f.key);
      if (i > -1) {
        if (cur.length < 2) return;
        cur.splice(i, 1);
      } else {
        if (cur.length >= D.kind.faces) { showMsg(copy.facesMax, 5000, "faces"); return; }
        cur.push(f.key);
      }
      if (msg.dataset.kind === "faces") hideMsg();
      p.picked = cur;
      syncTiles();
      ripple(45);
      changed();
      announce(f.test ? (copy.test || "") : i > -1 ? "face taken out" : "face added");
    }
    function useFace(f) {
      /* (v3.12) the hats: a new face (or a tap on one) is the one face again; "use" adds more. (v3.44, Ally: "when
         changing photo & going into a wrap, it goes back to the first image uploaded") the mixes too (the idea wraps,
         The Classic, The All-Over): a new photo or a saved face is the one face again, where it used to join the mix
         behind the first; a tap on a face in the row still adds it */
      designs.forEach(function (d) { if (d.kind.multi || isMix(d)) P(d).picked = null; });
      seenFaceKey = f.key;
      /* (v3.9) a hat placed on the face that was in use (or the sample face) sits the same on
         the new face's head: the hat engine moves it by each face's measured head */
      designs.forEach(function (d) {
        var p = P(d), e = isHatLike(d.engine) && eng(d);
        if (p.place && e && e.rebase && SHARED.face !== f) p.place = e.clampPlace(e.rebase(p.place, SHARED.face, f), { face: f, hat: p.hat });
      });
      SHARED.face = f;
      syncTiles();
      /* every other design with faces saves afresh when it's next shown (a
         save of the old face that's still going lets go when it lands); a
         design without faces is left be, saves and all */
      designs.forEach(function (d) {
        if (d !== D && d.kind.faces) { var p = P(d); p.saving = null; p.fails = 0; p.offerRetry = false; }
      });
      if (!D.kind.faces) return;
      ripple(45);
      changed();
      announce(f.test ? (copy.test || "") : "face added");
    }
    /* (v3.12) a group photo: every face found, each ticked in every design that takes several
       (a mix, a hat's), face 1 the one in use; the message says how many */
    function addGroup(g) {
      var keys = [];
      g.faces.forEach(function (f) {
        f.key = f.c || f.src;
        var had = faceByKey(f.key);
        if (!had) { SHARED.faces.push(f); addTile(f, true); }
        keys.push(f.key);
      });
      useFace(faceByKey(keys[0]));
      SHARED.group = { keys: keys.slice(), n: (SHARED.group ? SHARED.group.n : 0) + 1 };
      seenGroup = SHARED.group.n;
      pickGroup(keys);
      var t = g.capped ? copy.foundMax : copy.found;
      showMsg(String(t || "").replace("[n]", g.found).replace("[max]", keys.length), 9000, "faces");
      announce(String(copy.found || "").replace("[n]", g.found));
      if (tray) { var last = tiles[keys[keys.length - 1]]; if (last) { var want = last.offsetLeft + last.offsetWidth + 6 - tray.clientWidth; if (want > tray.scrollLeft) tray.scrollTo({ left: want, behavior: REDUCED ? "auto" : "smooth" }); } }
    }
    var seenGroup = 0;
    var seenFaceKey = null;                                      /* (v3.44) the face in use when the studio last showed (sync) */
    function pickGroup(keys) {
      designs.forEach(function (d) { if (d.kind.faces > 1 || d.kind.multi) P(d).picked = keys.slice(0, faceCap(d)); });
      designs.forEach(function (d) { if (d !== D && d.kind.faces) { var p = P(d); p.saving = null; p.fails = 0; p.offerRetry = false; } });
      syncTiles();
      if (D.kind.faces) { ripple(45); changed(); }
    }
    /* (v3.12) "use: face 1 · face 2 · ..." under the hat editor: which faces are on a hat wrap;
       (v3.39) their heads, each face's own cut-out (faded till it's on, the ink tick when it is) */
    var useEls = qa(".js-use");
    function syncUse() {
      if (!useEls) return;
      var on = isHatLike(D.engine) && SHARED.faces.length > 1, cur = facesFor();
      useEls.forEach(function (el) {
        el.hidden = !on;
        if (!on) return;
        var bs = slice(el.querySelectorAll("button"));
        while (bs.length < SHARED.faces.length) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "tt-ws__usef";
          b.addEventListener("click", function () { useToggle(+this.dataset.i); });
          el.appendChild(b); bs.push(b);
        }
        bs.forEach(function (b, i) {
          var f = SHARED.faces[i];
          b.hidden = !f;
          if (!f) return;
          b.dataset.i = i;
          var im = b.querySelector("img");
          if (!im) { im = document.createElement("img"); im.alt = ""; im.decoding = "async"; b.appendChild(im); }
          if (im.getAttribute("src") !== f.src) im.src = f.src;
          b.setAttribute("aria-label", "face " + (i + 1));
          b.setAttribute("aria-pressed", cur.indexOf(f) > -1 ? "true" : "false");
        });
      });
    }
    function useToggle(i) {
      var f = SHARED.faces[i], e = eng(D);
      if (!f) return;
      var was = facesFor(), cur = was.map(function (x) { return x.key; }), at = cur.indexOf(f.key);
      if (at > -1) { if (cur.length < 2) return; cur.splice(at, 1); }
      else { if (cur.length >= faceCap()) { showMsg(copy.facesMax, 5000, "faces"); return; } cur.push(f.key); }
      var p = P();
      /* the hat stays where it was on the head when face 1 changes */
      if (p.place && e && e.rebase && was[0] && was[0].key !== cur[0]) p.place = e.clampPlace(e.rebase(p.place, was[0], faceByKey(cur[0])), { face: faceByKey(cur[0]), hat: p.hat });
      p.picked = cur;
      syncTiles();
      ripple(45);
      changed();
      hatEdit(); hatThumbsSoon();
      announce(at > -1 ? "face taken off the wrap" : "face on the wrap");
    }
    indexSaved();                                                 /* (v3.14) the section's saved faces, so a face handed over takes its tile */
    SHARED.faces.forEach(function (f) { addTile(f, false); });   /* faces handed over from the page that opened the studio */
    renderSaved();
    if (addBtn) addBtn.addEventListener("click", pick);
    paper.addEventListener("click", function () {
      if (D.kind.faces && !facesFor().length && !S.busy) pick();
    });
    /* a photo dragged over the paper or the upload area: each lights up itself (v3.5: the
       upload area brightens with a solid white edge; the paper keeps its outline) */
    function dropZone(el, cls) {
      if (!el) return;
      ["dragenter", "dragover"].forEach(function (ev) {
        el.addEventListener(ev, function (e) { if (!D.kind.faces) return; e.preventDefault(); el.classList.add(cls); });
      });
      ["dragleave", "drop"].forEach(function (ev) {
        el.addEventListener(ev, function (e) {
          e.preventDefault();
          if (ev === "dragleave" && e.relatedTarget && el.contains(e.relatedTarget)) return;    /* onto its own camera or words */
          el.classList.remove(cls);
        });
      });
      el.addEventListener("drop", function (e) { handle(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]); });
    }
    dropZone(paper, "is-drag"); dropZone(dropEl || tray, "is-over");

    /* ── hat and age ── */
    var hatsFor = null;
    /* the hat rows: "how old?"'s, and (v3.5) the one under the upload on "who's it for?" */
    function hatRows() { return [hatsEl, hats2].filter(Boolean); }
    function buildHats(d) {
      if (!hatsEl) return;
      if (hatsFor !== d) {
        hatsFor = d;
        hatRows().forEach(function (row) { row.textContent = ""; });
        hatRows().forEach(function (row) { d.hats.forEach(function (h, i) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "tt-ws__hat";
          b.setAttribute("aria-label", h.name);
          /* the hat on its own until it can be drawn on their face (hatThumbs) */
          var im = document.createElement("img");
          im.alt = ""; im.width = 64; im.height = 64; im.decoding = "async"; im.src = h.thumb || h.src;
          var cvh = document.createElement("canvas"); cvh.className = "tt-ws__hatthumb"; cvh.hidden = true;
          b.appendChild(im); b.appendChild(cvh);
          /* its artwork comes as soon as it's wanted */
          var want = function () { var e = eng(D); if (e) e.prefetch(i); };
          b.addEventListener("pointerenter", want);
          b.addEventListener("focus", want);
          b.addEventListener("touchstart", want, { passive: true });
          b.addEventListener("click", function () {
            want();
            var p = P();
            /* (v3.22) tick or untick; one always stays; every face in every hat, at most five */
            var hs = p.hats && p.hats.length ? p.hats.slice() : [p.hat];
            var at = hs.indexOf(i);
            if (at > -1) {
              if (hs.length === 1) return;
              hs.splice(at, 1);
            } else {
              var nf = Math.max(1, (shown().faces || []).length);
              if (nf * (hs.length + 1) > 5) {
                announce("5 pictures is the most on one wrap");
                b.classList.remove("is-full"); void b.offsetWidth; b.classList.add("is-full");
                showFull(b);
                return;
              }
              hs.push(i);
            }
            p.hats = hs; p.hat = hs[0];
            syncHats();
            ripple(14);
            changed();
            hatEdit();
          });
          row.appendChild(b);
        }); });
      }
      syncHats();
    }
    function syncHats() {
      hatRows().forEach(function (row) {
        var hs = P().hats && P().hats.length ? P().hats : [P().hat];
        slice(row.children).forEach(function (x, j) { x.setAttribute("aria-pressed", hs.indexOf(j) > -1 ? "true" : "false"); });
      });
      hatThumbsSoon();
    }
    /* each hat in the row, worn on their face (or the sample face) with their age and
       placement, once its artwork is in: redrawn a moment after anything in it changes */
    var thumbT = 0;
    /* (v3.22) "5 pictures is the most": a small note over the hat row for 2s */
    var fullT = 0;
    function showFull(b) {
      var row = b.parentNode && b.parentNode.parentNode; if (!row) return;     /* (beside the row, not in it: the row's children are its hats) */
      var n = row.querySelector(".tt-ws__full");
      if (!n) { n = document.createElement("span"); n.className = "tt-ws__full"; n.setAttribute("aria-hidden", "true"); n.textContent = "5 pictures is the most on one wrap"; row.appendChild(n); }
      n.classList.add("is-on");
      clearTimeout(fullT); fullT = setTimeout(function () { slice(document.querySelectorAll(".tt-ws__full")).forEach(function (x) { x.classList.remove("is-on"); }); }, 2200);
    }
    function hatThumbsSoon() { clearTimeout(thumbT); thumbT = setTimeout(hatThumbs, 120); }
    /* a picture drawn to fit (contained, centred) on a canvas the size of its box */
    function fitPic(cvh, pic, W, H, pad) {
      var dpr = density(), px = Math.round(W * dpr), py = Math.round(H * dpr);
      if (cvh.width !== px || cvh.height !== py) { cvh.width = px; cvh.height = py; }
      var x = cvh.getContext("2d"), m = (pad || 0) * dpr, k = Math.min((px - 2 * m) / pic.width, (py - 2 * m) / pic.height);
      x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, px, py);
      x.imageSmoothingQuality = "high";
      x.drawImage(pic, (px - pic.width * k) / 2, (py - pic.height * k) / 2, pic.width * k, pic.height * k);
    }
    function hatThumbs() {
      var e = isHatLike(D.engine) && eng(D);
      if (!e || !e.hatFace) return;
      var s = shown();
      /* (the hat rows are The Party Hat's; The Santa Hat has one hat) */
      if (D.engine === "hat") hatRows().forEach(function (row) {
        if (!row.clientWidth) return;                 /* a row that isn't laid out (its step is another design's) */
        slice(row.children).forEach(function (b, i) {
          var cvh = b.querySelector("canvas"), im = b.querySelector("img");
          if (!cvh || !e.hasArt(i)) { if (e.prefetch) e.prefetch(i); return; }
          var pic = e.hatFace({ face: s.face, hat: i, age: s.age, place: s.place });
          fitPic(cvh, pic, b.clientWidth || 56, b.clientHeight || 56, 0);
          cvh.hidden = false; if (im) im.hidden = true;
        });
      });
    }

    /* ── the hat editor (v3.4; v3.9: wherever it's shown): their face in the hat, like the
       face confetti's accessories: drag to move, pinch (two fingers: size, and turn after a 5°
       twist), a corner to size, the knob to turn, "reset" for the default. The same limits as
       confetti (the engine's clampPlace: 8% to 220% of the face's width, a turn either way,
       and the hat-face still fits its cell). It shows the whole hat-face, zooming out as the
       hat goes higher or bigger than the box (never in, while it's held: in again once let
       go). (v3.9, Ally: "can it just move it there?") There are two editors: the one in "how
       old?" / "your hat", with the size and tilt sliders beside it, and the one under the
       upload on "who's it for?", live there too (on the sample face before a photo: where the
       hat's put carries over to their face). Nothing in either goes to another step. Both
       show and change the one placement (P().place, kept when switching designs; one for
       every hat), which is what's baked into "_Hat face". Each keeps only its own view (zoom).
       Touch on an editor never scrolls the page (touch-action: none) ── */
    var EDS = qa(".js-hated").map(function (el) {
      return { fit: !!el.closest(".js-hfit"), el: el, cv: el.querySelector(".js-hatcv"), box: el.querySelector(".js-hbox"), reset: el.querySelector(".js-hreset"),
               z: 0, tx: 0, ty: 0, held: false, glide: null, geo: null };
    });
    var HV = { raf: 0, geo: null };                   /* (the drawing's frame; geo: the hat's box in the editor on show, for ?ttdev) */
    var hedRow = q(".js-hedrow"), hRanges = qa(".js-hrange"), hVals = qa(".js-hval");
    function hatEng() { return isHatLike(D.engine) ? eng(D) : null; }
    function hatState() { var s = shown(); return { face: s.face, hat: s.hat, age: s.age, place: s.place }; }
    /* an editor is drawn while its step is the one on show */
    function edOn(ed) {
      if (ed.fit) return FIT.open;                    /* (v3.19) the full-screen fitter: while it's open */
      var s = ed.el.closest(".tt-ws__step"); return !!s && s.dataset.step === S.tab;
    }
    var FIT = { el: q(".js-hfit"), open: false, from: null, t: 0 };
    /* room round the hat-face for the handles (more above: the turn knob stands over the hat);
       a short editor (the one under the upload, on a phone) keeps just what they need */
    function edPad(H) {
      /* (v3.13) a phone: one corner (bottom right) and the knob over the hat need only this */
      if (tabsMode()) return { t: 36, s: 10, b: 10 };
      return H >= 170 ? { t: 48, s: 26, b: 26 } : { t: 38, s: 12, b: 12 };
    }
    /* the view that shows the whole hat-face in the box: face-picture pixels -> box pixels */
    function hatFit(e, s, W, H) {
      var pic = e.hatFace(s), f = e.faceIn(s) || { x: 0, y: 0 }, m = edPad(H);
      var z = Math.min((W - 2 * m.s) / pic.width, (H - m.t - m.b) / pic.height);
      return { z: z, tx: (W - pic.width * z) / 2 + f.x * z, ty: m.t + (H - m.t - m.b - pic.height * z) / 2 + f.y * z };
    }
    function hatEdit() { if (HV && !HV.raf) HV.raf = requestAnimationFrame(hatDraw); }     /* (HV: not before the studio is set up) */
    function hatDraw() {
      HV.raf = 0;
      syncHatSliders();
      EDS.forEach(function (ed) { if (ed.reset) ed.reset.hidden = !P().place; if (edOn(ed)) edDraw(ed); });     /* ("reset" in both, drawn or not) */
    }
    function edDraw(ed) {
      var e = hatEng();
      if (!e || !e.hatFace) return;
      var W = ed.el.clientWidth, H = ed.el.clientHeight;
      if (!W || !H) return;
      var s = hatState(), dpr = density();
      var fit = hatFit(e, s, W, H);
      /* held: zoom out only (so nothing slides from under the finger unless it must) */
      if (!ed.z) { ed.z = fit.z; ed.tx = fit.tx; ed.ty = fit.ty; }
      else if (ed.held) {
        if (fit.z < ed.z) { ed.z = fit.z; ed.tx = fit.tx; ed.ty = fit.ty; }
      } else if (Math.abs(fit.z - ed.z) > 1e-4 || Math.abs(fit.tx - ed.tx) > 0.3 || Math.abs(fit.ty - ed.ty) > 0.3) {
        /* let go: glides (0.3s) to the view that fits */
        var g = ed.glide;
        if (!g || g.to.z !== fit.z || g.to.tx !== fit.tx || g.to.ty !== fit.ty) g = ed.glide = { from: { z: ed.z, tx: ed.tx, ty: ed.ty }, to: fit, t0: performance.now() };
        var t = REDUCED ? 1 : Math.min(1, (performance.now() - g.t0) / 300), k = ease(t);
        ed.z = g.from.z + (fit.z - g.from.z) * k; ed.tx = g.from.tx + (fit.tx - g.from.tx) * k; ed.ty = g.from.ty + (fit.ty - g.from.ty) * k;
        if (t < 1) hatEdit(); else ed.glide = null;
      }
      var pw = Math.round(W * dpr), ph = Math.round(H * dpr);
      if (ed.cv.width !== pw || ed.cv.height !== ph) { ed.cv.width = pw; ed.cv.height = ph; }
      var x = ed.cv.getContext("2d"), pic = e.hatFace(s), f = e.faceIn(s) || { x: 0, y: 0 };
      x.setTransform(dpr, 0, 0, dpr, 0, 0); x.clearRect(0, 0, W, H);
      x.imageSmoothingQuality = "high";
      x.drawImage(pic, ed.tx - f.x * ed.z, ed.ty - f.y * ed.z, pic.width * ed.z, pic.height * ed.z);
      /* the handles on the hat's box */
      var P0 = e.place(s), fw = (f.w || pic.width), fh = (f.h || pic.height);
      var cw = fw * P0.w * ed.z, chh = cw * e.artAr(s.hat || 0), cx = ed.tx + fw * P0.x * ed.z, cy = ed.ty + fh * P0.y * ed.z;
      ed.box.style.width = cw + "px"; ed.box.style.height = chh + "px";
      ed.box.style.setProperty("--bw", cw + "px"); ed.box.style.setProperty("--bh", chh + "px");     /* (v3.12) the handles, by transform */
      ed.box.style.transform = "translate(" + (cx - cw / 2).toFixed(2) + "px," + (cy - chh / 2).toFixed(2) + "px) rotate(" + (P0.r || 0) + "deg)";
      ed.box.hidden = !e.hasArt(s.hat || 0);
      ed.geo = HV.geo = { cx: cx, cy: cy, w: cw, h: chh, r: P0.r || 0, fw: fw, fh: fh };
    }
    /* a new placement: kept within the limits; the paper, both editors, the sliders and the
       hats row follow */
    function setPlace(np) {
      var e = hatEng(); if (!e) return;
      P().place = e.clampPlace(np, hatState());
      hatEdit(); render(); hatThumbsSoon();
      changed();
    }
    /* (v3.9, Ally: "sliders") size (the hat's width, as a % of the face's) and tilt (degrees),
       always showing the placement however it was last changed. Size has the editor's limits
       (the engine's 8% to 220%); tilt -45° to 45° (a turn past that, from the knob, rests the
       slider at its end, its value still the angle). Each move goes through clampPlace like a
       drag */
    function syncHatSliders() {
      var e = hatEng(); if (!e || !hRanges.length) return;
      var pl = e.place(hatState()), v = { w: Math.round(pl.w * 100), r: Math.round(pl.r || 0) };
      hRanges.forEach(function (r) {
        var k = r.getAttribute("data-k");
        if (+r.value !== v[k]) r.value = v[k];
        r.setAttribute("aria-valuetext", k === "w" ? v.w + "%" : v.r ? String(v.r < 0 ? copy.rotLeft : copy.rotRight).replace("[n]", Math.abs(v.r)) : "0");
      });
      hVals.forEach(function (o) { var t = o.getAttribute("data-k") === "w" ? v.w + "%" : rotText(v.r); if (o.textContent !== t) o.textContent = t; });
    }
    hRanges.forEach(function (r) {
      r.addEventListener("input", function () {
        var e = hatEng(); if (!e) return;
        var pl = e.place(hatState()), v = +r.value;
        if (r.getAttribute("data-k") === "w") pl.w = v / 100; else pl.r = v;
        setPlace(pl);
      });
    });
    var assignObj = function (o, p) { for (var k in p) o[k] = p[k]; return o; };
    EDS.forEach(function (ed) {
      var el = ed.el, hp = new Map(), hd = null;
      var pt = function (ev) { var r = el.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; };
      var start = function () {
        var e = hatEng(), g = ed.geo; if (!e || !g) return null;
        var pl = e.place(hatState()), pts = []; hp.forEach(function (v) { pts.push(v); });
        var base = { pl: pl, g: g };
        if (pts.length >= 2) {
          var a = pts[0], b = pts[1];
          return assignObj(base, { mode: "pinch", d0: Math.hypot(b.x - a.x, b.y - a.y) || 1, a0: Math.atan2(b.y - a.y, b.x - a.x), m0: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, twist: false });
        }
        return base;
      };
      el.addEventListener("pointerdown", function (ev) {
        if (!hatEng() || (ev.target.closest && ev.target.closest(".js-hreset, .js-use"))) return;     /* (v3.12: and "use") */
        ev.preventDefault();
        if (!ed.fit && FIT.el && tabsMode()) { openFit(el); return; }     /* (v3.19) a phone: the full-screen fitter */
        try { el.setPointerCapture(ev.pointerId); } catch (er) {}
        hp.set(ev.pointerId, pt(ev));
        ed.held = true;
        var h = ev.target.getAttribute && ev.target.getAttribute("data-h");
        hd = start();
        if (!hd) return;
        var p = pt(ev);
        if (hp.size >= 2) return;
        if (h === "turn") assignObj(hd, { mode: "turn", a0: Math.atan2(p.y - hd.g.cy, p.x - hd.g.cx) });
        else if (h) assignObj(hd, { mode: "size", d0: Math.hypot(p.x - hd.g.cx, p.y - hd.g.cy) || 1 });
        else assignObj(hd, { mode: "move", p0: p });
      });
      el.addEventListener("pointermove", function (ev) {
        if (!hp.has(ev.pointerId) || !hd) return;
        hp.set(ev.pointerId, pt(ev));
        var p = pt(ev), pl = hd.pl, g = hd.g, z = ed.z || 1;
        if (hd.mode === "pinch") {
          var pts = []; hp.forEach(function (v) { pts.push(v); }); if (pts.length < 2) return;
          var a = pts[0], b = pts[1], d = Math.hypot(b.x - a.x, b.y - a.y), an = Math.atan2(b.y - a.y, b.x - a.x);
          var turn = (an - hd.a0) * 180 / Math.PI; if (Math.abs(turn) > 5) hd.twist = true;
          var m = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
          setPlace({ x: pl.x + (m.x - hd.m0.x) / (z * g.fw), y: pl.y + (m.y - hd.m0.y) / (z * g.fh), w: pl.w * d / hd.d0, r: pl.r + (hd.twist ? turn : 0) });
        } else if (hd.mode === "move") {
          setPlace({ x: pl.x + (p.x - hd.p0.x) / (z * g.fw), y: pl.y + (p.y - hd.p0.y) / (z * g.fh), w: pl.w, r: pl.r });
        } else if (hd.mode === "size") {
          setPlace({ x: pl.x, y: pl.y, w: pl.w * Math.hypot(p.x - g.cx, p.y - g.cy) / hd.d0, r: pl.r });
        } else if (hd.mode === "turn") {
          var t2 = (Math.atan2(p.y - g.cy, p.x - g.cx) - hd.a0) * 180 / Math.PI;
          setPlace({ x: pl.x, y: pl.y, w: pl.w, r: ((pl.r + t2 + 540) % 360) - 180 });
        }
      });
      var up = function (ev) {
        if (!hp.has(ev.pointerId)) return;
        hp.delete(ev.pointerId);
        hd = hp.size ? start() : null;               /* one finger left of a pinch: it moves on from here */
        if (hd && !hd.mode) { var p0 = null; hp.forEach(function (v) { p0 = v; }); assignObj(hd, { mode: "move", p0: p0 }); }
        if (!hp.size) { ed.held = false; hatEdit(); }
      };
      el.addEventListener("pointerup", up);
      el.addEventListener("pointercancel", up);
      /* "reset": the hat back where it starts (both editors, the sliders and the paper follow) */
      if (ed.reset) ed.reset.addEventListener("click", function () { P().place = null; hatEdit(); render(); hatThumbsSoon(); changed(); announce("hat put back"); });
      if ("ResizeObserver" in window) new ResizeObserver(function () { hatEdit(); }).observe(el);
    });
    /* ── (v3.19) "fit the hat": full screen on a phone ── */
    var fitDone = FIT.el ? FIT.el.querySelector(".js-hfitdone") : null;
    if (FIT.el) {
      document.body.appendChild(FIT.el);             /* (over the header and everything else) */
      fitDone.addEventListener("click", function () { closeFit(); });
      FIT.el.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { e.preventDefault(); closeFit(); return; }
        if (e.key !== "Tab") return;                  /* focus stays in the fitter */
        var f = slice(FIT.el.querySelectorAll("button:not([hidden]), input")).filter(function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.addEventListener("popstate", function () { if (FIT.open) closeFit(true); });
    }
    function openFit(from) {
      if (FIT.open || !FIT.el) return;
      FIT.open = true; FIT.from = from || null;
      clearTimeout(FIT.t);
      var cs = getComputedStyle(root);
      FIT.el.style.setProperty("--bg", cs.getPropertyValue("--bg").trim() || "#f395b3");
      FIT.el.style.setProperty("--ink", cs.getPropertyValue("--ink").trim() || "#333333");
      document.documentElement.classList.add("tt-ws-fitting");
      FIT.el.hidden = false;
      FIT.el.getBoundingClientRect();                 /* (so the fade-in runs) */
      FIT.el.classList.add("is-in");
      EDS.forEach(function (ed) { if (ed.fit) ed.z = 0; });     /* (fit the view afresh) */
      hatEdit();
      try { history.pushState({ ttFit: 1 }, ""); } catch (er) {}
      setTimeout(function () { if (FIT.open) fitDone.focus({ preventScroll: true }); }, 60);
      announce("fit the hat");
    }
    function closeFit(fromBack) {
      if (!FIT.open) return;
      FIT.open = false;
      FIT.el.classList.remove("is-in");
      document.documentElement.classList.remove("tt-ws-fitting");
      FIT.t = setTimeout(function () { if (!FIT.open) FIT.el.hidden = true; }, REDUCED ? 0 : 220);
      if (!fromBack) { try { if (history.state && history.state.ttFit) history.back(); } catch (er) {} }
      hatEdit(); render();
      if (FIT.from) { try { FIT.from.setAttribute("tabindex", "-1"); FIT.from.focus({ preventScroll: true }); } catch (er) {} }
    }

    /* ── (v3.49) the face fitter (Ally: "wraps like snowman & gingerbread, they need to position their face in the first
       panel & name should be there too"): on the figure designs (kind.fit), under the upload on "who's it for?"
       (.js-fsoon), their face in its figure as the design draws it: the engine's fitInfo finds one of their figures near
       the roll's middle and the design's box round it, and its sharp drawing draws just that part, with their name and
       the figures beside it. "fit the hat"'s handling: one finger moves the face, two size and turn it (turning after a
       5° twist), a corner sizes it, the knob turns it, "reset" puts it back; it shows the whole face, zooming out while
       it's held only when it must and gliding to fit once let go. On a phone a tap opens it full screen (.js-ffit), with
       size and tilt under it, as "fit the hat". Each face its own fit (P().fits[face key] = the engine's { x, y, s, r }),
       which face is being fitted their heads under it (.js-fwho, with two or more on the wrap). While a face is held
       only the fitters redraw (FG.live); the paper follows every FIG_COMMIT ms (not under the full screen), and at once
       when it's let go. The name box (the name step's own, so its messages and rules are the same) moves in for a
       design that takes a name (placeName) ── */
    var FIG_COMMIT = 220;
    var FG = { who: 0, live: null, liveKey: "", held: false, commitT: 0, raf: 0, open: false, from: null, t: 0, part: "" };
    var fsoon = q(".js-fsoon"), fnameSlot = q(".js-fnameslot"), fwhoEls = qa(".js-fwho"), fRanges = qa(".js-frange"), fVals = qa(".js-fval");
    var FFIT = q(".js-ffit"), ffitDone = FFIT ? FFIT.querySelector(".js-ffitdone") : null;
    var FEDS = qa(".js-figed").map(function (el) {
      return { fit: !!el.closest(".js-ffit"), el: el, cv: el.querySelector(".js-figcv"), box: el.querySelector(".js-figbox"), reset: el.querySelector(".js-figreset"),
               z: 0, ox: 0, oy: 0, held: false, glide: null, geo: null, key: "" };
    });
    function figOn(d) { d = d || D; return !!(d.kind.fit && d.kind.faces); }
    function figEng() { return figOn() ? eng(D) : null; }
    /* the face being fitted (one of the faces on the wrap) */
    function fitFaces() { return isCouples() ? couplesFaces() : facesFor(); }     /* (v3.62) a couples design: each of its couples' faces */
    function figFace() { var fs = fitFaces(); if (!fs.length) return null; if (FG.who >= fs.length) FG.who = 0; return fs[FG.who]; }
    function figFitOf(f) { var p = P(); return f ? (FG.live && FG.liveKey === f.key ? FG.live : (p.fits && p.fits[f.key]) || null) : null; }
    /* ── (v3.58, Ally: "position the pud", "position antlers, nose", "move hat", "position the crown (one pos for all
       colours)", "sleigh ride, you should be able to move the hat too") what the fitter moves: the face (as ever), or a
       piece it wears, for a design that names them (its fit.pieces: [{ key, name }]; fit.face true to offer the face as
       well, else the pieces alone). A face's fit holds its own move (x, y, s, r) and each piece's (p: { key: move }, idea
       engine v1.14: baked into its figures, so the line and the print carry it). With two or more, a row of pills over
       which face (.js-fparts) picks the one being moved; the handles sit on it, and size, tilt and "reset" are its ── */
    var NO_MOVE = { x: 0, y: 0, s: 1, r: 0 };
    function figPartsList() {
      var e = figOn() ? eng(D) : null, F = (e && e.design && e.design.fit) || {}, ps = F.pieces || [];
      return (!ps.length || F.face ? [{ key: "", name: "face" }] : []).concat(ps.map(function (x) { return { key: x.key, name: x.name || x.key, tilt: x.tilt !== false, slide: !!x.slide }; }));
    }
    /* (v3.60) the part being moved's own controls: tilt (unless the design's piece says tilt: false: a round nose), and
       position sliders (its piece says slide: true) */
    function figPartOpt() { var k = figPart(), x = figPartsList().filter(function (y) { return y.key === k; })[0]; return { tilt: !x || x.tilt !== false, slide: !!(x && x.slide) }; }
    function figPart() {
      var L = figPartsList();
      if (!L.some(function (x) { return x.key === FG.part; })) FG.part = L.length ? L[0].key : "";
      return FG.part;
    }
    function figPartName(k) { var x = figPartsList().filter(function (y) { return y.key === k; })[0]; return x ? x.name : "face"; }
    function partOf(rec, k) {
      var q = !rec ? null : k ? (rec.p && rec.p[k]) : rec;
      return q ? { x: +q.x || 0, y: +q.y || 0, s: q.s == null ? 1 : +q.s, r: +q.r || 0 } : { x: 0, y: 0, s: 1, r: 0 };
    }
    function isNoMove(q) { return !q || (Math.abs(q.x) < 1e-3 && Math.abs(q.y) < 1e-3 && Math.abs(q.s - 1) < 1e-3 && Math.abs(q.r) < 0.05); }
    function withPart(rec, k, v) {
      var o = { x: 0, y: 0, s: 1, r: 0 }, n;
      if (rec) { o.x = +rec.x || 0; o.y = +rec.y || 0; o.s = rec.s == null ? 1 : +rec.s; o.r = +rec.r || 0; if (rec.p) { o.p = {}; for (n in rec.p) o.p[n] = rec.p[n]; } }
      if (k) { o.p = o.p || {}; o.p[k] = { x: v.x, y: v.y, s: v.s, r: v.r }; } else { o.x = v.x; o.y = v.y; o.s = v.s; o.r = v.r; }
      return o;
    }
    /* the pills (in the fitter beside the face and in the full screen), made for the open design */
    var fpartEls = [];
    function figParts() {
      if (typeof FG === "undefined" || !FG || !FEDS) return;     /* (not set up yet) */
      var L = figOn() ? figPartsList() : [], on = L.length > 1, cur = figPart(), ver = L.map(function (x) { return x.key + "=" + x.name; }).join(",");
      if (!fpartEls.length) fwhoEls.forEach(function (w) {
        var el = document.createElement("div");
        el.className = "tt-ws__fparts js-fparts"; el.setAttribute("role", "group"); el.setAttribute("aria-label", "what to move"); el.hidden = true;
        w.parentNode.insertBefore(el, w);
        el.addEventListener("click", function (ev) {
          var b = ev.target && ev.target.closest ? ev.target.closest("button") : null;
          if (!b || b.getAttribute("data-k") == null) return;
          var k = b.getAttribute("data-k");
          if (k === FG.part) return;
          figCommit(); FG.part = k; figParts(); figEdit(); announce("moving the " + figPartName(k));
        });
        fpartEls.push(el);
      });
      fpartEls.forEach(function (el) {
        if (el.hidden !== !on) el.hidden = !on;
        if (el.getAttribute("data-for") !== ver) {
          el.setAttribute("data-for", ver);
          el.innerHTML = L.map(function (x) { return '<button type="button" class="tt-ws__seg" data-k="' + x.key + '" aria-pressed="false"><span>' + String(x.name).replace(/[<&"]/g, "") + "</span></button>"; }).join("");
        }
        slice(el.querySelectorAll("button")).forEach(function (b) { var pr = String(b.getAttribute("data-k") === cur); if (b.getAttribute("aria-pressed") !== pr) b.setAttribute("aria-pressed", pr); });
      });
      /* (phones) the small fitter's pill says what a tap fits */
      var one = L.length === 1 && L[0].key ? "tap to move the " + L[0].name : on ? "tap to move the " + L.map(function (x) { return x.name; }).join(" or ") : "";
      FEDS.forEach(function (ed) { if (!ed.fit) { if (one) ed.el.setAttribute("data-tip", one); else ed.el.removeAttribute("data-tip"); } });
    }
    /* what the fitters draw: what's shown, with the fit being made */
    function figState() {
      var s = shown(), f = figFace();
      if (FG.live && f && f.key === FG.liveKey) { var o = {}, k, pf = P().fits || {}; for (k in pf) o[k] = pf[k]; o[f.key] = FG.live; s.fits = o; }
      return s;
    }
    function figEdit() { if (FG && !FG.raf) FG.raf = requestAnimationFrame(figDrawAll); }
    function figShown(ed) { return ed.fit ? FG.open : !!fsoon && !fsoon.hidden && S.tab === "faces"; }
    function figDrawAll() {
      FG.raf = 0;
      figSliders();
      /* (v3.60) the full screen's title and tip say what's being moved ("move the nose", "drag the nose · pinch to size") */
      if (FFIT && figOn()) {
        var L = figPartsList(), k0 = figPart(), nm = figPartName(k0), ttl = FFIT.querySelector(".tt-ws__fith"), tip = FFIT.querySelector(".tt-ws__fittip");
        var tt = L.length === 1 && !L[0].key ? "fit their face" : "move the " + L.map(function (x) { return x.key ? x.name : "face"; }).join(" & ");
        var tp = (k0 ? "drag the " + nm : "drag their face") + " · pinch to size" + (figPartOpt().tilt ? " and turn" : "");
        if (ttl && ttl.textContent !== tt) ttl.textContent = tt;
        if (tip && tip.textContent !== tp) tip.textContent = tp;
      }
      var has = !isNoMove(partOf(figFitOf(figFace()), figPart()));      /* (v3.58: the part being moved) */
      FEDS.forEach(function (ed) { if (ed.reset) ed.reset.hidden = !has; if (figShown(ed)) figDraw(ed); });
    }
    /* the view that shows the design's box round the face and the whole face as fitted: roll mm -> editor px */
    function figView(fi, W, H) {
      var v = fi.view, g = fi.fig || v, m = edPad(H);
      var x0 = Math.min(v.x0, g.x0), y0 = Math.min(v.y0, g.y0), x1 = Math.max(v.x1, g.x1), y1 = Math.max(v.y1, g.y1);
      var z = Math.min((W - 2 * m.s) / (x1 - x0), (H - m.t - m.b) / (y1 - y0));
      return { z: z, ox: (W - (x1 - x0) * z) / 2 - x0 * z, oy: m.t + (H - m.t - m.b - (y1 - y0) * z) / 2 - y0 * z };
    }
    function figDraw(ed) {
      var e = figEng(), W = ed.el.clientWidth, H = ed.el.clientHeight;
      if (!e || !e.fitInfo || !W || !H) return;
      var s = figState(), fi = e.fitInfo(s, FG.who);
      if (!fi) return;
      var to = figView(fi, W, H);
      /* held: zoom out only (so nothing slides from under the finger unless it must); let go: glides (0.3s) to the fit */
      if (!ed.z) { ed.z = to.z; ed.ox = to.ox; ed.oy = to.oy; ed.glide = null; }
      else if (ed.held) { if (to.z < ed.z - 1e-6) { ed.z = to.z; ed.ox = to.ox; ed.oy = to.oy; } }
      else if (Math.abs(to.z - ed.z) > 1e-4 || Math.abs(to.ox - ed.ox) > 0.3 || Math.abs(to.oy - ed.oy) > 0.3) {
        var gl = ed.glide;
        if (!gl || Math.abs(gl.to.z - to.z) > 1e-6 || Math.abs(gl.to.ox - to.ox) > 0.01 || Math.abs(gl.to.oy - to.oy) > 0.01) gl = ed.glide = { from: { z: ed.z, ox: ed.ox, oy: ed.oy }, to: to, t0: performance.now() };
        var t = REDUCED ? 1 : Math.min(1, (performance.now() - gl.t0) / 300), k = ease(t);
        ed.z = gl.from.z + (to.z - gl.from.z) * k; ed.ox = gl.from.ox + (to.ox - gl.from.ox) * k; ed.oy = gl.from.oy + (to.oy - gl.from.oy) * k;
        if (t < 1) figEdit(); else ed.glide = null;
      }
      var dpr = density(), pw = Math.round(W * dpr), ph = Math.round(H * dpr);
      var key = [e.sig(s), FG.who, pw, ph, ed.z.toFixed(4), ed.ox.toFixed(2), ed.oy.toFixed(2)].join("|");
      if (key !== ed.key) {
        ed.key = key;
        if (ed.cv.width !== pw || ed.cv.height !== ph) { ed.cv.width = pw; ed.cv.height = ph; }
        var x = ed.cv.getContext("2d");
        x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, pw, ph);
        /* roll mm on the editor: the engine draws in mm (10 px a cm), only the part on show, sharp */
        x.setTransform(dpr * ed.z, 0, 0, dpr * ed.z, dpr * ed.ox, dpr * ed.oy);
        e.draw(x, ROLL, 120, 10, clock(), s, null, { sharp: true, x0: -ed.ox / ed.z / 10, y0: -ed.oy / ed.z / 10, x1: (W - ed.ox) / ed.z / 10, y1: (H - ed.oy) / ed.z / 10, dpr: dpr, z: ed.z });
      }
      /* the handles on their head (as fitted), by transform (no layout moves); (v3.58) or on the piece being moved, never
         smaller than a fingertip */
      var pk = figPart(), h = pk && fi.pieces && fi.pieces[pk] ? fi.pieces[pk] : fi.head;
      var cx = ed.ox + h.x * ed.z, cy = ed.oy + h.y * ed.z, bw = Math.max(pk ? 34 : 0, h.w * ed.z), bh = Math.max(pk ? 34 : 0, h.h * ed.z);
      if (ed.box) {
        ed.box.hidden = !figFace();
        ed.box.style.width = bw + "px"; ed.box.style.height = bh + "px";
        ed.box.style.setProperty("--bw", bw + "px"); ed.box.style.setProperty("--bh", bh + "px");
        ed.box.style.transform = "translate(" + (cx - bw / 2).toFixed(2) + "px," + (cy - bh / 2).toFixed(2) + "px) rotate(" + (h.rot * 180 / Math.PI).toFixed(3) + "deg)";
        /* (v3.60) no turning knob on a piece that doesn't tilt */
        var knob = ed.box.querySelector('[data-h="turn"]'), kv = figPartOpt().tilt ? "" : "hidden";
        if (knob && knob.style.visibility !== kv) knob.style.visibility = kv;
      }
      var pp = pk && fi.pieces && fi.pieces[pk];                       /* (v3.58) a piece moves in its face's frame */
      ed.geo = FG.geo = { cx: cx, cy: cy, w: bw, h: bh, rot: pp ? pp.frot : fi.rot, unit: pp ? pp.unit : fi.unit, fit: pp ? pp.fit : fi.fit, z: ed.z };
    }
    /* a new fit for the face being fitted (v3.58: for the part being moved: the face, or a piece), within the engine's
       limits: the fitters at once, the paper soon (or when let go) */
    function figSet(f, now) {
      var face = figFace(), e = figEng();
      if (!face || !e) return;
      var L = e.fitLimits || { xy: 1, s0: 0.5, s1: 2 }, cl = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
      FG.live = withPart(figFitOf(face), figPart(), { x: cl(f.x, -L.xy, L.xy), y: cl(f.y, -L.xy, L.xy), s: cl(f.s, L.s0, L.s1), r: figPartOpt().tilt ? ((f.r + 540) % 360) - 180 : 0 });     /* (v3.60) a piece with no tilt stays straight */
      FG.liveKey = face.key;
      figEdit();
      if (now) { figCommit(); return; }
      if (!FG.commitT && !FG.open) FG.commitT = setTimeout(function () { FG.commitT = 0; figCommit(); }, FIG_COMMIT);
    }
    /* the fit being made becomes the face's (rounded; no fit at all is no fit): the paper redrawn, the design saved again */
    function figCommit() {
      clearTimeout(FG.commitT); FG.commitT = 0;
      if (!FG.live || !figOn()) { FG.live = null; return; }
      var p = P(), f = FG.live, r4 = function (v) { return Math.round(v * 1e4) / 1e4; }, fits = {}, k;
      for (k in p.fits || {}) fits[k] = p.fits[k];
      /* (v3.58) the face's move and each piece's, rounded; one that moves nothing is left out */
      var rd = function (q) { return { x: r4(q.x), y: r4(q.y), s: r4(q.s), r: Math.round(q.r * 100) / 100 }; }, own = partOf(f, ""), pcs = null;
      for (k in f.p || {}) { var q = partOf(f, k); if (!isNoMove(q)) { pcs = pcs || {}; pcs[k] = rd(q); } }
      if (isNoMove(own) && !pcs) delete fits[FG.liveKey];
      else { fits[FG.liveKey] = isNoMove(own) ? { x: 0, y: 0, s: 1, r: 0 } : rd(own); if (pcs) fits[FG.liveKey].p = pcs; }
      p.fits = Object.keys(fits).length ? fits : null;
      if (!FG.held) FG.live = null;
      render(); changed();
    }
    /* size (%) and tilt (degrees) always show the fit however it was last changed; tilt -45° to 45° (the knob turns further:
       the slider rests at its end, its value the angle) */
    /* (v3.60, Ally of Rudolph Rows' nose: "maybe no tilt option but positioning sliders?") left / right and up / down: the
       move in hundredths of a head height, within FIG_SLIDE of where the design puts it, said as words */
    var FIG_SLIDE = 30;
    function slideText(k, v) { return !v ? "middle" : (k === "x" ? (v < 0 ? "left " : "right ") : (v < 0 ? "up " : "down ")) + Math.abs(v); }
    function figSliders() {
      if (!fRanges.length || !figOn()) return;
      var f = partOf(figFitOf(figFace()), figPart()), o = figPartOpt(), cl = function (n) { return Math.max(-FIG_SLIDE, Math.min(FIG_SLIDE, n)); };
      var v = { s: Math.round(f.s * 100), r: Math.round(f.r), x: cl(Math.round(f.x * 100)), y: cl(Math.round(f.y * 100)) };     /* (v3.58) the part being moved */
      var on = { s: true, r: o.tilt, x: o.slide, y: o.slide };
      fRanges.forEach(function (r) {
        var k = r.getAttribute("data-k"), xy = r.closest(".js-fxy"), box = xy || r.closest(".tt-ws__ctl");
        if (box) { var d = on[k] ? (xy ? "grid" : "") : "none"; if (box.style.display !== d) box.style.display = d; }      /* (v3.60) only its own controls (x, y side by side) */
        if (+r.value !== v[k]) r.value = v[k];
        r.setAttribute("aria-valuetext", k === "s" ? v.s + "%" : k === "x" || k === "y" ? slideText(k, v[k]) : v.r ? String(v.r < 0 ? copy.rotLeft : copy.rotRight).replace("[n]", Math.abs(v.r)) : "0");
      });
      fVals.forEach(function (el) { var k = el.getAttribute("data-k"), t = k === "s" ? v.s + "%" : k === "x" || k === "y" ? slideText(k, v[k]) : rotText(v.r); if (el.textContent !== t) el.textContent = t; });
    }
    fRanges.forEach(function (r) {
      r.addEventListener("input", function () {
        var f = partOf(figFitOf(figFace()), figPart()), n = { x: f.x, y: f.y, s: f.s, r: f.r }, v = +r.value, k = r.getAttribute("data-k");
        if (k === "s") n.s = v / 100; else if (k === "x") n.x = v / 100; else if (k === "y") n.y = v / 100; else n.r = v;     /* (v3.60) x, y */
        figSet(n);
      });
      r.addEventListener("change", function () { figCommit(); });
    });
    FEDS.forEach(function (ed) {
      var el = ed.el, hp = new Map(), hd = null;
      var pt = function (ev) { var r = el.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; };
      var start = function () {
        var g = ed.geo; if (!g || !figFace()) return null;
        var f0 = partOf(figFitOf(figFace()), figPart()), pts = []; hp.forEach(function (v) { pts.push(v); });
        var base = { f0: { x: f0.x, y: f0.y, s: f0.s, r: f0.r }, g: g };
        if (pts.length >= 2) {
          var a = pts[0], b = pts[1];
          return assignObj(base, { mode: "pinch", d0: Math.hypot(b.x - a.x, b.y - a.y) || 1, a0: Math.atan2(b.y - a.y, b.x - a.x), m0: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, twist: false });
        }
        return base;
      };
      /* a move on the editor (px) in the face's own frame (the figure's slot may be turned), in the fit's units */
      var along = function (dx, dy) {
        var g = hd.g, c = Math.cos(g.rot), s = Math.sin(g.rot), u = Math.max(1e-6, g.unit * (ed.z || g.z));
        return { x: (dx * c + dy * s) / u, y: (-dx * s + dy * c) / u };
      };
      el.addEventListener("pointerdown", function (ev) {
        if (!figEng() || (ev.target.closest && ev.target.closest(".js-figreset"))) return;
        ev.preventDefault();
        if (!ed.fit && FFIT && tabsMode()) { if (figFace()) figOpen(el); return; }     /* a phone: full screen */
        if (!figFace()) return;                       /* (the sample face: nothing of theirs to fit yet) */
        try { el.setPointerCapture(ev.pointerId); } catch (er) {}
        hp.set(ev.pointerId, pt(ev));
        ed.held = FG.held = true;
        var h = ev.target.getAttribute && ev.target.getAttribute("data-h");
        hd = start();
        if (!hd) return;
        var p = pt(ev);
        if (hp.size >= 2) return;
        if (h === "turn") assignObj(hd, { mode: "turn", a0: Math.atan2(p.y - hd.g.cy, p.x - hd.g.cx) });
        else if (h) assignObj(hd, { mode: "size", d0: Math.hypot(p.x - hd.g.cx, p.y - hd.g.cy) || 1 });
        else assignObj(hd, { mode: "move", p0: p });
      });
      el.addEventListener("pointermove", function (ev) {
        if (!hp.has(ev.pointerId) || !hd) return;
        hp.set(ev.pointerId, pt(ev));
        var p = pt(ev), f0 = hd.f0, g = hd.g, d;
        if (hd.mode === "pinch") {
          var pts = []; hp.forEach(function (v) { pts.push(v); }); if (pts.length < 2) return;
          var a = pts[0], b = pts[1], dd = Math.hypot(b.x - a.x, b.y - a.y), an = Math.atan2(b.y - a.y, b.x - a.x);
          var turn = (an - hd.a0) * 180 / Math.PI; if (Math.abs(turn) > 5) hd.twist = true;
          d = along((a.x + b.x) / 2 - hd.m0.x, (a.y + b.y) / 2 - hd.m0.y);
          figSet({ x: f0.x + d.x, y: f0.y + d.y, s: f0.s * dd / hd.d0, r: f0.r + (hd.twist ? turn : 0) });
        } else if (hd.mode === "move") {
          d = along(p.x - hd.p0.x, p.y - hd.p0.y);
          figSet({ x: f0.x + d.x, y: f0.y + d.y, s: f0.s, r: f0.r });
        } else if (hd.mode === "size") {
          figSet({ x: f0.x, y: f0.y, s: f0.s * Math.hypot(p.x - g.cx, p.y - g.cy) / hd.d0, r: f0.r });
        } else if (hd.mode === "turn") {
          figSet({ x: f0.x, y: f0.y, s: f0.s, r: f0.r + (Math.atan2(p.y - g.cy, p.x - g.cx) - hd.a0) * 180 / Math.PI });
        }
      });
      var up = function (ev) {
        if (!hp.has(ev.pointerId)) return;
        hp.delete(ev.pointerId);
        hd = hp.size ? start() : null;               /* one finger left of a pinch: it moves on from here */
        if (hd && !hd.mode) { var p0 = null; hp.forEach(function (v) { p0 = v; }); assignObj(hd, { mode: "move", p0: p0 }); }
        if (!hp.size) { ed.held = FG.held = false; figCommit(); figEdit(); }
      };
      el.addEventListener("pointerup", up);
      el.addEventListener("pointercancel", up);
      /* "reset": this face (v3.58: the part being moved) as the design puts it */
      if (ed.reset) ed.reset.addEventListener("click", function () {
        var f = figFace(); if (!f) return;
        var k = figPart();
        FG.live = withPart(figFitOf(f), k, NO_MOVE); FG.liveKey = f.key;
        figCommit(); figEdit(); announce(figPartName(k) + " put back");
      });
      if ("ResizeObserver" in window) new ResizeObserver(function () { figEdit(); }).observe(el);
    });
    /* which face is being fitted: their heads (the faces on the wrap), with two or more */
    function figWho() {
      var fs = figOn() ? fitFaces() : [], on = fs.length > 1;
      if (FG.who >= fs.length) FG.who = 0;
      fwhoEls.forEach(function (el) {
        el.hidden = !on;
        if (!on) return;
        var bs = slice(el.querySelectorAll("button"));
        while (bs.length < fs.length) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "tt-ws__usef";
          b.addEventListener("click", function () { figPick(+this.dataset.i); });
          el.appendChild(b); bs.push(b);
        }
        bs.forEach(function (b, i) {
          var f = fs[i];
          b.hidden = !f;
          if (!f) return;
          b.dataset.i = i;
          var im = b.querySelector("img");
          if (!im) { im = document.createElement("img"); im.alt = ""; im.decoding = "async"; b.appendChild(im); }
          if (im.getAttribute("src") !== f.src) im.src = f.src;
          b.setAttribute("aria-label", "fit face " + (i + 1));
          b.setAttribute("aria-pressed", i === FG.who ? "true" : "false");
        });
      });
    }
    function figPick(i) {
      if (i === FG.who) return;
      figCommit();
      FG.who = i;
      figWho(); figEdit();
      announce("fitting face " + (i + 1));
    }
    /* the name step's box (and its line of messages) in the fitter's side, for a figure design that takes a name; back in
       its step for any other (only while it's not being typed in) */
    function placeName(inFig) {
      if (!nameIn || !fnameSlot || document.activeElement === nameIn) return;
      var home = stepEl("name"), foot = nmsg ? nmsg.parentNode : null, to = inFig ? fnameSlot : home;
      fnameSlot.hidden = !inFig;
      if (!to || nameIn.parentNode === to) return;
      to.appendChild(nameIn);
      if (foot) to.appendChild(foot);
    }
    /* the fitter on show (or not) for the open design: under the upload, live once a face is in (the name box at once) */
    function figSync() {
      if (!FG) return;                                 /* (not set up yet) */
      var on = figOn(), awake = on && facesFor().length > 0;
      if (fsoon) {
        fsoon.hidden = !on;
        fsoon.classList.toggle("is-named", false);                /* (v3.61) the name is on its own step */
        fsoon.classList.toggle("is-awake", awake);
        slice(fsoon.querySelectorAll(".js-figed, .js-fwho, .js-fparts, .tt-ws__fsl")).forEach(function (n) { if (awake) n.removeAttribute("inert"); else n.setAttribute("inert", ""); });
      }
      root.classList.toggle("is-fit", on);
      if (soonEl) {
        soonEl.classList.toggle("is-fig", on);
        if (on) soonEl.removeAttribute("inert");       /* (the name box is live before a photo; the fitter waits for one) */
      }
      placeName(false);                                /* (v3.61) never in the fitter now */
      figParts();                                      /* (v3.58) */
      figWho();
      if (on) figEdit();
      else if (FG.open) figClose();
    }
    /* ── on a phone: "fit their face", full screen (as "fit the hat") ── */
    if (FFIT) {
      document.body.appendChild(FFIT);                /* (over the header and everything else) */
      ffitDone.addEventListener("click", function () { figClose(); });
      FFIT.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { e.preventDefault(); figClose(); return; }
        if (e.key !== "Tab") return;                  /* focus stays in the fitter */
        var f = slice(FFIT.querySelectorAll("button:not([hidden]), input")).filter(function (n) { return !n.disabled && n.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.addEventListener("popstate", function () { if (FG.open) figClose(true); });
    }
    function figOpen(from) {
      if (FG.open || !FFIT) return;
      FG.open = true; FG.from = from || null;
      clearTimeout(FG.t);
      var cs = getComputedStyle(root);
      FFIT.style.setProperty("--bg", cs.getPropertyValue("--bg").trim() || "#f395b3");
      FFIT.style.setProperty("--ink", cs.getPropertyValue("--ink").trim() || "#333333");
      document.documentElement.classList.add("tt-ws-fitting");
      FFIT.hidden = false;
      FFIT.getBoundingClientRect();                   /* (so the fade-in runs) */
      FFIT.classList.add("is-in");
      FEDS.forEach(function (ed) { if (ed.fit) { ed.z = 0; ed.key = ""; } });     /* (fit the view afresh) */
      figWho(); figEdit();
      try { history.pushState({ ttFigFit: 1 }, ""); } catch (er) {}
      setTimeout(function () { if (FG.open) ffitDone.focus({ preventScroll: true }); }, 60);
      announce("fit their face");
    }
    function figClose(fromBack) {
      if (!FG.open) return;
      FG.open = false;
      FFIT.classList.remove("is-in");
      document.documentElement.classList.remove("tt-ws-fitting");
      FG.t = setTimeout(function () { if (!FG.open) FFIT.hidden = true; }, REDUCED ? 0 : 220);
      if (!fromBack) { try { if (history.state && history.state.ttFigFit) history.back(); } catch (er) {} }
      figCommit(); figEdit(); render();
      if (FG.from) { try { FG.from.setAttribute("tabindex", "-1"); FG.from.focus({ preventScroll: true }); } catch (er) {} }
    }

    /* ── (v3.7) The Santa Hat: the hat editor is one element, moved into the open design's
       step ("how old?" for The Party Hat, "your hat" for The Santa Hat) as it opens (steps
       not on show, so nothing seen moves); and the paper colour: the product's Colour option
       (the variant follows the size and the colour), each a swatch of its block's colour, in
       "your hat" and (greyed till a face is in) under the upload ── */
    var papersEls = qa(".js-papers"), paperVals = qa(".js-paperval");
    function placeEditor(d) {
      if (!hedRow) return;
      var at = d.engine === "santa" || d.engine === "santarows" || d.engine === "santawhite" ? stepEl("hat") : d.engine === "hat" ? stepEl("age") : null;
      if (!at || at.contains(hedRow)) return;
      var before = at.querySelector(d.engine === "hat" ? ".tt-ws__hopts" : ".tt-ws__papers");
      at.insertBefore(hedRow, before || null);
    }
    function colourOption(Pr) {
      var oi = sizeOption(Pr), found = -1;
      (Pr.options || []).forEach(function (o, i) { var n = typeof o === "string" ? o : o && o.name; if (found < 0 && i !== oi && /colou?r/i.test(n || "")) found = i; });
      return found;
    }
    function colourValues(Pr) {
      var ci = colourOption(Pr), seen = {}, out = [];
      if (ci < 0) return out;
      Pr.variants.forEach(function (v) { var c = (v.options || [])[ci]; if (c != null && !seen[c]) { seen[c] = 1; out.push(c); } });
      return out;
    }
    /* the colour in use (else the first the product has), and its hex (the block's, else white) */
    function colourOf(d) {
      var vals = colourValues(d.product), p = P(d);
      if (!vals.length) return null;
      if (p.colour == null || vals.indexOf(p.colour) < 0) p.colour = vals[0];
      return p.colour;
    }
    function paperHex(d) {
      var c = colourOf(d), m = (d.papers || []).filter(function (x) { return c != null && x.name.toLowerCase() === String(c).toLowerCase(); })[0];
      return m ? m.hex : "#FFFFFF";
    }
    function buildPapers(d) {
      var vals = colourValues(d.product);
      papersEls.forEach(function (row) {
        if (row.ttFor === d) return;
        row.ttFor = d;
        row.textContent = "";
        vals.forEach(function (c) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "tt-ws__col"; b.dataset.colour = c;
          b.setAttribute("aria-label", String(c).toLowerCase());
          var hx = (d.papers.filter(function (x) { return x.name.toLowerCase() === String(c).toLowerCase(); })[0] || {}).hex || "#FFFFFF";
          b.style.setProperty("--sw", hx); b.style.setProperty("--tick", tickOn(hx));
          b.addEventListener("click", function () { setColour(c); });
          row.appendChild(b);
        });
      });
      syncPapers();
    }
    function syncPapers() {
      if (D.engine !== "santa") return;
      var c = colourOf(D);
      papersEls.forEach(function (row) { slice(row.children).forEach(function (b) { b.setAttribute("aria-pressed", b.dataset.colour === c ? "true" : "false"); }); });
      paperVals.forEach(function (v) { v.textContent = String(c || "").toLowerCase(); });
    }
    /* a colour picked: the same size in that colour (the variant follows), drawn at once */
    function setColour(c) {
      var Pr = D.product, p = P();
      if (colourOption(Pr) < 0 || p.colour === c) return;
      var cur = variant(), size = cur ? sizeOf(Pr, cur) : null, ci = colourOption(Pr);
      p.colour = c;
      var nv = Pr.variants.filter(function (v) { return (v.options || [])[ci] === c && (size == null || sizeOf(Pr, v) === size) && v.available; })[0];
      if (nv) p.variant = nv.id;
      buildSizes();
      syncPapers();
      ripple(14);
      changed();
      hatThumbsSoon();
      announce(String(c).toLowerCase() + " paper");
    }

    if (ageIn) {
      ageIn.value = SHARED.age || "";
      ageIn.addEventListener("input", function () {
        var v = ageIn.value.replace(/\D+/g, "").slice(0, 3);
        if (v !== ageIn.value) ageIn.value = v;
        if (v === SHARED.age) return;
        SHARED.age = v;
        render();
        changed();
        hatEdit(); hatThumbsSoon();
      });
    }

    /* ── the pattern (The Classic, The All-Over): the open design's own, P().pattern ── */
    var patLays = qa(".js-lay"), patCols = qa(".js-bg"), patRanges = qa(".js-range"), patVals = qa(".js-val");   /* (v3.48: face size is the size step's) */
    var shuffleBtns = qa(".js-shuffle");                /* (v3.5: "your pattern"'s, and the copy under the upload) */
    patCols.forEach(function (b) { b.style.setProperty("--tick", tickOn(b.getAttribute("data-bg"))); });   /* (v3.58) */
    function cmText(v) { return (v % 1 ? v.toFixed(1) : String(v)) + " cm"; }
    function cmNum(v) { return v % 1 ? v.toFixed(1) : String(v); }
    function rotText(v) { return (v > 0 ? "+" : "") + v + "°"; }
    function inGroup(el) { var g = el.closest(".js-pgroup"); return !!g && g.getAttribute("data-engine") === D.engine; }
    /* each control's value, as it's shown beside its title */
    function valText(k, p) {
      if (k === "rot") return rotText(p.rot);
      if (k === "extras") return Math.round(p.extras * 100) + "%";
      if (k === "bg") { var b = patCols.filter(function (x) { return x.getAttribute("data-bg") === p.bg; })[0]; return b ? b.getAttribute("aria-label") : ""; }
      return p[k] != null ? cmText(p[k]) : "";
    }
    /* the controls show the open design's pattern (its group only; the other's is hidden) */
    function syncPattern() {
      qa(".js-pgroup").forEach(function (g) { g.hidden = g.getAttribute("data-engine") !== D.engine; });
      var e = eng(D), p = P().pattern;
      if (D.engine === "shirt") { syncShirt(); return; }            /* (v3.26) the shirt's kit is its pattern */
      if (!e || !p || !e.limits) return;
      patVals.forEach(function (o) {
        if (!inGroup(o)) return;
        var t = valText(o.getAttribute("data-k"), p);
        if (o.textContent !== t) o.textContent = t;
      });
      patLays.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-lay") === p.layout ? "true" : "false"); });
      patCols.forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-bg") === p.bg ? "true" : "false"); });
      patRanges.forEach(function (r) {
        if (!inGroup(r)) return;
        var k = r.getAttribute("data-k"), v = k === "extras" ? Math.round(p.extras * 100) : p[k];
        if (v == null) return;
        if (+r.value !== v && !(document.activeElement === r && Math.abs(+r.value - v) < 0.26)) r.value = v;
        if (k === "rot") r.setAttribute("aria-valuetext", p.rot ? String(p.rot < 0 ? copy.rotLeft : copy.rotRight).replace("[n]", Math.abs(p.rot)) : "0");
        else if (k === "extras") r.setAttribute("aria-valuetext", Math.round(p.extras * 100) + "%");
        else r.setAttribute("aria-valuetext", cmText(v));
      });
    }
    /* a change to the pattern: drawn at once, saved a second later */
    function setPattern(ch, how) {
      var e = eng(D), p = P();
      if (!e || !p.pattern || !e.clean) return false;
      var next = {}, k;
      for (k in p.pattern) next[k] = p.pattern[k];
      for (k in ch) next[k] = ch[k];
      next = e.clean(next);
      if (JSON.stringify(next) === JSON.stringify(p.pattern)) return false;
      p.pattern = next;
      syncPattern();
      syncFsize();                                    /* (v3.48) */
      if (how === "ripple") ripple(30); else render();
      changed();
      return true;
    }
    patLays.forEach(function (b) { b.addEventListener("click", function () { setPattern({ layout: b.getAttribute("data-lay") }); }); });
    patCols.forEach(function (b) { b.addEventListener("click", function () { setPattern({ bg: b.getAttribute("data-bg") }); }); });
    patRanges.forEach(function (r) {
      r.addEventListener("input", function () {
        var k = r.getAttribute("data-k"), p = P().pattern, ch = {};
        if (!p) return;
        ch[k] = k === "extras" ? (+r.value) / 100 : +r.value;
        if (!setPattern(ch)) syncPattern();           /* past an end: the thumb goes back to it */
      });
    });
    shuffleBtns.forEach(function (b) {
      b.addEventListener("click", function () { setPattern({ seed: (Math.random() * 4294967296) >>> 0 }, "ripple"); });
    });

    /* ── the words (Our Favourite): their name, made into "Name’s our
       favourite" (as the gift wrap page makes it, and their name is the
       gift wrap page's too), or their own words ("write your own words";
       "use their name instead" goes back). The old page's rules: what's
       wrong is said under the box, and only when it can't be printed ── */
    function rules() { var e = window.TTWrapEngines && window.TTWrapEngines.phrase; return e && e.rules; }
    function pc() { return D.copy || {}; }               /* the words' wording: the design's own */
    function setPmsg(text) { if (pmsg) pmsg.textContent = text || ""; }
    function phraseOk(d) { d = d || D; var e = d.engine === "phrase" && eng(d); return !!(e && e.complete(st(d))); }
    /* the name in what was typed as a name ("Mila’s our favourite" typed whole is Mila) */
    function nameOnly(v) { return String(v || "").replace(/\s*['‘’ʼ`]\s*s(\s+our(\s+favourite)?)?\s*$/i, "").replace(/\s+/g, " ").trim(); }
    function makePhrase(name) {
      var v = String(name || "").replace(/\s+/g, " ").trim(), R = rules();
      if (!v) return "";
      /* (v3.36) emoji at the end of the name go after the phrase: "Mila’s our favourite 💕" */
      var t = R && R.tail ? R.tail(v) : { base: v, tail: "" };
      if (t.tail && t.base) return makePhrase(t.base) + " " + t.tail;
      if (R) { var s = R.suffix(v); if (s.done) return v; if (s.value) return s.value.replace(/’S OUR FAVOURITE$|S OUR FAVOURITE$| OUR FAVOURITE$| FAVOURITE$/, function (m) { return m.toLowerCase(); }); }
      return nameOnly(v) + "’s our favourite";
    }
    /* what's in the box can't be printed: why, and the plain version to offer (or null) */
    function phraseProblem() {
      var e = D.engine === "phrase" && eng(D), p = P(), raw = String(p.phrase || "");
      if (!e || !raw.trim()) return null;
      var r = e.read(raw);
      if (r.ok) return null;
      var fix = r.plain ? (p.own ? r.plain : nameOnly(r.plain)) : null;
      return { reason: r.reason, bad: r.bad || [], fix: fix && fix !== phraseIn.value ? fix : null };
    }
    /* (v3.36) emoji in the words: their shapes loaded, then everything drawn and saved again (the line waits meanwhile) */
    var emojiWait = 0;
    function emojiSoon(v) {
      var M = window.TTEmoji;
      if (!M || !M.maybe(v)) return;
      emojiWait++;
      var done = function () { emojiWait = Math.max(0, emojiWait - 1); readPhrase(); readName(); readShirt(); readTexts(); followName(); render(); changed(); paint(); };
      M.need(v).then(done, done);
    }
    function readPhrase() {
      if (!phraseIn || D.engine !== "phrase") return;
      if (emojiWait) { setPmsg(""); phraseIn.removeAttribute("aria-invalid"); return; }
      var r = phraseProblem();
      if (!r) { setPmsg(""); phraseIn.removeAttribute("aria-invalid"); return; }
      phraseIn.setAttribute("aria-invalid", "true");
      if (r.reason === "long") setPmsg(P().own ? pc().long : (pc().chipLong || pc().long));
      else {
        /* the letters first ("Ë won't print: ..."), so the line never cuts off the part that matters */
        var m = pc().chars || "", bad = r.bad.length ? r.bad.join(" ") : "";
        setPmsg(m.indexOf("{letters}") > -1 ? m.replace("{letters}", bad) : m + (bad ? " " + bad : ""));
      }
    }
    /* the box, its heading and the way to the other kind of words, for the design's mode */
    function syncWords() {
      if (!phraseIn || D.engine !== "phrase") return;
      var p = P(), own = !!p.own;
      if (plabel) plabel.textContent = own ? "your words" : "who’s it for?";
      phraseIn.placeholder = own ? (pc().placeholder || "") : "their name";
      if (ownTxt) ownTxt.textContent = own ? "use their name instead" : "write your own words";
      var v = own ? p.phrase : (SHARED.name || nameOnly(p.phrase));
      if (phraseIn.value !== v) phraseIn.value = v;
      readPhrase();
    }
    function setPhrase(v, focus) {
      phraseIn.value = v;
      phraseIn.dispatchEvent(new Event("input", { bubbles: true }));
      if (focus) phraseIn.focus({ preventScroll: true });
    }
    /* a button under the box takes them back to it on a computer, and on a
       phone only if they were typing (the keyboard was up): tapping it with
       the keyboard down mustn't bring it up over what they're reading */
    var hadBox = false;
    function backToBox() { var b = !tabsMode() || hadBox; hadBox = false; return b; }
    if (phraseIn) {
      phraseIn.addEventListener("input", function () {
        if (D.engine !== "phrase") return;
        var p = P();
        if (p.own) { p.phrase = phraseIn.value; p.auto = ""; }
        else { SHARED.name = nameOnly(phraseIn.value); p.phrase = p.auto = makePhrase(phraseIn.value); }
        emojiSoon(phraseIn.value);
        readPhrase();
        render();
        changed();
        wordsCloseUp();
      });
      if (ownBtn) {
        ownBtn.addEventListener("pointerdown", function () { hadBox = document.activeElement === phraseIn; });
        ownBtn.addEventListener("click", function () {
          var p = P(), back = backToBox();
          /* their own words start from what's there; their name puts it back */
          if (!p.own) { p.own = true; p.auto = ""; }
          else { p.own = false; p.phrase = p.auto = makePhrase(SHARED.name); }
          syncWords();
          render();
          changed();
          if (back) phraseIn.focus({ preventScroll: true });
        });
      }
    }

    /* ── (v3.41) the face size (The Party Hat, The Santa Hat): .js-fsize beside "details" under the sizes, shown on those
       two only; each choice says how many go across the roll (the engine's own sizing). (v3.48) The Classic and The
       All-Over too: the choice is their pattern's sizes (FSIZE_PAT), each saying how big a face prints ── */
    function syncFsize() {
      var pat = FSIZE_PAT[D.engine] || null, on = !!(FSIZE_ON[D.engine] || pat), e = on ? eng() : null;
      var cur = pat ? FSIZE_FS[fsizeOf(D.engine, P().pattern)] : on ? P().fsize || 0 : 0;
      qa(".js-fsize").forEach(function (box) {
        if (box.hidden === on) box.hidden = !on;
        if (!on && box.open) box.open = false;
        slice(box.querySelectorAll(".js-fshat")).forEach(function (s) { if (s.hidden !== !!pat) s.hidden = !!pat; });
        slice(box.querySelectorAll(".js-fseg")).forEach(function (b) {
          var mm = +b.getAttribute("data-mm"), fs = b.getAttribute("data-fs"), x = pat ? pat[FSIZE_FS.indexOf(fs)] : null;
          var pr = String(pat ? fs === cur : mm === cur), sm = b.querySelector(".js-fsacross");
          if (b.getAttribute("aria-pressed") !== pr) b.setAttribute("aria-pressed", pr);
          var t = x ? (x.head != null ? cmText(x.head) : cmNum(x.sMin) + "–" + cmNum(x.sMax) + " cm") : e && e.sized ? e.sized(mm || 87).across + " across" : "";
          if (sm && sm.textContent !== t) sm.textContent = t;
        });
      });
    }
    root.addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest(".js-fseg") : null;
      if (b && FSIZE_PAT[D.engine]) {                  /* (v3.48) The Classic, The All-Over: the pattern's sizes */
        var x = FSIZE_PAT[D.engine][FSIZE_FS.indexOf(b.getAttribute("data-fs"))];
        if (x) setPattern(x);
        return;
      }
      if (!b || !FSIZE_ON[D.engine]) return;
      var mm = +b.getAttribute("data-mm");
      if (FSIZES.indexOf(mm) < 0 || (P().fsize || 0) === mm) return;
      P().fsize = mm;
      syncFsize(); render(); changed();
    });

    /* ── (v3.40) an idea wrap's colour (its design's first option: the four pattern wraps'): .js-ideacols, a swatch each
       (the step's own, made once its design is in); the choice is the design's pattern ── */
    function syncIdeaCols(d) {
      d = d || D;
      var e = d.engine === "idea" ? eng(d) : null, des = e && e.design, op = des && (des.options || [])[0], p = P(d);
      var cur = op ? (p.pattern && p.pattern[op.id]) || op.def || op.values[0].id : "", own = !!op && op.custom && /^#/.test(cur);
      /* (v3.46) the row under their faces: only on the open design, when it has a colour */
      if (d === D) qa(".js-icol").forEach(function (r) { if (r.hidden !== !op) r.hidden = !op; });
      qa(".js-ideacols").forEach(function (box) {
        if (!op) { if (box.innerHTML) box.innerHTML = ""; box.removeAttribute("data-for"); return; }
        if (box.getAttribute("data-for") !== des.id) {
          box.setAttribute("data-for", des.id);
          box.innerHTML = op.values.map(function (v) { return '<button type="button" class="tt-ws__col js-ideacol" data-v="' + v.id + '" aria-label="' + String(v.name).toLowerCase() + '" aria-pressed="false" style="--sw: ' + v.hex + '; --tick: ' + tickOn(v.hex) + '"></button>'; }).join("") +
            /* (v3.46, Ally: "and enable custom colour") their own: the "+", the custom colour card, as the shirt's */
            (op.custom ? '<button type="button" class="tt-ws__col tt-ws__col--custom js-ideacustom" aria-label="your own colour" aria-haspopup="dialog" aria-pressed="false"></button>' : "");
        }
        slice(box.querySelectorAll(".js-ideacol")).forEach(function (b) { var on = String(b.getAttribute("data-v") === cur); if (b.getAttribute("aria-pressed") !== on) b.setAttribute("aria-pressed", on); });
        slice(box.querySelectorAll(".js-ideacustom")).forEach(function (b) {
          b.classList.toggle("is-on", own); b.style.setProperty("--sw", own ? cur : "#fff"); b.style.setProperty("--tick", tickOn(own ? cur : "")); b.setAttribute("aria-pressed", own ? "true" : "false");
        });
      });
      var val = op && op.values.filter(function (x) { return x.id === cur; })[0], t = val ? String(val.name).toLowerCase() : own ? "your own colour" : "";
      qa(".js-ideacolval").forEach(function (o) { if (o.textContent !== t) o.textContent = t; });
    }
    root.addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest(".js-ideacol") : null;
      if (!b || D.engine !== "idea") return;
      var e = eng(), op = e && e.design && (e.design.options || [])[0], p = P();
      if (!op) return;
      p.pattern = p.pattern || {};
      p.pattern[op.id] = b.getAttribute("data-v");
      syncIdeaCols(); render(); changed();
    });
    /* ── (v3.54) a choice per face (an idea design's perFace: Naughty or Nice's nice, naughty or both) as Santa's two
       lists (Ally: "Build C, the two lists"): a card for each of the design's lists (perFace.lists: "nice list",
       "naughty list") side by side under the faces, on the design's own lined paper with its handwritten heading
       (perFace.look), their faces as chips in each. A tap ticks a face onto that list (the wrap's pen tick, in the list's
       ink) or takes it off; on both lists is perFace.both ("both"). A face is always on a list: taken off its only one,
       it goes on the other (both cards show what happened). Off a list, a face is faded. The chips share the room left
       under the faces (the CSS: that room is a size container): one row for one or two faces, two for three to five.
       Nothing is rebuilt on a tap, so the tapped chip keeps focus and the room never changes height. Kept in the design's
       pattern by the face's key; the line is v3.47's ("Face 1": "Nice" / "Naughty" / "Both"). v3.52's grid is gone ── */
    var PF_TICK = '<svg class="tt-ws__nntick" viewBox="0 0 24 24" aria-hidden="true"><path pathLength="1" d="M3.7 13.2Q6.6 17.3 9.1 20.6Q13.8 10.8 20.6 2.4"/></svg>';   /* the wrap's pen tick (the design's tick()) */
    function pfVal(pf, cur, key) { var v = cur[key]; return pf.values.some(function (x) { return x.id === v; }) ? v : pf.def != null ? pf.def : pf.values[0].id; }
    /* the lists: the design's, else one a value (its "both" left out) */
    function pfLists(pf) {
      return pf.lists && pf.lists.length ? pf.lists : pf.values.filter(function (x) { return x.id !== pf.both; }).map(function (x) { return { id: x.id, name: x.name }; });
    }
    function pfOn(pf, v, l) { return v === l || (pf.both != null && v === pf.both); }
    /* how the chips sit in a list: one row for one or two faces, two rows for three to five (three across for five) */
    function pfShape(n) { var c = n <= 2 ? Math.max(1, n) : n <= 4 ? 2 : 3; return [c, Math.ceil(n / c)]; }
    function syncPerFace(d) {
      d = d || D;
      if (d !== D) return;
      var e = d.engine === "idea" ? eng(d) : null, pf = e && e.design && e.design.perFace, fs = pf ? facesFor(d) : [];
      qa(".js-pfrow").forEach(function (row) {
        var on = !!pf && fs.length > 0;
        if (row.hidden !== !on) row.hidden = !on;
        if (!on) return;
        var box = row.querySelector(".js-pfs"), cur = (P(d).pattern && P(d).pattern[pf.id]) || {}, lists = pfLists(pf);
        /* the lists, made once for the design, on its paper */
        var ver = pf.id + ":" + lists.map(function (l) { return l.id; }).join(",");
        if (box.getAttribute("data-for") !== ver) {
          box.setAttribute("data-for", ver);
          var lk = pf.look || {};
          [["--nn-paper", lk.paper], ["--nn-rule", lk.rule], ["--nn-margin", lk.margin], ["--nn-pen", lk.pen], ["--nn-font", lk.font ? '"' + String(lk.font).replace(/["\\]/g, "") + '"' : ""]].forEach(function (x) {
            if (x[1]) box.style.setProperty(x[0], x[1]); else box.style.removeProperty(x[0]);
          });
          box.textContent = "";
          lists.forEach(function (l) {
            var card = document.createElement("div"), h = document.createElement("span"), chips = document.createElement("div"), nm = String(l.name || l.id).toLowerCase();
            card.className = "tt-ws__nnlist"; card.setAttribute("role", "group"); card.setAttribute("aria-label", nm); card.setAttribute("data-l", l.id);
            if (l.tick) card.style.setProperty("--nn-tick", l.tick);
            h.className = "tt-ws__nnh"; h.setAttribute("aria-hidden", "true"); h.textContent = nm;
            chips.className = "tt-ws__nnchips";
            card.appendChild(h); card.appendChild(chips); box.appendChild(card);
          });
          if (pf.title) box.setAttribute("aria-label", pf.title);
        }
        var sh = pfShape(fs.length);
        if (box.style.getPropertyValue("--nc") !== String(sh[0])) box.style.setProperty("--nc", String(sh[0]));
        if (box.style.getPropertyValue("--nr") !== String(sh[1])) box.style.setProperty("--nr", String(sh[1]));
        /* a chip a face in each list: kept and refilled in place, so a face's picture never blinks */
        slice(box.querySelectorAll(".tt-ws__nnlist")).forEach(function (list) {
          var l = list.getAttribute("data-l"), chips = list.querySelector(".tt-ws__nnchips"), bs = slice(chips.children);
          while (bs.length > fs.length) chips.removeChild(bs.pop());
          while (bs.length < fs.length) {
            var b = document.createElement("button"), im = document.createElement("img");
            b.type = "button"; b.className = "tt-ws__nnc js-pfc"; b.setAttribute("data-l", l); b.setAttribute("aria-pressed", "false");
            im.alt = ""; im.decoding = "async"; im.draggable = false;
            b.appendChild(im); b.insertAdjacentHTML("beforeend", PF_TICK);
            chips.appendChild(b); bs.push(b);
          }
          fs.forEach(function (f, i) {
            var b = bs[i], im = b.firstChild, o = String(pfOn(pf, pfVal(pf, cur, f.key), l)), lbl = "face " + (i + 1);
            if (b.getAttribute("data-k") !== f.key) b.setAttribute("data-k", f.key);
            if (b.getAttribute("data-i") !== String(i)) b.setAttribute("data-i", String(i));
            if (im.getAttribute("src") !== f.src) im.src = f.src;
            if (b.getAttribute("aria-pressed") !== o) b.setAttribute("aria-pressed", o);
            if (b.getAttribute("aria-label") !== lbl) b.setAttribute("aria-label", lbl);
          });
        });
      });
    }
    root.addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest(".js-pfc") : null;
      if (!b || D.engine !== "idea") return;
      var e = eng(), pf = e && e.design && e.design.perFace, p = P(), k = b.getAttribute("data-k"), l = b.getAttribute("data-l");
      if (!pf || !k || !l) return;
      var lists = pfLists(pf), other = lists.filter(function (x) { return x.id !== l; })[0];
      var o = (p.pattern && p.pattern[pf.id]) || {}, v = pfVal(pf, o, k), nv;
      /* on this list: off it (from both, onto the other only; from this one only, onto the other); off it: onto it too */
      if (pfOn(pf, v, l)) nv = lists.length === 2 ? other.id : null;
      else nv = lists.length === 2 && pf.both != null ? pf.both : l;
      if (!nv || nv === v) return;
      p.pattern = p.pattern || {};
      var m = {}, x;
      for (x in o) m[x] = o[x];
      m[k] = nv;
      p.pattern[pf.id] = m;
      syncPerFace(); render(); changed();
      var nl = lists.filter(function (y) { return y.id === nv; })[0];
      announce("face " + (+b.getAttribute("data-i") + 1) + (nv === pf.both ? " on both lists" : " on the " + String((nl && nl.name) || nv).toLowerCase()));
    });
    /* (v3.46) their own colour: the custom colour card (colourCard(), the shirt's), opened on the colour now */
    root.addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest(".js-ideacustom") : null;
      if (!b || D.engine !== "idea") return;
      var e = eng(), op = e && e.design && (e.design.options || [])[0], p = P();
      if (!op) return;
      var cur = (p.pattern && p.pattern[op.id]) || op.def || op.values[0].id;
      var hex = /^#/.test(cur) ? cur : ((op.values.filter(function (x) { return x.id === cur; })[0]) || {}).hex || "";
      colourCard().then(function (CC) {
        CC.open({ value: hex, title: "custom colour", action: "use", opener: b,
          onPick: function (h) { var q = P(); q.pattern = q.pattern || {}; q.pattern[op.id] = h; syncIdeaCols(); render(); changed(); } });
      }, function () { showMsg(copy.openFail || "That didn’t open — try again.", 6000); });
    });

    /* ── the name (The Cheerful, v3.3): their name, shared with Our Favourite and the gift
       wrap page (TTWrapShared.name). The worker's rules show under the box only when what's
       typed can't be printed, with the plain version as the button's way out ── */
    function nameEng(d) { d = d || D; return isNamed(d) ? eng(d) : null; }
    function nameOk(d) { var e = nameEng(d); return !!(e && e.complete(st(d || D))); }
    function nameProblem() {
      var e = nameEng(), raw = String(SHARED.name || "");
      if (!e || !raw.trim()) return null;
      var r = e.read(raw);
      if (r.ok) return null;
      return { reason: r.reason, bad: r.bad || [], fix: r.plain && r.plain !== nameIn.value ? r.plain : null };
    }
    function readName() {
      if (!nameIn || !isNamed(D)) return;
      if (emojiWait) { if (nmsg) nmsg.textContent = ""; nameIn.removeAttribute("aria-invalid"); return; }   /* (v3.36) */
      var r = nameProblem(), w = pc();
      if (!r) { if (nmsg) nmsg.textContent = ""; nameIn.removeAttribute("aria-invalid"); return; }
      nameIn.setAttribute("aria-invalid", "true");
      var m = r.reason === "long" ? longMsg(w.long || "") : (w.chars || ""), bad = r.bad.join(" ");
      if (r.reason !== "long") m = m.indexOf("{letters}") > -1 ? m.replace("{letters}", bad) : m + (bad ? " " + bad : "");
      if (nmsg) nmsg.textContent = m;
    }
    /* (v3.63) "too long" with an idea design's own most characters in it (the setting's wording says 24) */
    function longMsg(s) {
      var e = D.engine === "idea" ? eng() : null, mx = e && e.design && e.design.nameMax;
      return mx ? String(s).replace(/\d+/, String(mx)) : s;
    }
    function syncName() {
      if (!nameIn) return;
      if (nameIn.value !== (SHARED.name || "") && document.activeElement !== nameIn) nameIn.value = SHARED.name || "";
      readName();
    }
    /* Our Favourite's phrase follows their name while it's still the one made from it */
    function followName() {
      designs.forEach(function (d) {
        if (d.engine !== "phrase") return;
        var p = P(d);
        if (p.own || (p.phrase && p.phrase !== p.auto)) return;
        p.phrase = p.auto = autoPhrase(d);
      });
    }
    if (nameIn) {
      nameIn.addEventListener("input", function () {
        if (!isNamed(D)) return;
        /* (v3.40, Ally: "when typing name, switch to close up view") */
        if (VIEWS[D.engine] && !atClose()) setView("close");
        SHARED.name = nameIn.value;
        emojiSoon(nameIn.value);
        followName();
        readName();
        syncNames();                                             /* (v3.63) the faces' boxes show it faint */
        render();
        changed();
        wordsCloseUp();
      });
    }

    /* ── (v3.63, Ally of Christmas Jumper Club: "would need name for each face in options") a name for each face: a design
       that takes one (the idea engine v1.18, takes.names) has a box for each of its faces, that face's head beside it; (v3.64)
       in place of their name's box, one face too, the first starting as their name, a blank one a plain jumper. Kept in the
       design's pattern (names: { face key: text }); the engine's rules under the boxes (its letters' own, and why a name
       won't print) ── */
    var fnBox = null, fnSeq = 0;
    (function () {
      var st0 = stepEl("name"), foot = st0 && st0.querySelector(".tt-ws__namefoot");
      if (!st0) return;
      fnBox = document.createElement("div");
      fnBox.className = "tt-ws__fnames js-fnames"; fnBox.hidden = true;
      if (foot && foot.nextSibling) st0.insertBefore(fnBox, foot.nextSibling); else st0.appendChild(fnBox);
    })();
    function takesNames(d) { d = d || D; var e = d.engine === "idea" ? eng(d) : null; return !!(e && e.design && e.design.takes && e.design.takes.names); }
    function faceNames(d) { var p = P(d || D).pattern; return p && p.names && typeof p.names === "object" ? p.names : {}; }
    /* (v3.64) what's in a face's box: what they typed there, else (the first face) their name, so it carries over */
    function boxName(d, f, i) { var v = faceNames(d)[f.key]; return typeof v === "string" ? v : i === 0 ? String(SHARED.name || "") : ""; }
    /* (v3.64, Ally: "maybe on this one it doesnt need a whos it for?") the step is the faces' boxes alone: their name's box
       and its line hidden, the step's heading "their name" / "their names" (its label the first box's) */
    function namesStep(st0, on, n, firstId) {
      if (!st0) return;
      st0.classList.toggle("is-pernames", on);
      var lab = st0.querySelector(".tt-ws__h2 label");
      if (!lab) return;
      if (lab.getAttribute("data-was") == null) lab.setAttribute("data-was", lab.textContent);
      var t = on ? (n > 1 ? "their names" : "their name") : lab.getAttribute("data-was"), fr = on && firstId ? firstId : nameIn ? nameIn.id : "";
      if (lab.textContent !== t) lab.textContent = t;
      if (fr && lab.htmlFor !== fr) lab.htmlFor = fr;
    }
    function syncNames(d) {
      d = d || D;
      if (d !== D || !fnBox) return;
      /* (v3.64) every face its box, one face too */
      var fs = takesNames(d) ? facesFor(d) : [], on = fs.length > 0, st0 = stepEl("name");
      if (fnBox.hidden === on) fnBox.hidden = !on;
      if (st0) st0.classList.toggle("has-fnames", on);
      if (!on) { namesStep(st0, false); return; }
      var e = eng(d), rule = (e && e.design && e.design.letters && e.design.letters.rule) || "", ver = d.id + ":" + fs.map(function (f) { return f.key; }).join(",");
      if (fnBox.getAttribute("data-for") !== ver) {
        fnBox.setAttribute("data-for", ver);
        fnBox.textContent = "";
        var list = document.createElement("div"), hid = st0 ? st0.querySelector(".tt-ws__h2") : null;
        list.className = "tt-ws__fnlist"; list.setAttribute("role", "group");
        if (hid && hid.id) list.setAttribute("aria-labelledby", hid.id);
        fnBox.appendChild(list);
        fs.forEach(function (f, i) {
          var id = (root.id || "tt-ws") + "-fn" + (++fnSeq), row = document.createElement("div"), pic = document.createElement("img"), el = document.createElement("input"), m = document.createElement("p");
          row.className = "tt-ws__fn";
          pic.className = "tt-ws__fnpic"; pic.alt = ""; pic.decoding = "async"; pic.draggable = false; pic.src = f.src;
          el.id = id; el.type = "text"; el.className = "tt-ws__phrase tt-ws__fnin js-fnin"; el.setAttribute("data-k", f.key); el.setAttribute("data-i", String(i));
          el.setAttribute("aria-label", "face " + (i + 1) + "'s name"); el.setAttribute("autocomplete", "off"); el.setAttribute("autocapitalize", "words");
          el.setAttribute("spellcheck", "false"); el.setAttribute("enterkeyhint", i < fs.length - 1 ? "next" : "done"); el.setAttribute("maxlength", "40");
          m.className = "tt-ws__pmsg tt-ws__fnmsg js-fnmsg"; m.id = id + "-m"; m.setAttribute("aria-live", "polite");
          el.setAttribute("aria-describedby", m.id);
          row.appendChild(pic); row.appendChild(el); list.appendChild(row); list.appendChild(m);
          el.addEventListener("focus", onTypingFocus);
          el.addEventListener("blur", onTypingBlur);
          el.addEventListener("keydown", function (ev) {
            if (ev.key !== "Enter") return;
            ev.preventDefault();
            var next = slice(fnBox.querySelectorAll(".js-fnin"))[i + 1];
            if (next) { next.focus(); return; }
            if (tabsMode()) { el.blur(); return; }
            if (goAct && stepOk(S.tab)) { go.focus({ preventScroll: true }); goAct(); }
          });
          el.addEventListener("input", function () {
            if (!takesNames()) return;
            if (VIEWS[D.engine] && !atClose()) setView("close");
            var p = P(), o = {}, nm = {}, k;
            for (k in p.pattern || {}) o[k] = p.pattern[k];
            for (k in faceNames()) nm[k] = faceNames()[k];
            nm[el.getAttribute("data-k")] = el.value;
            o.names = nm;
            p.pattern = o;
            /* (v3.64) the first face's name is their name: every wrap and the gift wrap page's bar have it */
            if (+el.getAttribute("data-i") === 0) { SHARED.name = el.value; emojiSoon(el.value); followName(); if (nameIn && document.activeElement !== nameIn) nameIn.value = el.value; }
            readNames();
            render();
            changed();
          });
        });
        if (rule) { var r = document.createElement("p"); r.className = "tt-ws__fnrule"; r.textContent = rule; fnBox.appendChild(r); }
      }
      var ins = slice(fnBox.querySelectorAll(".js-fnin"));
      namesStep(st0, true, fs.length, ins[0] && ins[0].id);
      ins.forEach(function (el, i) {
        var f = fs[i], want = f ? boxName(d, f, i) : "", ph = i === 0 ? "their name" : "their name, or leave it blank";
        if (el.getAttribute("data-i") !== String(i)) el.setAttribute("data-i", String(i));
        if (document.activeElement !== el && el.value !== want) el.value = want;
        if (el.placeholder !== ph) el.placeholder = ph;
      });
      readNames();
    }
    /* (v3.64) the first box whose name won't print, and why (for the button's way out) */
    function namesProblem() {
      var e = eng(), bad = null;
      if (!fnBox || fnBox.hidden || !e) return null;
      slice(fnBox.querySelectorAll(".js-fnin")).some(function (el) {
        var s = el.value.trim(), r = s ? e.read(s) : { ok: true };
        if (!r.ok) bad = { el: el, reason: r.reason, fix: r.plain || null };
        return !!bad;
      });
      return bad;
    }
    /* each box's name: why it won't print, if it won't (the name's own wording) */
    function readNames() {
      if (!fnBox || fnBox.hidden) return;
      var e = eng(), w = pc(), max = (e && e.design && e.design.nameMax) || 16;
      slice(fnBox.querySelectorAll(".js-fnin")).forEach(function (el) {
        var m = el.parentNode.nextSibling, s = el.value.trim(), r = !s || !e ? { ok: true } : e.read(s), txt = "";
        if (r.ok) el.removeAttribute("aria-invalid");
        else {
          el.setAttribute("aria-invalid", "true");
          if (r.reason === "long") txt = w.long ? longMsg(w.long) : "That's a bit long. " + max + " characters at most.";
          else {
            var bad = (r.bad || []).join(" "), c0 = w.chars || "{letters} won't print in this lettering.";
            txt = c0.indexOf("{letters}") > -1 ? c0.replace("{letters}", bad) : c0 + (bad ? " " + bad : "");
            if (r.plain) txt += " Try " + r.plain + ".";
          }
        }
        if (m && m.textContent !== txt) m.textContent = txt;
      });
    }

    /* ── (v3.58, Ally: "not just editable name but the 'merry christmas' too"; "change the words"; "read all the jokes, make
       your own") a design's own words (its texts: the idea engine's v1.13, the hat engine's v8 for Santa Rows and Santa on
       White): a box each, made from the design once it's in and filled with its words as they are, so they read and
       change them in place; blank puts the design's own back (its words show faint in the empty box). What they type is
       kept in the design's pattern by the text's id (kept a week with the rest); the engine's rules (its fonts' letters,
       its most characters) show under the box, as the name's do.
       (v3.61, Ally: "the words and name can be the same step") with their name: on the name step, under it, titled "the
       words"; without (Pudding Heads, Cracker Crowns' jokes): the "words" step of its own. A box is as tall as its words
       (one line unless they need two); a list's rows are spaced as the fitter's labelled controls; (Ally: "when clicking the
       next joke here, could the close up shift to show that joke?") a list's box in use glides the close-up to the nearest
       place its words are on the paper ── */
    var textsBox = q(".js-texts"), textsHead = q(".js-textsh"), txSeq = 0;
    function textList(d) { var e = eng(d || D); return (e && (e.texts || (e.design && e.design.texts))) || []; }
    function textsOk(d) {
      d = d || D;
      var e = eng(d), pat = P(d).pattern || {};
      return textList(d).every(function (t) { var s = String(pat[t.id] == null ? "" : pat[t.id]).trim(); return !s || !e || !e.readText || e.readText(t.id, s).ok; });
    }
    function textShown(t) { return String(t.def || "").replace(/\s+/g, " ").trim(); }
    /* a box as tall as its words (a joke's): one line unless it needs more */
    function fitBox(el) {
      if (el.tagName !== "TEXTAREA") return;
      el.style.height = "auto";
      el.style.height = el.scrollHeight + (el.offsetHeight - el.clientHeight) + "px";
    }
    /* (v3.61) where the boxes go: with their name on its step, else the words step */
    function textsHome(d) { return stepsFor(d).indexOf("texts") > -1 ? stepEl("texts") : stepEl("name"); }
    function syncTexts(d) {
      d = d || D;
      if (d !== D || !textsBox) return;
      var e = eng(d), T = textList(d), des = e && e.design, pat = P(d).pattern || {}, home = textsHome(d), title = (des && des.textsTitle) || (e && e.textsTitle) || "the words";
      if (home && textsBox.parentNode !== home && document.activeElement && !textsBox.contains(document.activeElement)) home.appendChild(textsBox);
      var inName = !!home && home.getAttribute("data-step") === "name";
      var ver = T.length ? d.id + ":" + T.map(function (t) { return t.id; }).join(",") + (inName ? ":n" : ":w") : "";
      if (textsHead) { if (textsHead.textContent !== title) textsHead.textContent = title; }
      if (textsBox.getAttribute("data-for") !== ver) {
        textsBox.setAttribute("data-for", ver);
        textsBox.textContent = "";
        textsBox.hidden = !T.length;
        textsBox.classList.toggle("is-list", T.length > 1);
        textsBox.classList.toggle("is-named", inName);
        if (inName && T.length) { var hd = document.createElement("p"); hd.className = "tt-ws__ctitle tt-ws__txh"; hd.id = (root.id || "tt-ws") + "-txh" + (++txSeq); hd.textContent = title; textsBox.appendChild(hd); }
        var headId = inName ? textsBox.firstChild && textsBox.firstChild.id : textsHead ? textsHead.parentNode.id : "";
        T.forEach(function (t) {
          var id = (root.id || "tt-ws") + "-tx" + (++txSeq), long = (t.max || 24) > 32, wrap = document.createElement("div"), el = document.createElement(long ? "textarea" : "input");
          wrap.className = "tt-ws__tx";
          if (T.length > 1) { var lab = document.createElement("label"); lab.className = "tt-ws__ctitle tt-ws__txl"; lab.setAttribute("for", id); lab.textContent = t.ask || t.label.toLowerCase(); wrap.appendChild(lab); }
          else if (headId) el.setAttribute("aria-labelledby", headId);
          el.id = id; el.className = "tt-ws__phrase tt-ws__txin js-txin" + (long ? " tt-ws__txin--long" : "");
          if (long) el.rows = 1; else el.type = "text";
          el.setAttribute("data-t", t.id); el.setAttribute("autocomplete", "off"); el.setAttribute("autocapitalize", "sentences");
          el.setAttribute("spellcheck", "false"); el.setAttribute("enterkeyhint", "done"); el.setAttribute("maxlength", String((t.max || 24) * 2 + 8));
          el.placeholder = textShown(t);
          var foot = document.createElement("p");
          foot.className = "tt-ws__pmsg tt-ws__txmsg js-txmsg"; foot.id = id + "-m"; foot.setAttribute("aria-live", "polite");
          el.setAttribute("aria-describedby", foot.id);
          wrap.appendChild(el); wrap.appendChild(foot); textsBox.appendChild(wrap);
          el.addEventListener("focus", function () { onTypingFocus(); if (T.length > 1) textCloseUp(t.id); });
          el.addEventListener("blur", onTypingBlur);
          el.addEventListener("keydown", function (ev) {
            if (ev.key !== "Enter") return;
            ev.preventDefault();
            if (tabsMode()) { el.blur(); return; }
            if (goAct && stepOk(S.tab)) { go.focus({ preventScroll: true }); goAct(); }
          });
          el.addEventListener("input", function () {
            if (!textList().some(function (x) { return x.id === t.id; })) return;
            if (VIEWS[D.engine] && !atClose()) setView("close");
            var p = P(), o = {}, k, v = el.value.replace(/\s*\n\s*/g, " ");
            if (v !== el.value) el.value = v;
            fitBox(el);
            for (k in p.pattern || {}) o[k] = p.pattern[k];
            o[t.id] = v;
            p.pattern = o;
            emojiSoon(v);
            readTexts();
            render();
            changed();
          });
        });
      }
      slice(textsBox.querySelectorAll(".js-txin")).forEach(function (el) {
        if (document.activeElement !== el) {
          var t = T.filter(function (x) { return x.id === el.getAttribute("data-t"); })[0], v = pat[el.getAttribute("data-t")];
          var want = typeof v === "string" ? v : t ? textShown(t) : "";
          if (el.value !== want) el.value = want;
        }
        fitBox(el);
      });
      readTexts();
    }
    /* (v3.61) a list's box in use: the close-up glides to the nearest place on the paper its words are (the engine's
       stickers say what each group of words is), at the close-up's own size; back to the view at rest when the boxes are
       left, as typing does. Reduced motion: straight there (zoomAt) */
    function textCloseUp(id) {
      var e = eng(), t = textList().filter(function (x) { return x.id === id; })[0];
      if (!e || !e.stickers || !t) return;
      var norm = function (s) { return String(s || "").replace(/\s+/g, " ").trim().toLowerCase(); };
      var v = norm((P().pattern || {})[id]), r0 = e.readText && v ? e.readText(id, v) : null, want = v && r0 && r0.ok ? v : norm(t.def);
      var W = cv.clientWidth, H = cv.clientHeight;
      if (!W || !H || !want) return;
      var r = sheetRect(W, H), k = r.bw / ROLL, hCm = r.bh / k, cur = zoomAt(clock()), cx = W / 2, cy = H / 2;
      var st = e.stickers(shown(), 0, 0, ROLL, hCm);
      if (!st || !st.words) return;
      var at = { x: ((cx - cur.ox) / cur.z - r.bx) / k, y: ((cy - cur.oy) / cur.z - r.by) / k }, best = null;
      st.words.forEach(function (w) {
        var g = norm(w.t);
        if (!g || (g !== want && g.indexOf(want.slice(0, 18)) < 0)) return;
        if (w.x < 2 || w.x > ROLL - 2) return;
        var dd = (w.x - at.x) * (w.x - at.x) + (w.y - at.y) * (w.y - at.y);
        if (!best || dd < best.d) best = { x: w.x, y: w.y, d: dd };
      });
      if (!best) return;
      var z = atClose() ? resolve(S.zoom.to).z : closeZ(D);
      z = Math.max(1.4, z);
      var px = r.bx + best.x * k, py = r.by + best.y * k, ox = cx - px * z, oy = cy - py * z;
      ox = Math.min(r.bx - r.bx * z, Math.max(r.bx + r.bw - (r.bx + r.bw) * z, ox));     /* (the sheet stays covered) */
      oy = Math.min(r.by - r.by * z, Math.max(r.by + r.bh - (r.by + r.bh) * z, oy));
      clearTimeout(lingerT);
      zoomTo({ z: z, ox: ox, oy: oy });
    }
    /* ── (v3.62, Ally of Under the Mistletoe: "we need to choose couples so couple 1, couple 2, can add more couples, only 1 as
       default then you pick whos in it like the naughty & nice and you can position them from there") a couples design
       (its block's idea in the section's couple_ideas; the design's couples: { max }): the "couples" step, a card a couple
       (couple 1 to start), each with their faces as chips: a tap puts a face in that couple (two at most: a third takes the
       second's place) or takes it out; "add a couple" (up to the design's max, while there are faces to pair), and a couple
       after the first can go. Kept in the design's pattern (couples: [[face key, face key], ...]). What's drawn and ordered
       is the couples' faces in turn (couple 1's two, couple 2's two, ...: the engine's faces, so the wrap takes the couples
       in turn), one face alone in a couple being both of it; the face fitter on step 1 positions each of them ── */
    var couplesBox = q(".js-couples"), COUPLES_MAX = 3;
    function isCouples(d) { return !!((d || D).kind.couples); }
    function couplesMax(d) { var e = eng(d || D), c = e && e.design && e.design.couples; return Math.max(1, Math.min(COUPLES_MAX, (c && c.max) || COUPLES_MAX)); }
    /* the couples as kept, their faces still in the mix, at least couple 1 (the first two faces) */
    function couplesOf(d) {
      d = d || D;
      var keys = facesFor(d).map(function (f) { return f.key; }), raw = P(d).pattern && P(d).pattern.couples, out = [];
      (Array.isArray(raw) ? raw : []).forEach(function (c) {
        if (!Array.isArray(c)) return;
        var a = keys.indexOf(c[0]) > -1 ? c[0] : null, b = keys.indexOf(c[1]) > -1 && c[1] !== a ? c[1] : null;
        out.push([a, b]);
      });
      if (!out.length) out.push([keys[0] || null, keys[1] || null]);
      return out.slice(0, couplesMax(d));
    }
    /* their faces in turn, two a couple (one alone is both; an empty couple is couple 1's) */
    function couplesFaces(d) {
      var base = facesFor(d), by = {}, list = [];
      if (!base.length) return base;
      base.forEach(function (f) { by[f.key] = f; });
      couplesOf(d).forEach(function (c) {
        var a = by[c[0]] || by[c[1]], b = by[c[1]] || a;
        if (!a) { a = list[0] || base[0]; b = list[1] || base[1] || a; }
        list.push(a, b);
      });
      return list;
    }
    function setCouples(cs) {
      var p = P(), o = {}, k;
      for (k in p.pattern || {}) o[k] = p.pattern[k];
      o.couples = cs.map(function (c) { return [c[0] || null, c[1] || null]; });
      p.pattern = o;
      syncCouples(); figWho(); figEdit(); render(); changed();
    }
    function syncCouples(d) {
      d = d || D;
      if (d !== D || !couplesBox) return;
      var on = isCouples(d);
      if (couplesBox.hidden === on) couplesBox.hidden = !on;
      if (!on) { if (couplesBox.firstChild) couplesBox.textContent = ""; couplesBox.removeAttribute("data-for"); return; }
      var base = facesFor(d), cs = couplesOf(d), ver = cs.length + ":" + base.map(function (f) { return f.key; }).join(",") + ":" + (cs.length < couplesMax(d));
      if (couplesBox.getAttribute("data-for") !== ver) {
        couplesBox.setAttribute("data-for", ver);
        couplesBox.textContent = "";
        cs.forEach(function (c, i) {
          var card = document.createElement("div"), h = document.createElement("div"), chips = document.createElement("div");
          card.className = "tt-ws__cpl"; card.setAttribute("role", "group"); card.setAttribute("aria-label", "couple " + (i + 1));
          h.className = "tt-ws__cplh";
          h.innerHTML = "<span>couple " + (i + 1) + "</span>" + (i ? '<button type="button" class="tt-ws__cplx js-cplx" data-i="' + i + '">remove</button>' : "");
          chips.className = "tt-ws__cplchips";
          base.forEach(function (f, j) {
            var b = document.createElement("button"), im = document.createElement("img");
            b.type = "button"; b.className = "tt-ws__usef js-cplf"; b.setAttribute("data-i", String(i)); b.setAttribute("data-k", f.key);
            b.setAttribute("aria-label", "face " + (j + 1) + " in couple " + (i + 1)); b.setAttribute("aria-pressed", "false");
            im.alt = ""; im.decoding = "async"; im.src = f.src;
            b.appendChild(im); chips.appendChild(b);
          });
          if (!base.length) chips.innerHTML = '<span class="tt-ws__cplnone">add their photos first</span>';
          card.appendChild(h); card.appendChild(chips); couplesBox.appendChild(card);
        });
        if (cs.length < couplesMax(d) && base.length) {
          var add = document.createElement("button");
          add.type = "button"; add.className = "tt-ws__tweak tt-ws__cpladd js-cpladd";
          add.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg><span>add a couple</span>';
          couplesBox.appendChild(add);
        }
      }
      slice(couplesBox.querySelectorAll(".js-cplf")).forEach(function (b) {
        var c = cs[+b.getAttribute("data-i")] || [], on2 = String(c.indexOf(b.getAttribute("data-k")) > -1);
        if (b.getAttribute("aria-pressed") !== on2) b.setAttribute("aria-pressed", on2);
      });
    }
    if (couplesBox) couplesBox.addEventListener("click", function (ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t || !isCouples()) return;
      var cs = couplesOf(), b;
      if ((b = t.closest(".js-cplf"))) {
        var i = +b.getAttribute("data-i"), k = b.getAttribute("data-k"), c = cs[i].slice(), at = c.indexOf(k);
        if (at > -1) c[at] = null;                                  /* out of this couple */
        else if (!c[0]) c[0] = k;
        else if (!c[1]) c[1] = k;
        else c[1] = k;                                              /* (two already: it takes the second's place) */
        if (!c[0] && c[1]) c = [c[1], null];
        cs[i] = c;
        setCouples(cs);
        announce((at > -1 ? "out of" : "in") + " couple " + (i + 1));
      } else if ((b = t.closest(".js-cpladd"))) {
        var used = [].concat.apply([], cs), keys = facesFor().map(function (f) { return f.key; });
        var free = keys.filter(function (x) { return used.indexOf(x) < 0; });
        cs.push([free[0] || keys[0] || null, free[1] || null]);
        setCouples(cs);
        announce("couple " + cs.length + " added");
      } else if ((b = t.closest(".js-cplx"))) {
        cs.splice(+b.getAttribute("data-i"), 1);
        setCouples(cs);
        announce("couple removed");
      }
    });

    function readTexts() {
      if (!textsBox) return;
      var e = eng(), w = pc();
      slice(textsBox.querySelectorAll(".js-txin")).forEach(function (el) {
        var m = el.parentNode.querySelector(".js-txmsg"), s = el.value.trim(), t = textList().filter(function (x) { return x.id === el.getAttribute("data-t"); })[0];
        var r = !s || emojiWait || !e || !e.readText ? { ok: true } : e.readText(el.getAttribute("data-t"), s), txt = "";
        if (r.ok) el.removeAttribute("aria-invalid");
        else {
          el.setAttribute("aria-invalid", "true");
          if (r.reason === "long") txt = (t && t.long) || "That's a bit long. " + ((t && t.max) || 24) + " characters at most, so it stays easy to read.";
          else { var bad = (r.bad || []).join(" "), c0 = w.chars || "{letters} won't print in this lettering."; txt = c0.indexOf("{letters}") > -1 ? c0.replace("{letters}", bad) : c0 + (bad ? " " + bad : ""); }
        }
        if (m && m.textContent !== txt) m.textContent = txt;
      });
    }

    /* ── (v3.26) the football shirt: their name (shared, as The Cheerful's), their number (the design's own, the age
       until they type one) and the kit (the design's "pattern": .js-kit buttons, data-k a kit key, data-v its value) ── */
    function shirtEng(d) { d = d || D; return d.engine === "shirt" ? eng(d) : null; }
    function shirtOk(d) { var e = shirtEng(d); return !!(e && e.complete(st(d || D))); }
    function shirtProblem() {
      var e = shirtEng(), raw = String(SHARED.name || "");
      if (!e || !raw.trim()) return null;
      var r = e.read(raw);
      return r.ok ? null : { reason: r.reason, bad: r.bad || [] };
    }
    function readShirt() {
      if (!snameIn || D.engine !== "shirt") return;
      if (emojiWait) { if (smsg) smsg.textContent = ""; snameIn.removeAttribute("aria-invalid"); return; }   /* (v3.37) */
      var r = shirtProblem(), w = pc();
      if (!r) { if (smsg) smsg.textContent = ""; snameIn.removeAttribute("aria-invalid"); return; }
      snameIn.setAttribute("aria-invalid", "true");
      var m = r.reason === "long" ? (w.long || "") : (w.chars || ""), bad = r.bad.join(" ");
      if (r.reason !== "long") m = m.indexOf("{letters}") > -1 ? m.replace("{letters}", bad) : m + (bad ? " " + bad : "");
      if (smsg) smsg.textContent = m;
    }
    function colourName(id) { var T = window.TTShirt, c = T && T.COLOURS.filter(function (x) { return x.id === id; })[0]; return c ? c.name.toLowerCase() : /^#/.test(id || "") ? "your own colour" : ""; }
    /* (v3.28) the kit: the pattern buttons, the parts to colour and one palette, made once from the shirt engine's own
       lists (the print's colours). The palette's last place is the part's automatic colour (data-v ""), for the parts
       that have one */
    var KIT_PARTS = [["body", "shirt"], ["second", "2nd"], ["sleeves", "sleeves"], ["trim", "collar"], ["ink", "name"], ["outline", "outline"]];
    /* (v3.39) the kit's controls: in the studio, or in the phone's kit pop-up while it's open */
    function kqa(sel) { var a = qa(sel); if (KF && KF.el) a = a.concat(slice(KF.el.querySelectorAll(sel))); return a; }
    function buildKit() {
      var T = window.TTShirt;
      if (!T) return;
      kqa(".js-kitpats").forEach(function (box) {
        if (box.children.length) return;
        box.innerHTML = T.PATTERNS.map(function (p) { return '<button type="button" class="tt-ws__seg js-kit" data-k="style" data-v="' + p.id + '" aria-pressed="false"><span>' + p.name.toLowerCase() + '</span></button>'; }).join("");
      });
      kqa(".js-kitparts").forEach(function (box) {
        if (box.children.length) return;
        box.innerHTML = KIT_PARTS.map(function (q) { return '<button type="button" class="tt-ws__seg js-kitpart" data-part="' + q[0] + '" aria-pressed="false"><span>' + q[1] + '</span></button>'; }).join("");
      });
      kqa(".js-kitpal").forEach(function (box) {
        if (box.children.length) return;
        box.innerHTML = T.COLOURS.map(function (c) { return '<button type="button" class="tt-ws__col js-kitcol" data-v="' + c.id + '" aria-label="' + c.name.toLowerCase() + '" aria-pressed="false" style="--sw: ' + c.hex + '; --tick: ' + tickOn(c.hex) + ';"></button>'; }).join("") +
          '<button type="button" class="tt-ws__col tt-ws__col--custom js-kitcustom" aria-label="your own colour" aria-haspopup="dialog"></button>' +
          '<button type="button" class="tt-ws__col tt-ws__col--auto js-kitcol" data-v="" aria-pressed="false"></button>';
      });
    }
    /* the part being coloured: the second colour only while there's a pattern to have one */
    function kitPart(p) { var q = P().kitPart || "body"; return q === "second" && p.style === "plain" ? "body" : q; }
    function syncKit() {
      var e = shirtEng(), p = P().pattern, T = window.TTShirt;
      if (!e || !p || !T) return;
      buildKit();
      var k = T.kit(e.kit(st())), part = kitPart(p);           /* k: as drawn, the automatic collar and name filled in */
      var hx = function (id) { return /^#/.test(id || "") ? id : (T.COLOURS.filter(function (x) { return x.id === id; })[0] || { hex: "#ffffff" }).hex; };
      var patName = (T.PATTERNS.filter(function (x) { return x.id === p.style; })[0] || { name: "" }).name.toLowerCase();
      kqa(".js-kit").forEach(function (b) { b.setAttribute("aria-pressed", p.style === b.getAttribute("data-v") ? "true" : "false"); });
      kqa(".js-kitpart").forEach(function (b) {
        var q = b.getAttribute("data-part"), off = q === "second" && p.style === "plain";
        b.setAttribute("aria-pressed", q === part ? "true" : "false");
        b.setAttribute("aria-disabled", off ? "true" : "false");
        if (q === "second") { var w = off ? "2nd" : patName, s = b.querySelector("span"); if (s.textContent !== w) s.textContent = w; }
      });
      /* the palette: the part's colour ringed; its automatic place shown only for a part that has one */
      var v = p[part] || "", auto = part === "sleeves" || part === "trim" || part === "ink" || part === "outline";
      kqa(".js-kitcol").forEach(function (b) {
        var bv = b.getAttribute("data-v");
        b.setAttribute("aria-pressed", bv === v ? "true" : "false");
        if (bv) return;
        b.style.visibility = auto ? "" : "hidden";
        b.tabIndex = auto ? 0 : -1;
        b.setAttribute("aria-label", part === "sleeves" ? (pc().sleevesAs || "as the shirt") : "auto");
        b.classList.toggle("is-none", part === "outline" && !k.outline);
        /* "as the shirt": the shirt's own colours, split as its pattern would put them on a sleeve; "auto": what it picks;
           (v3.29) the outline's "none": white, struck through */
        var bg = part === "sleeves" ? (p.style === "plain" ? hx(p.body) : "linear-gradient(135deg, " + hx(p.body) + " 50%, " + hx(p.second) + " 50%)") : part === "outline" && !k.outline ? "#fff" : hx(k[part]);
        if (b.style.getPropertyValue("--sw") !== bg) { b.style.setProperty("--sw", bg); b.style.setProperty("--tick", tickOn(bg)); }
      });
      /* (v3.29) their own colour: the "+" wears it while it's in use; the picker opens on what the part is now */
      var own = /^#/.test(v);
      kqa(".js-kitcustom").forEach(function (l) {
        l.classList.toggle("is-on", own);
        l.style.setProperty("--sw", own ? v : "#fff"); l.style.setProperty("--tick", tickOn(own ? v : ""));
        l.setAttribute("aria-pressed", own ? "true" : "false");
      });
      kqa(".js-kval").forEach(function (o) {
        var kk = o.getAttribute("data-k"), t = kk === "style" ? patName : own ? "your own colour"
          : !v ? (part === "sleeves" ? (pc().sleevesAs || "as the shirt") : "auto · " + (k[part] ? colourName(k[part]) : "none")) : colourName(v);
        if (o.textContent !== t) o.textContent = t;
      });
      kitPaint();
    }
    /* ── (v3.39, Ally, of the kit on a phone: "better layout on mobile, easier. If it needs a pop up instead, do that
       with no wrap preview just one shirt") on a phone "their kit" opens full screen, as "fit the hat": one shirt, big,
       and the kit's own controls (moved in while it's open, put back after). The button in the step wears their shirt ── */
    var KF = { el: q(".js-kfit"), open: false, t: 0 };
    var kitIn = q(".tt-ws__kitin"), kitHome = kitIn ? kitIn.parentNode : null;
    var kitOpenB = q(".js-kitopen"), kitMini = q(".js-kitmini"), kitSum = q(".js-kitsum");
    var kfCv = KF.el ? KF.el.querySelector(".js-kfitcv") : null, kfSlot = KF.el ? KF.el.querySelector(".js-kfitslot") : null;
    var kfDone = KF.el ? KF.el.querySelector(".js-kfitdone") : null;
    /* one shirt as it is now (MARLOWE 10 while there's no name or number, as the paper), filling a cssW x cssH canvas */
    function oneShirt(c, cssW, cssH) {
      var e = shirtEng(), T = window.TTShirt;
      if (!c || !e || !T || !P().pattern || cssW < 2 || cssH < 2) return;
      var dpr = Math.min(3, window.devicePixelRatio || 1), W = Math.round(cssW * dpr), H = Math.round(cssH * dpr);
      if (c.width !== W || c.height !== H) { c.width = W; c.height = H; }
      var o = e.kit(st()), x = c.getContext("2d");
      if (!T.cleanName(o.name).text && !o.number) { o.name = "MARLOWE"; o.number = "10"; }
      x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, W, H);
      T.shirt(x, o, W / 2, H / 2, Math.min(W, H * .96) * .92);       /* (a shirt is about as tall as it's wide) */
    }
    function kitPaint() {
      if (D.engine !== "shirt") return;
      var p = P().pattern || {}, T = window.TTShirt;
      if (kitMini) oneShirt(kitMini, 44, 44);
      if (kitSum && T) {
        var pat = (T.PATTERNS.filter(function (x) { return x.id === p.style; })[0] || { name: "" }).name.toLowerCase();
        var t = (/^#/.test(p.body || "") ? "your own colour" : colourName(p.body || "")) + (pat ? " · " + pat : "");
        if (kitSum.textContent !== t) kitSum.textContent = t;
      }
      if (KF && KF.open) kfDraw();                    /* (KF: set further down; a paint before then has no pop-up yet) */
    }
    function kfDraw() { if (kfCv && kfCv.parentNode) oneShirt(kfCv, kfCv.parentNode.clientWidth, kfCv.parentNode.clientHeight); }
    function openKit() {
      if (KF.open || !KF.el || !kitIn || !tabsMode()) return;
      KF.open = true; clearTimeout(KF.t);
      var cs = getComputedStyle(root);
      KF.el.style.setProperty("--bg", cs.getPropertyValue("--bg").trim() || "#f395b3");
      KF.el.style.setProperty("--ink", cs.getPropertyValue("--ink").trim() || "#333333");
      kfSlot.appendChild(kitIn);
      document.documentElement.classList.add("tt-ws-fitting");
      KF.el.hidden = false;
      KF.el.getBoundingClientRect();                  /* (so the fade-in runs) */
      KF.el.classList.add("is-in");
      kfDraw();
      try { history.pushState({ ttKit: 1 }, ""); } catch (er) {}
      setTimeout(function () { if (KF.open) kfDone.focus({ preventScroll: true }); }, 60);
      announce("their kit");
    }
    function closeKit(fromBack) {
      if (!KF.open) return;
      KF.open = false;
      KF.el.classList.remove("is-in");
      document.documentElement.classList.remove("tt-ws-fitting");
      KF.t = setTimeout(function () {
        if (KF.open) return;
        KF.el.hidden = true;
        if (kitHome && kitIn.parentNode !== kitHome) kitHome.appendChild(kitIn);   /* (back in the step, out of sight on a phone) */
      }, REDUCED ? 0 : 220);
      if (!fromBack) { try { if (history.state && history.state.ttKit) history.back(); } catch (er) {} }
      render();
      if (kitOpenB) { try { kitOpenB.focus({ preventScroll: true }); } catch (er) {} }
    }
    if (KF.el) {
      document.body.appendChild(KF.el);               /* (over the header and everything else) */
      kfDone.addEventListener("click", function () { closeKit(); });
      KF.el.addEventListener("keydown", function (e) {
        if (e.key === "Escape") { e.preventDefault(); closeKit(); return; }
        if (e.key !== "Tab") return;                  /* focus stays in it */
        var f = slice(KF.el.querySelectorAll("button, input")).filter(function (n) { return !n.disabled && n.offsetParent !== null && n.tabIndex > -1; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      });
      window.addEventListener("popstate", function () { if (KF.open) closeKit(true); });
      window.addEventListener("resize", function () { if (KF.open) { if (!tabsMode()) closeKit(); else kfDraw(); } });
    }
    if (kitOpenB) kitOpenB.addEventListener("click", openKit);
    function syncShirt() {
      if (D.engine !== "shirt") return;
      var p = P();
      /* the number starts as their age (a football shirt's number is often how old they are) */
      if (p.pattern && !p.numTouched && !p.pattern.number && SHARED.age) p.pattern.number = String(SHARED.age).replace(/\D/g, "").slice(0, 2);
      if (snameIn && snameIn.value !== (SHARED.name || "") && document.activeElement !== snameIn) snameIn.value = SHARED.name || "";
      if (snumIn && p.pattern && snumIn.value !== p.pattern.number && document.activeElement !== snumIn) snumIn.value = p.pattern.number;
      readShirt(); syncKit();
    }
    if (snameIn) snameIn.addEventListener("input", function () {
      if (D.engine !== "shirt") return;
      SHARED.name = snameIn.value;
      emojiSoon(snameIn.value);                                 /* (v3.37) */
      followName(); readShirt(); render(); changed(); wordsCloseUp();
    });
    if (snumIn) snumIn.addEventListener("input", function () {
      if (D.engine !== "shirt") return;
      var v = snumIn.value.replace(/\D/g, "").slice(0, 2);
      if (v !== snumIn.value) snumIn.value = v;
      P().numTouched = true;
      setPattern({ number: v });
      paint(); wordsCloseUp();
    });
    /* (built once the shirt's data is in, so listened for on the studio, and (v3.39) on the phone's kit pop-up, where
       the kit's controls are while it's open): the pattern, the part, a colour */
    function inKit(n) { return !!n && (root.contains(n) || (!!KF.el && KF.el.contains(n))); }
    function onKitClick(ev) {
      var t = ev.target && ev.target.closest ? ev.target : null;
      if (!t || D.engine !== "shirt") return;
      var b = t.closest(".js-kit"), q = t.closest(".js-kitpart"), c = t.closest(".js-kitcol"), ch = {};
      if (b && inKit(b)) { ch[b.getAttribute("data-k")] = b.getAttribute("data-v"); setPattern(ch); paint(); }
      else if (q && inKit(q) && q.getAttribute("aria-disabled") !== "true") { P().kitPart = q.getAttribute("data-part"); syncKit(); }
      else if (c && inKit(c)) { ch[kitPart(P().pattern)] = c.getAttribute("data-v"); setPattern(ch); paint(); }
    }
    root.addEventListener("click", onKitClick);
    if (KF.el) KF.el.addEventListener("click", onKitClick);
    /* (v3.31) their own colour: the custom colour card (the bunting's), opened on the part's colour now */
    var SHIRT_QUICK = ["#12857f", "#c99a2e", "#8cc63f", "#c2185b", "#b39ddb", "#5d4037", "#6e7378", "#f3e9d2"];
    var ccJob = null;
    function colourCard() {
      if (window.TTColourCard) return Promise.resolve(window.TTColourCard);
      if (!ccJob) {
        var cc = C.colourCard || {};
        if (cc.css && !document.querySelector('link[data-tt-cc]')) {
          var l = document.createElement("link"); l.rel = "stylesheet"; l.href = cc.css; l.setAttribute("data-tt-cc", "");
          document.head.appendChild(l);
        }
        ccJob = K.loadScript(cc.js).then(function () { return window.TTColourCard; }, function (e) { ccJob = null; throw e; });
      }
      return ccJob;
    }
    function onKitCustom(ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest(".js-kitcustom") : null;
      if (!b || !inKit(b) || D.engine !== "shirt") return;
      var T = window.TTShirt, part = kitPart(P().pattern), p = P().pattern, e = shirtEng();
      var v = p[part] || (T && e ? T.kit(e.kit(st()))[part] : "");
      var hexOf = function (id) { return /^#/.test(id || "") ? id : ((T && T.COLOURS.filter(function (x) { return x.id === id; })[0]) || {}).hex || ""; };
      colourCard().then(function (CC) {
        CC.open({ value: hexOf(v), title: "custom colour", action: "use", quick: SHIRT_QUICK, opener: b,
          onPick: function (hex) { var ch = {}; ch[kitPart(P().pattern)] = hex; setPattern(ch); paint(); } });
      }, function () { showMsg(copy.openFail || "That didn\u2019t open \u2014 try again.", 6000); });
    }
    root.addEventListener("click", onKitCustom);
    if (KF.el) KF.el.addEventListener("click", onKitCustom);

    /* ── sizes, from the product's variants ── */
    function shortSize(t) {
      if (/\bsquare\b/i.test(t)) return "square";            /* 61 x 61cm, the smallest since 2026-10-20 */
      var m = /\bA([0-9])\b/i.exec(t);
      if (m) return "A" + m[1];
      var len = K.lenCm(t);
      if (len && !/cm/i.test(t)) return (len / 100) + "m";
      if (len) return len + "cm";
      return t;
    }
    /* the option that holds the sizes: the one with the most lengths (a tie
       goes to the earlier), so "A2 Roll / Green" still reads as A2 */
    function sizeOption(Pr) {
      var best = 0, bestN = 0;
      (Pr.options || []).forEach(function (o, i) {
        var seen = {}, n = 0;
        Pr.variants.forEach(function (v) { var val = (v.options || [])[i]; if (val != null && !seen[val]) { seen[val] = 1; if (K.lenCm(val)) n++; } });
        if (n > bestN) { bestN = n; best = i; }
      });
      return best;
    }
    function sizeOf(Pr, v) { return (v.options || [])[sizeOption(Pr)] || v.title; }
    var sizeBtns = [];
    /* the sizes for the open design. Which is chosen: the size they picked
       (SHARED.size, by name: set only by tapping a size, or by a ?variant=
       link) if this design sells it; else this design's own last pick; else
       the first that's for sale. Says { want, to } when they'd picked a
       size this design doesn't sell, so the page can say so */
    function buildSizes() {
      var Pr = D.product, oi = sizeOption(Pr), ci = colourOption(Pr);
      sizesEl.textContent = ""; sizeBtns = [];
      var only = Pr.variants.length === 1 && /^default title$/i.test(Pr.variants[0].title);
      /* (v3.7) a design sold in colours (The Santa Hat): a link to a variant picks its colour; the
         sizes are the colour in use's variants, one button each */
      if (ci > -1 && !booted && C.selected != null) {
        var sv = Pr.variants.filter(function (v) { return String(v.id) === String(C.selected); })[0];
        if (sv) P().colour = (sv.options || [])[ci];
      }
      var colour = ci > -1 ? colourOf(D) : null;
      var list = ci > -1 ? Pr.variants.filter(function (v) { return (v.options || [])[ci] === colour; }) : Pr.variants;
      list.forEach(function (v) {
        var b = document.createElement("button");
        var label = (v.options || [])[oi] || v.title;
        b.type = "button"; b.className = "tt-ws__size";
        b.dataset.id = v.id;
        b.setAttribute("aria-pressed", "false");
        b.setAttribute("aria-label", v.title + ", " + v.price);
        b.disabled = !v.available;
        var a = document.createElement("span"); a.textContent = ci < 0 && Pr.variants.length > 1 && (Pr.options || []).length > 1 ? v.title : shortSize(label);
        var p = document.createElement("small"); p.textContent = v.price;
        b.appendChild(a); b.appendChild(p);
        b.addEventListener("click", function () {
          SHARED.size = sizeOf(Pr, v);
          P().sizeNote = false;
          if (msg.dataset.kind === "size") hideMsg();
          setVariant(v.id);
        });
        sizesEl.appendChild(b); sizeBtns.push(b);
      });
      sizesEl.classList.toggle("is-one", only);          /* keeps its room, so nothing moves */
      /* details: every size once, as 61 x length (as the worker reads it) */
      if (dsizes) {
        dsizes.textContent = "";
        var seen = {};
        Pr.variants.forEach(function (v) {
          var val = (v.options || [])[oi] || v.title, len = K.lenCm(val);
          if (seen[val] || !len) return;
          seen[val] = 1;
          var row = document.createElement("div"); row.className = "tt-ws__drow"; row.dataset.val = val;
          var dt = document.createElement("dt"); dt.textContent = val;
          var dd = document.createElement("dd"); dd.textContent = ROLL + " × " + len + "cm";
          row.appendChild(dt); row.appendChild(dd); dsizes.appendChild(row);
        });
        dsizes.hidden = !dsizes.children.length;
      }
      var avail = list.filter(function (v) { return v.available; }), mine = P().variant, want = SHARED.size, pickV = null;
      /* a link to a size (?variant=), on the design the page opened on */
      if (!booted && C.selected != null) {
        pickV = avail.filter(function (v) { return String(v.id) === String(C.selected); })[0];
        if (pickV) want = SHARED.size = sizeOf(Pr, pickV);
      }
      if (!pickV && want != null) pickV = avail.filter(function (v) { return sizeOf(Pr, v) === want; })[0];
      var missed = !pickV && want != null;
      if (!pickV && mine != null) pickV = avail.filter(function (v) { return String(v.id) === String(mine); })[0];
      if (!pickV) pickV = avail[0];
      setVariant(pickV ? pickV.id : null, true);
      return missed && pickV ? { want: want, to: sizeOf(Pr, pickV) } : null;
    }
    function variant() { return D.product.variants.filter(function (v) { return v.id === S.variant; })[0] || null; }
    function setVariant(id, quiet) {
      S.variant = id;
      P().variant = id;
      sizeBtns.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.id) === String(id) ? "true" : "false"); });
      var v = variant(), oi = sizeOption(D.product);
      var val = v ? ((v.options || [])[oi] || v.title) : "", len = K.lenCm(val);
      if (sizeLine) sizeLine.textContent = v ? (v.title + (len ? " · " + ROLL + " × " + len + "cm" : "")) : "";
      if (dsizes) slice(dsizes.children).forEach(function (r) { r.classList.toggle("is-on", r.dataset.val === val); });
      idIn.value = id || "";
      if (!quiet) paint();
    }
    if (det) {
      document.addEventListener("click", function (e) { if (det.open && !det.contains(e.target)) det.open = false; });
      det.addEventListener("keydown", function (e) {
        if (e.key === "Escape" && det.open) { det.open = false; det.querySelector("summary").focus(); }
      });
    }

    /* ── saving the design: (v3.53) once at the size step, and on add if it's changed since ── */
    var saveT = 0;
    /* (v3.6: for any design, not only the open one: the all-wraps moment adds others) */
    function sigOf(d) { var e = eng(d || D); return e ? e.sig(st(d || D)) : ""; }
    function sigNow() { return sigOf(D); }
    function orderable(d) {
      d = d || D;
      var e = eng(d);
      if (!e) return false;
      if (d.kind.faces) {
        var fs = facesFor(d);
        if (!fs.length || fs.some(function (f) { return f.test; })) return false;
      }
      return !!e.complete(st(d));
    }
    function designReady(d) { d = d || D; var p = P(d); return orderable(d) && p.saved.sig === sigOf(d) && !!p.saved.props; }
    function changed() {
      clearTimeout(saveT);
      var p = P();
      p.saving = null; p.fails = 0; p.offerRetry = false;
      if (msg.dataset.kind === "save") hideMsg();
      paint();
    }
    /* (v3.53) nothing saves a second after a change any more (every face, nudge, colour and letter used to upload a
       whole set): a design is saved when the size step is reached (atSize), and on add if it's changed since */
    function resume() { clearTimeout(saveT); }
    /* (v3.53) the size step reached, the design opened on it, or it became complete there: saved once, just after the
       step's slide (an add before then saves it itself); leaving the step and coming back saves again */
    var sizeVisit = null;
    function atSize() {
      var last = ORDER[ORDER.length - 1];
      if (!last || S.tab !== last) { sizeVisit = null; return; }
      if (!sizeVisit || sizeVisit.d !== D) sizeVisit = { d: D, done: false };
      if (sizeVisit.done || !orderable()) return;
      sizeVisit.done = true;
      var d = D;
      clearTimeout(saveT);
      saveT = setTimeout(function () { if (D === d && S.tab === last) save(); }, 400);
    }
    /* save(d): d (else the open design) baked and uploaded; a promise: true once saved, false
       if it was overtaken, rejected if it failed (v3.6: any design, for the all-wraps moment) */
    function save(dd) {
      var d = dd || D;
      if (!orderable(d)) return Promise.resolve(false);
      var p = P(d), e = eng(d), mine = sigOf(d), token = { sig: mine };
      if (p.saved.sig === mine && p.saved.props) return Promise.resolve(true);
      if (p.saving && p.saving.sig === mine && p.saving.job) return p.saving.job;     /* already on its way */
      if (d === D) clearTimeout(saveT);
      p.saving = token; p.offerRetry = false; if (d === D) paint();
      var still = function () { return eng(d) === e && e.sig(st(d)) === mine; };
      /* overtaken (they changed it, or its face changed while another design
         was open): this save lets go, unless a newer one already holds it,
         and the design carries on (now, or when it's next shown) */
      var letGo = function () {
        if (p.saving !== token) return;
        p.saving = null;
        if (d === D) { resume(); paint(); }
      };
      token.job = e.bake(st(d)).then(function (b) {
        if (!still()) { letGo(); return false; }
        var keys = Object.keys(b.uploads);
        return Promise.all(keys.map(function (k) { return K.upload(b.uploads[k].canvas, b.uploads[k].name, { lossy: K.lossyFor ? K.lossyFor(k) : "" }); })).then(function (urls) {
          if (!still()) { letGo(); return false; }
          var props = [];
          b.order.forEach(function (name) {
            var i = keys.indexOf(name), v = i > -1 ? urls[i] : b.props[name];
            if (v != null && v !== "") props.push([name, String(v)]);
          });
          p.saved = { sig: mine, props: props };
          if (p.saving === token) p.saving = null;
          p.fails = 0; p.offerRetry = false;
          warmToast(props, b.thumbs);
          if (d === D) {
            if (msg.dataset.kind === "save") hideMsg();
            paint();
            announce("design saved");
          }
          return true;
        });
      }).catch(function (er) { failed(d, mine, token); throw er || new Error("save"); });
      token.job.catch(function () {});
      return token.job;
    }
    /* from the first failure the button offers "try saving again", while it
       also tries again by itself (3s, then 6s); after three, it says why. A
       design that's been left tries again when it's shown again. A save
       that's been overtaken just lets go. */
    function failed(d, mine, token) {
      var p = P(d), e = eng(d);
      if (p.saving !== token) return;
      p.saving = null;
      if (!e || e.sig(st(d)) !== mine) { if (d === D) { resume(); paint(); } return; }
      p.fails++; p.offerRetry = true;
      if (d !== D) return;
      clearTimeout(saveT);
      if (p.fails <= 2) saveT = setTimeout(function () { if (D === d && sigNow() === mine) save(); }, p.fails * 3000);
      else showMsg(copy.saveFail, 0, "save");
      paint();
    }
    function saveNow() { P().fails = 0; if (msg.dataset.kind === "save") hideMsg(); save(); }
    function warmToast(props, thumbs) {
      props.forEach(function (pr) {
        if (pr[0] !== "_Preview" || pr[1].indexOf("/image/upload/") < 0) return;
        var t = toastThumb(thumbs && thumbs[pr[0]]);
        if (t !== TOAST_THUMB) (window.TTWrapThumbs || (window.TTWrapThumbs = {}))[pr[1]] = t;
        var im = new Image();
        im.decoding = "async";
        im.src = pr[1].replace("/image/upload/", "/image/upload/" + t + "/");
      });
    }

    /* ── the one ink button: always the next move ── */
    function price() { var v = variant(); return v ? v.price : ""; }
    function orderDone() { return !!variant(); }
    function nextLabel() { return String(copy.next || "next").replace(/\s*:\s*$/, ""); }
    /* what a step still needs: the button's words and what it does (or null: answered) */
    function need(name) {
      if (name === "faces") return stepOk("faces") ? null : { label: copy.addPhoto, act: pick };     /* (v3.61: a figure design's name is on step 2 now) */
      if (name === "age") return stepOk("age") ? null : { label: copy.addAge, act: function () { focusIn(ageIn); } };
      if (name === "words") {
        var w = pc(), toBox = function () { focusIn(phraseIn); }, r = phraseProblem();
        /* typed, but it can't be printed: the way out */
        if (r && r.fix) return { label: w.fix, act: function () { setPhrase(r.fix, false); } };
        if (r && r.reason === "long") return { label: w.shorter, act: toBox };
        if (r) return { label: w.letters, act: toBox };
        if (phraseOk()) return null;
        /* still loading the design, with words typed */
        if (P().engState !== "ok" && String(P().phrase).trim()) return { label: copy.loading || "", wait: true };
        return { label: P().own ? "type your words" : w.add, act: toBox };
      }
      /* (v3.64) a name for each face: the first box that won't print, else at least one name */
      if (name === "name" && takesNames() && fnBox && !fnBox.hidden) {
        var fw = pc(), fp = namesProblem(), first = fnBox.querySelector(".js-fnin");
        if (fp && fp.fix) return { label: fw.fix || "swap to plain letters", act: function () { fp.el.value = fp.fix; fp.el.dispatchEvent(new Event("input", { bubbles: true })); } };
        if (fp && fp.reason === "long") return { label: fw.shorter || "make it shorter", act: function () { focusIn(fp.el); } };
        if (fp) return { label: fw.letters || "change the letters", act: function () { focusIn(fp.el); } };
        if (nameOk()) return null;
        if (P().engState !== "ok") return { label: copy.loading || "", wait: true };
        return { label: fw.add || "type their name", act: function () { focusIn(first); } };
      }
      if (name === "name") {
        var nw = pc(), toName = function () { focusIn(nameIn); }, nr = nameProblem();
        if (nr && nr.fix) return { label: nw.fix || "swap to plain letters", act: function () { nameIn.value = nr.fix; nameIn.dispatchEvent(new Event("input", { bubbles: true })); } };
        if (nr && nr.reason === "long") return { label: nw.shorter || "make it shorter", act: toName };
        if (nr) return { label: nw.letters || "change the letters", act: toName };
        if (nameOk()) return null;
        if (P().engState !== "ok" && String(SHARED.name || "").trim()) return { label: copy.loading || "", wait: true };
        return { label: nw.add || "type their name", act: toName };
      }
      if (name === "shirt") {
        var sw = pc(), toSName = function () { focusIn(snameIn); }, sr = shirtProblem();
        if (sr && sr.reason !== "long" && emojiWait) return { label: copy.loading || "", wait: true };   /* (v3.37: their emoji still coming) */
        if (sr && sr.reason === "long") return { label: sw.shorter || "make it shorter", act: toSName };
        if (sr) return { label: sw.letters || "change the letters", act: toSName };
        if (shirtOk()) return null;
        if (P().engState !== "ok" && String(SHARED.name || "").trim()) return { label: copy.loading || "", wait: true };
        return { label: sw.add || "add their name", act: toSName };
      }
      if (name === "size") return variant() ? null : { label: copy.pickSize, act: function () { var b = sizeBtns.filter(function (x) { return !x.disabled; })[0]; focusIn(b); } };
      return null;
    }
    function next() {
      var p = P();
      /* this design's own add to basket (another design's is the popup's to tell) */
      if (p.adding) return { label: copy.adding, wait: true };
      if (p.added) return { label: String(copy.added || "added").replace(/\s*[✓✔]\s*$/, ""), wait: true, added: true };
      if (S.busy && D.kind.faces) return { label: copy.cutting || busyLines[0] || "", wait: true };
      if (p.engState === "failed") return { label: copy.engineRetry || "try again", act: retryEngine };
      /* a side trip (the hats, the pattern): done takes them back */
      if (isAside(S.tab)) return { label: "done", act: backward };
      var n = need(S.tab);
      if (n) return n;
      if (S.tab !== ORDER[ORDER.length - 1]) return { label: nextLabel(), act: forward };   /* (v3.39: the size step is the last) */
      /* the last step: anything before it still to answer comes first */
      for (var i = 0; i < ORDER.length - 1; i++) {
        var m = need(ORDER[i]);
        if (m) { var to = ORDER[i]; return m.wait ? m : { label: m.label, act: function () { goStep(to); } }; }
      }
      if (D.kind.faces && facesFor().some(function (f) { return f.test; })) return { label: copy.test, off: true };
      if (!orderable()) return { label: copy.loading || "", wait: true };          /* the engine's still on its way */
      if (p.pending || (p.saving && p.fails)) return { label: copy.saving, wait: true };   /* (v3.53) their add saving first, or a save tried again */
      if (p.offerRetry && !p.saving) return { label: copy.retry, act: saveNow };
      return { label: (copy.add || "add to basket ·") + " " + price(), act: add, add: true };   /* (v3.53: saved or not: add saves) */
    }
    var goAct = null, goWait = false, goAdded = false;
    var TICK = '<svg class="tt-ws__gotick" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
    function setGo(n) {
      var label = n.label || "";
      if (goLabel.dataset.text !== label || goWait !== !!n.wait || goAdded !== !!n.added) {
        goLabel.dataset.text = label;
        goLabel.textContent = label;
        if (n.added) goLabel.insertAdjacentHTML("beforeend", TICK);
        else if (n.wait && !n.off) {
          var dots = document.createElement("span");
          dots.className = "tt-ws__dots"; dots.setAttribute("aria-hidden", "true");
          dots.innerHTML = "<i></i><i></i><i></i>";
          goLabel.appendChild(dots);
        }
        goLabel.classList.remove("is-new"); void goLabel.offsetWidth; goLabel.classList.add("is-new");
      }
      goWait = !!n.wait; goAdded = !!n.added;
      /* aria-disabled, not disabled: a focused button that's disabled drops focus */
      var off = !!(n.wait || n.off);
      go.disabled = false;
      if (off) go.setAttribute("aria-disabled", "true"); else go.removeAttribute("aria-disabled");
      goAct = off ? null : n.act;
      go.classList.toggle("is-add", !!n.add);
      go.classList.toggle("is-added", !!n.added);
    }
    go.addEventListener("click", function () { if (goAct) goAct(); });

    /* the basket's add (Shopify's answer, or why not) */
    function cartPost(body, quiet) {
      return fetch(C.cartAdd, { method: "POST", body: body, headers: { Accept: "application/json" }, ttQuiet: quiet })
        .then(function (r) {
          if (!r.ok) {
            return r.json().catch(function () { return {}; }).then(function (j) {
              var e = new Error(j.description || j.message || ""); e.shop = true; throw e;   /* Shopify said no, and why */
            });
          }
          return r.json();
        });
    }
    /* ── adding to the basket ── */
    /* every properties[...] field the form owns goes (its own and any form=
       field); then the open design's own, and only if each is one of that
       design's fields */
    function writeForm() {
      var allowed = D.kind.fields, props = P().saved.props || [];
      if (!props.length || props.some(function (p) { return allowed.indexOf(p[0]) < 0; })) return false;
      slice(form.elements).concat(slice(form.querySelectorAll("input"))).forEach(function (el) {
        if (el.name && el.name.indexOf("properties[") === 0 && el.parentNode) el.parentNode.removeChild(el);
      });
      props.forEach(function (p) {
        var el = document.createElement("input");
        el.type = "hidden"; el.name = "properties[" + p[0] + "]"; el.value = p[1];
        form.appendChild(el);
      });
      idIn.value = S.variant;
      return true;
    }
    /* "adding…" and "added" are the added design's own: if they open another
       design meanwhile, its button carries on as it was (the basket popup says
       it's in), and a refusal waits for this design */
    /* ── (v3.5) the shipping tube (Ally's design, assets/tt-wrap-tube.js): on add, their
       wrap rolls up off the paper, goes into a kraft tube with the TP sticker, white caps
       and tan tape seal it, and it flies to the basket; then (v3.51) back to the wraps,
       with the basket popup. The paper hides (opacity only) while its copy rolls, and
       comes back as the tube leaves. Never with reduced motion, in a close-up or a hidden
       tab: then just the popup. The page stays usable throughout; a second add waits only
       for its own design's (p.adding) ── */
    var tubeJob = null, packing = 0;
    function loadTube() {
      if (window.TTWrapTube || tubeJob || !C.tube || REDUCED) return;
      tubeJob = K.loadScript(C.tube).then(function () {
        /* (v3.6) the sticker's lettering, decoded ahead */
        if (window.TTWrapTube && window.TTWrapTube.prepare) window.TTWrapTube.prepare({ sticker: C.tubeSticker });
      }).catch(function () { tubeJob = null; });
    }
    idle(loadTube, { timeout: 6000 });
    var markTpl = q(".js-tubemark");
    function startTube() {
      if (REDUCED || !window.TTWrapTube || packing || document.visibilityState !== "visible" || !sheetEl || !cv.clientWidth || zoomedIn()) return null;
      /* (v3.13) close up: the whole sheet is what rolls up (drawn once for the tube to copy, then
         the close-up again, out of sight while the paper's hidden) */
      var keep = atClose() ? S.zoom : null;
      if (keep) { S.zoom = { from: NO_ZOOM, to: NO_ZOOM, t0: 0 }; drawNow(); }
      var mark = markTpl && markTpl.content ? markTpl.content.querySelector("svg") : null, t = null;
      try { t = window.TTWrapTube.start({ canvas: cv, sheet: sheetEl, mark: mark }); } catch (e) { t = null; }
      if (keep) { S.zoom = { from: NO_ZOOM, to: keep.to, t0: 0 }; if (t) slideEl.style.opacity = "0"; drawNow(); }
      if (!t) return null;
      packing++;
      slideEl.style.opacity = "0";                  /* the tube's copy of it rolls up in its place */
      paper.classList.add("is-packed");               /* (v3.13: the view switch steps aside with it) */
      t.packed.then(function () { packing = Math.max(0, packing - 1); });
      return t;
    }
    /* the paper back, fading up as the tube leaves */
    function unpack() {
      paper.classList.remove("is-packed");
      if (slideEl.style.opacity !== "0") return;
      slideEl.style.opacity = "";
      if (!REDUCED && slideEl.animate) {
        try { slideEl.animate({ opacity: [0, 1], scale: [".97", "1"] }, { duration: 300, easing: "cubic-bezier(.2, .8, .3, 1)" }); } catch (e) {}
      }
    }
    /* (v3.51) after an add, back to the wraps, with the basket popup: the page that opened the studio does both
       (tt:ws-added, cancelled: its grid where they were); on a wrap's own page the gift wrap page shows the popup as
       it arrives (sessionStorage ttWsAdded, read by assets/tt-wrap-collection.js). False: they stay (the theme
       editor), and the popup shows here */
    var visits = 0, ADDED_BEAT = 600;               /* (no tube: "added ✓" this long first) */
    function homeAdded(item) {
      var ev = null;
      try { ev = new CustomEvent("tt:ws-added", { bubbles: true, cancelable: true, detail: { item: item || null } }); } catch (e) {}
      if (ev && !root.dispatchEvent(ev)) return true;
      if (C.designMode || !C.homeUrl) return false;
      try { sessionStorage.setItem("ttWsAdded", JSON.stringify({ t: Date.now(), item: item || null })); } catch (e) {}
      if (!backToOpener()) location.assign(homeUrl());       /* (v3.56: the page that had opened it, where it was) */
      return true;
    }
    function add() {
      var d = D, p = P(d), visit = visits;
      if (p.adding || p.pending || !variant()) return;
      if (D.product.pretend) { showMsg("These are pretend sizes (testing): they can't go in the basket."); return; }
      /* (v3.53) not saved as it stands (changed since the size step, or that save still on its way): "saving…" (pending)
         till it's up, then the add; a failed save offers "try saving again" as ever */
      if (!designReady()) {
        if (!orderable()) return;
        p.pending = true; hideMsg(); paint();
        save(d).then(function (ok) {
          p.pending = false;
          if (D !== d) return;
          /* (only if they're still here: not if they left the studio and came back meanwhile) */
          if (ok && visit === visits && root.isConnected && designReady() && variant()) add(); else paint();
        }, function () { p.pending = false; if (D === d) paint(); });
        return;
      }
      if (!writeForm()) { showMsg(copy.cartFail); return; }
      p.adding = true; p.added = false; clearTimeout(p.addedT); hideMsg(); paint();
      /* every add is quiet (sections/tt-cart-toast v2.0: ttQuiet still updates the count): the popup
         shows once the tube has flown, on the wraps they're back on */
      var toast = window.TTCartToast && window.TTCartToast.show ? window.TTCartToast : null;
      var tube = startTube();
      cartPost(new FormData(form), !!toast)
        .then(function (item) {
          p.adding = false; p.inBasket = true;
          p.added = true;
          p.addedT = setTimeout(function () { p.added = false; if (D === d) paint(); }, 2000);
          if (D === d) { paint(); announce("added to your basket"); }
          /* once it's packed: the paper back and the tube away; once it's landed, back to the wraps (unless
             they've left meanwhile, or opened another design: then just the popup, where they are) */
          (tube ? tube.packed : Promise.resolve()).then(function () {
            unpack();
            var flown = tube ? tube.fly() : new Promise(function (res) { setTimeout(res, ADDED_BEAT); });
            var after = function () {
              if (!packing) unpack();                 /* (never left hidden; unless another add's tube is rolling it now) */
              if (visit === visits && D === d && root.isConnected && homeAdded(item)) return;
              if (toast) toast.show({ item: item || null });
            };
            flown.then(after, after);
          });
        })
        .catch(function (e) {
          p.adding = false;
          if (tube) tube.cancel();
          unpack();
          var t = e && e.shop ? (copy.cartFail || "") + (e.message ? " " + e.message : "") : copy.cartOffline;   /* the line dropped: never "Failed to fetch" */
          if (D !== d) { p.addMsg = t; return; }
          paint();
          showMsg(t);
        });
    }
    /* the form only ever goes through add(); Enter in the date box mustn't
       post it (window, so this runs before the basket popup's own catcher) */
    window.addEventListener("submit", function (e) {
      if (e.target !== form) return;
      e.preventDefault(); e.stopImmediatePropagation();
    }, true);

    /* ── messages and the state of things ── */
    var msgT = 0;
    function showMsg(t, ms, kind) {
      if (!t) return;
      msg.textContent = t; msg.hidden = false; msg.dataset.kind = kind || "";
      clearTimeout(msgT);
      if (ms !== 0) msgT = setTimeout(hideMsg, ms || 7000);
    }
    /* a preview that didn't load stays said until it does */
    function hideMsg() {
      clearTimeout(msgT);
      if (P().engState === "failed") { msg.textContent = copy.engineFail; msg.hidden = false; msg.dataset.kind = "engine"; return; }
      msg.hidden = true; msg.dataset.kind = "";
    }
    function announce(t) { if (t) sr.textContent = t; }
    var lastReady = null;
    function paint() {
      atSize();                                                  /* (v3.53) */
      setGo(next());
      syncTrail();                                    /* (v3.51) a step answered (or not) opens the ones after it */
      var hasFaces = facesFor().length > 0;
      paper.classList.toggle("is-empty", !!D.kind.faces && !hasFaces && !S.busy);
      busyEl.hidden = !(S.busy && D.kind.faces);
      var r = designReady(), now = D.key + (r ? "|1" : "|0");
      if (now !== lastReady) {
        lastReady = now;
        try { document.dispatchEvent(new CustomEvent("tt:wrapstudio", { detail: { design: D.product.handle || D.key, ready: r } })); } catch (e) {}
      }
    }

    /* ── layout ── */
    var lastW = window.innerWidth;
    /* the studio's top (under the header): on the studio, and on the page's
       root for the basket popup, which sits there on phones */
    function measureTop() {
      var top = Math.max(0, Math.round(root.getBoundingClientRect().top + (window.scrollY || 0))) + "px";
      root.style.setProperty("--tt-ws-top", top);
      html.style.setProperty("--tt-ws-top", top);
    }
    window.addEventListener("resize", function () {
      if (!root.isConnected) return;
      if (window.innerWidth !== lastW) {
        lastW = window.innerWidth; measureTop();
        if (!typing()) baseVV = vvH();                  /* turned round: a new full height */
      }
      render();
    });
    if (wideMq && wideMq.addEventListener) wideMq.addEventListener("change", function () {
      if (!tabsMode()) { typedFrom = null; setRoomy(false); zoomTo(REST); }
      else zoomTo(REST);                              /* (v3.16) a phone's view at rest can differ */
      if (typeof syncView === "function") syncView();
      paint();
    });
    window.addEventListener("load", function () { measureTop(); });

    /* ── for a page that opens the studio in place (the gift wrap page,
       sections/tt-wrap-collection): the shared state, open(key) to switch
       design, sync() each time it's shown again, leave() before it's
       taken off the page ── */
    /* the phrase made from their name; one that can't be printed as typed
       (Lily-Mae) is the version the engine offers (Lily Mae), once it can read it */
    function autoPhrase(d) {
      var v = makePhrase(SHARED.name);
      if (v.length > 60) return "";
      var e = v && eng(d || D);
      if (e && e.read) {
        var r = e.read(v);
        if (!r.ok && r.plain && e.read(r.plain).ok) v = r.plain;
      }
      return v;
    }
    var api = {
      shared: SHARED,
      designs: designs.map(function (d) { return d.key; }),
      current: function () { return D.key; },
      /* the design on show can be drawn in full: its engine and artwork */
      ready: function () { var e = eng(D); return !!(e && e.ready()); },
      /* the paper drawn now, not next frame (for a page about to picture it) */
      draw: function () { if (root.isConnected) drawNow(); return true; },
      open: function (key, o) {
        var d = byKey(key), rep = !!(o && o.replace);
        /* fresh: chosen on the page, so it opens on its own first step (faces, words), as if
           visited, and without the pop-in (the page drew it already) */
        if (d && o && o.fresh) P(d).intro = true;
        if (d && d !== D && o && o.fresh) S.tab = null;
        if (d) switchTo(d, { push: !rep, replace: rep, animate: !(o && o.instant) });
        return !!d;
      },
      sync: function () {
        if (!root.isConnected) return false;
        /* faces the page added (each gets its tile, after the ones there; v3.14: a saved
           face's where it stands), and the one in use */
        SHARED.faces.forEach(function (f) { if (!f.key) f.key = f.c || f.src; addTile(f, false); });
        if (keepEl) keepEl.checked = SHARED.keep !== false;
        renderSaved();
        /* a face chosen on the page that a design's own mix doesn't have: that mix starts afresh with it. (v3.44) Any face
           chosen on the page since the studio last showed is the one face again, as a new face here is; the first time
           it shows, a mix kept from an earlier visit stays only if it starts with the face in use (a mix made here
           always does: its first face is the one last added) */
        var fk = SHARED.face ? SHARED.face.key : "", first = seenFaceKey === null, moved = !first && fk !== seenFaceKey;
        designs.forEach(function (d) {
          var p = P(d);
          if ((isMix(d) || d.kind.multi) && p.picked && SHARED.face && (moved || p.picked.indexOf(fk) < 0 || (first && p.picked[0] !== fk))) p.picked = null;
        });
        seenFaceKey = fk;
        /* (v3.12) a group photo the page found: every face ticked, as here */
        if (SHARED.group && SHARED.group.n !== seenGroup) { seenGroup = SHARED.group.n; pickGroup(SHARED.group.keys.filter(faceByKey)); }
        syncTiles();
        if (ageIn && ageIn.value !== (SHARED.age || "")) ageIn.value = SHARED.age || "";
        /* Our Favourite's phrase follows their name while it's still the one made from it */
        designs.forEach(function (d) {
          if (d.engine !== "phrase") return;
          var p = P(d);
          if (p.own || (p.phrase && p.phrase !== p.auto)) return;
          p.phrase = p.auto = autoPhrase(d);
        });
        syncWords();
        if (D.engine === "cheerful") syncName();
        if (D.engine === "shirt") syncShirt();
        colourNow = "";                                 /* the page put its own colour and title back */
        look(D);
        measureTop();
        render(); resume(); paint();
        return true;
      },
      leave: function () {
        visits++;                                     /* (v3.51) an add still flying won't take them back to the wraps again */
        var a = document.activeElement;
        if (a && a !== document.body && root.contains(a) && a.blur) a.blur();
        clearTimeout(zoomT); clearTimeout(vvT); clearTimeout(lingerT); zoomT = 0;
        cancelAnimationFrame(glideRaf);
        typedFrom = null; kbSeen = false;
        setRoomy(false);
        S.zoom = { from: NO_ZOOM, to: REST, t0: 0 }; closeClass();
        if (det) det.open = false;
        if (FIT.open) closeFit(true);                 /* (v3.19) */
        html.classList.remove("tt-ws-paint");
        return true;
      }
    };
    root.ttWrapStudio = api;
    window.TTWrapStudio = api;

    /* ── testing hooks, only with ?ttdev in the address ── */
    if (DEV) window.ttWrapStudioDev = {
      face: function (url, real) {
        url = url || C.devFace;
        return K.loadImage(url, true).then(function (img) { addFace({ img: img, src: url, c: real ? url : "", o: "", test: !real }); });
      },
      skip: function (ms) { S.clock += (ms == null ? 60000 : ms); frame(performance.now()); return true; },
      draw: function () { frame(performance.now()); return true; },
      keyboard: function (px) { S.kb = px || 0; onViewport(); return S.kb; },
      /* show other size names, e.g. the real product's while it's archived:
         sizes([["A2 Roll", "£4.99"], ...]). For looking only: never addable */
      sizes: function (list) {
        D.product = { id: D.product.id, handle: D.product.handle, title: D.product.title, url: D.product.url, borrowed: D.product.borrowed,
                      fromPrice: list[0][1], options: ["Size"], pretend: true,
                      variants: list.map(function (t, i) { return { id: -1 - i, title: t[0], options: [t[0]], price: t[1], available: true }; }) };
        buildSizes(); paint(); return D.product.variants.length;
      },
      zoom: function (on) { S.zoom = { from: NO_ZOOM, to: on ? closeUp() : REST, t0: 0 }; closeClass(); frame(performance.now()); return resolve(S.zoom.to); },
      /* (v3.13) the view at rest: view("close" | "whole") as the switch sets it; view() says it */
      view: function (v) { if (v) setView(v); return { view: viewOf(D), choice: S.view, zoom: resolve(S.zoom.to), at: zoomAt(clock()), sw: viewEl ? !viewEl.hidden : false }; },
      design: function (key, instant) { return api.open(key, { instant: !!instant }); },
      pattern: function (ch) { setPattern(ch || {}, ch && ch.seed != null ? "ripple" : ""); return P().pattern; },
      /* a step of the open design (or a side trip), as if they'd gone there */
      tab: function (name) { goStep(name); return S.tab; },
      name: function (t) { if (!nameIn || !isNamed(D)) return false; nameIn.value = t; nameIn.dispatchEvent(new Event("input", { bubbles: true })); return SHARED.name; },
      phrase: function (t) { if (!phraseIn) return false; phraseIn.value = t; phraseIn.dispatchEvent(new Event("input", { bubbles: true })); return P().phrase; },
      /* (v3.51) "‹ back" and the step bar, as a tap (back(); trail(n), n from 1); trail() says what the bar shows */
      back: function () { stepBack(); return S.tab; },
      trail: function (n) {
        var lis = trailEl ? slice(trailEl.children) : [];
        if (n) { var b = lis[n - 1] && lis[n - 1].firstElementChild; if (b) b.click(); }
        return lis.map(function (li) { return li.getAttribute("data-step") + (li.classList.contains("is-on") ? "*" : "") + (li.classList.contains("is-done") ? "+" : "") + (li.classList.contains("is-wait") ? "-" : ""); }).join(" ");
      },
      state: function () {
        var p = P();
        return { design: D.key, engineName: D.engine, engine: !!eng(D), engineState: p.engState, tab: S.tab, ret: S.ret, tabs: ORDER.slice(), tabsMode: tabsMode(),
                 faces: SHARED.faces.length, face: SHARED.face ? { c: SHARED.face.c, o: SHARED.face.o, test: SHARED.face.test } : null,
                 hat: p.hat, place: p.place, hatBox: HV.geo || null, age: SHARED.age, phrase: p.phrase, phraseOk: phraseOk(), name: SHARED.name, nameOk: nameOk(),
                 pattern: p.pattern, mix: facesFor().map(function (f) { return f.key; }), seen: p.seen,
                 variant: S.variant, saving: !!p.saving, fails: p.fails, offerRetry: p.offerRetry,
                 adding: p.adding, added: p.added, sizeNote: p.sizeNote, size: SHARED.size,
                 saved: p.saved, ready: designReady(), button: goLabel.dataset.text, anim: !!S.anim,
                 zoom: resolve(S.zoom.to), view: viewOf(D), typedFrom: typedFrom, kbSeen: kbSeen, baseVV: baseVV, roomy: roomy, strip: paperStrip(),
                 sheet: true, box: BOX,
                 inBasket: designs.filter(function (d) { return P(d).inBasket; }).map(function (d) { return d.key; }), borrowed: !!D.product.borrowed, vt: !!vtNow,
                 per: designs.map(function (d) { var x = P(d); return { key: d.key, engine: x.engState, hat: x.hat, phrase: x.phrase, variant: x.variant, saved: !!x.saved.props, sig: x.saved.sig, saving: !!x.saving, adding: x.adding, added: x.added }; }) };
      }
    };
    /* (v3.49) the face fitter: fit({ x, y, s, r }, who) sets face who's fit (null puts it back); fit() says the fits, the
       face being fitted and where its head's box is in the fitter on show; fitOpen(on) the full screen */
    if (DEV) {
      /* (v3.58) fit(f, who, part): f may carry its pieces' moves (p: { key: { x, y, s, r } }); part picks what's moved */
      window.ttWrapStudioDev.fit = function (f, who, part) {
        if (who != null) figPick(who);
        if (part != null) { figCommit(); FG.part = part; figParts(); figEdit(); }
        if (f !== undefined) { var g = figFace(); if (!g) return false; FG.live = f ? { x: +f.x || 0, y: +f.y || 0, s: f.s == null ? 1 : +f.s, r: +f.r || 0, p: f.p || undefined } : { x: 0, y: 0, s: 1, r: 0 }; FG.liveKey = g.key; figCommit(); }
        return { on: figOn(), who: FG.who, part: figPart(), parts: figPartsList(), fits: P().fits || null, geo: FG.geo || null, open: FG.open, named: !!(fsoon && fsoon.classList.contains("is-named")), nameIn: !!(nameIn && fnameSlot && fnameSlot.contains(nameIn)) };
      };
      /* (v3.58) words(id, t): one of the design's own words, as typed in its box */
      window.ttWrapStudioDev.words = function (id, t) {
        var el = textsBox && slice(textsBox.querySelectorAll(".js-txin")).filter(function (x) { return x.getAttribute("data-t") === id; })[0];
        if (!el) return false; el.value = t; el.dispatchEvent(new Event("input", { bubbles: true })); return (P().pattern || {})[id];
      };
      window.ttWrapStudioDev.fitOpen = function (on) { if (on) figOpen(null); else figClose(); return FG.open; };
      /* (v3.63) faceName(i, t): face i's own name (from 0), as typed in its box */
      window.ttWrapStudioDev.faceName = function (i, t) {
        var el = fnBox && slice(fnBox.querySelectorAll(".js-fnin"))[i];
        if (!el) return false; el.value = t; el.dispatchEvent(new Event("input", { bubbles: true })); return faceNames();
      };
    }

    /* ── go ── */
    /* (v3.34) on its own page, the design they were on opens on the step they were on */
    var keptTab = kept && !asked && kept.open === D.key && typeof kept.tab === "string" ? kept.tab : null;
    showDesign(D, keptTab ? { tab: keptTab } : undefined);
    booted = true;
    /* (v3.36) words with emoji, kept from before or handed over: their shapes */
    emojiSoon([SHARED.name || ""].concat(designs.map(function (d) { return P(d).phrase || ""; })).join("\n"));
    /* (v3.34) their faces from before, once loaded: a tile each, the design redrawn; past the faces with none back, back */
    if (SHARED.restoring && !SHARED.restored) SHARED.restoring.then(function (fs) {
      if (!root.isConnected) return;
      if (fs.length) {
        if (SHARED.group && SHARED.group.kept) seenGroup = SHARED.group.n;   /* (their own picks stand) */
        api.sync();
      }
      var fi = ORDER.indexOf("faces");
      if (fi > -1 && ORDER.indexOf(S.tab) > fi && !stepOk("faces")) goStep(landing(D, S.tab));
    }, function () {});
    if (KEEP) KEEP.onLeave(function () {
      var was = KEEP.get("wrap") || {}, per = was.per && typeof was.per === "object" ? was.per : {}, f = {};
      designs.forEach(function (d) {
        var p = P(d);
        per[d.key] = { hat: p.hat, hats: p.hats, place: p.place, phrase: p.phrase, auto: p.auto, own: p.own, pattern: p.pattern,
                       picked: p.picked, colour: p.colour, variant: p.variant, fsize: p.fsize };
        if (d.kind.fit) per[d.key].fits = p.fits || null;      /* (v3.49) */
      });
      f.per = per;
      if (root.isConnected) {                         /* (on the page now: where they are in it) */
        var t = isAside(S.tab) ? S.ret : S.tab;
        f.open = D.key; f.tab = t || null;
      }
      KEEP.wrapSave(f);
    });
    try { history.replaceState(Object.assign({}, history.state, { ttws: D.key }), ""); } catch (e) {}
    paint();
    render();
  }
})();
